import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import {
  Page,
  Card,
  Text as PolarisText,
  Button,
  ButtonGroup,
  LegacyStack,
  TextField,
  Tag,
  Modal,
  Icon,
  ColorPicker,
  Popover,
  ActionList,
  Spinner,
  DatePicker,
  Checkbox,
  Thumbnail,
  Box,
  Toast, // Added Toast for error messages
} from "@shopify/polaris";
import moment from "moment-timezone";
import { debounce } from "lodash";
import {
  TextBoldIcon,
  TextItalicIcon,
  TextUnderlineIcon,
  MagicIcon,
  TextColorIcon,
  TextAlignLeftIcon,
  TextAlignCenterIcon,
  TextAlignRightIcon,
  LinkIcon,
  ChevronUpIcon,
  ChevronDownIcon,
  PlusIcon,
  DuplicateIcon,
  DeleteIcon,
  ImagesIcon,
  TextTitleIcon,
  TextBlockIcon,
  TextQuoteIcon,
  DataTableIcon,
  ListBulletedIcon,
  ImageIcon,
  UploadIcon,
  MenuVerticalIcon,
  ImageMagicIcon,
  ProductIcon,
  LayoutColumns3Icon,
  SearchIcon,
  EditIcon,
  DragHandleIcon,
  PaginationEndIcon,
  PaginationStartIcon,
  ImageWithTextOverlayIcon,
  LockIcon,
  PlayCircleIcon,
} from "@shopify/polaris-icons";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Node } from "@tiptap/core";
import { ResizableImage } from "../extensions/ResizableImage";
import { Plugin } from "prosemirror-state";
// import {ResizableImage} from 'tiptap-extension-resize-image';
// import ImageResize from "tiptap-extension-resize-image";
// import { ResizableImage } from 'tiptap-extension-resizable-image';
// import "tiptap-extension-resizable-image/styles.css";
import { v4 as uuid } from "uuid";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useEditor, EditorContent } from "@tiptap/react";
import Link from "@tiptap/extension-link";
import Image from "@tiptap/extension-image";
import Table from "@tiptap/extension-table";
import TableRow from "@tiptap/extension-table-row";
import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";
import TaskItem from "@tiptap/extension-task-item";
import CodeBlockLowlight from "@tiptap/extension-code-block-lowlight";
import Highlight from "@tiptap/extension-highlight";
import TextAlign from "@tiptap/extension-text-align";
import Underline from "@tiptap/extension-underline";
import TextStyle from "@tiptap/extension-text-style";
import Color from "@tiptap/extension-color";
import { createLowlight, common } from "lowlight";
import StarterKit from "@tiptap/starter-kit";
import DOMPurify from "dompurify";
import axios from "axios";
import "./styles.css";
import ArticleModal from "../Modals/ArticleModal";
import { DOMParser as ProseMirrorDOMParser } from "prosemirror-model";
import { Extension } from "@tiptap/core";
import { HardBreak } from "@tiptap/extension-hard-break";
import { SaveBar } from "@shopify/app-bridge-react";
import { useAppBridge } from "@shopify/app-bridge-react";
import SaveModal from "../Modals/SaveModal";
import CloseModal from "../Modals/CloseModal";
// EditorToolbar Component (Unchanged)
const shopifyAppUrl = process.env.REACT_APP_SHOPIFY_APP_URL;
const EditorToolbar = ({
  editor,
  index,
  onAiAction,
  shopOrigin,
  onImageClick,
  setIsAiLoading,
  articleLanguage,
  subscriptionPlan,
  blogsCount,
}) => {
  const colorPickerRef = useRef(null);
  const colorPickerRef1 = useRef(null);
  const lastSelectionRef = useRef(null);
  const [isLinkModalOpen, setIsLinkModalOpen] = useState(false);
  const [linkUrl, setLinkUrl] = useState("");
  const [isColorPickerOpen, setIsColorPickerOpen] = useState(false);
  const [isColorPickerOpen1, setIsColorPickerOpen1] = useState(false);
  const [selectedColor, setSelectedColor] = useState(null);
  const [isCustomColorModalOpen, setIsCustomColorModalOpen] = useState(false);
  const [isCustomColorModalOpen1, setIsCustomColorModalOpen1] = useState(false);
  const [aiPopoverActive, setAiPopoverActive] = useState(false);

  const [blockType, setBlockType] = useState("paragraph");

  const shouldDisableRewrite = () => {
    if (!editor) return false;

    const { state } = editor;
    const { selection } = state;
    const { $from } = selection;

    // Check if we're inside restricted block types
    let hasRestrictedBlocks = false;

    // Check the entire document for restricted block types
    state.doc.descendants((node) => {
      if (
        node.type.name === "productBlock" ||
        node.type.name === "productGridBlock" ||
        node.type.name === "imageWithTextBlock"
      ) {
        hasRestrictedBlocks = true;
        return false; // Stop traversing once we find a restricted block
      }
    });

    // NEW: Check if cursor is currently inside a table
    let isInTable = false;
    for (let depth = $from.depth; depth >= 0; depth--) {
      const node = $from.node(depth);
      if (
        node.type.name === "table" ||
        node.type.name === "tableRow" ||
        node.type.name === "tableCell" ||
        node.type.name === "tableHeader"
      ) {
        isInTable = true;
        break;
      }
    }

    return hasRestrictedBlocks || isInTable;
  };

  // Add useEffect to update blockType when editor state changes
  useEffect(() => {
    if (!editor) return;

    const updateBlockType = () => {
      const { $from } = editor.state.selection;
      const parentNode = $from.parent;
      let newBlockType = "paragraph";

      if (parentNode.type.name === "heading") {
        newBlockType = "1";
      } else if (parentNode.type.name === "blockquote") {
        newBlockType = "blockquote";
      } else if (
        parentNode.type.name === "listItem" &&
        editor.isActive("bulletList")
      ) {
        newBlockType = "bulletList";
      }

      setBlockType(newBlockType);
    };

    editor.on("selectionUpdate", updateBlockType);
    editor.on("update", updateBlockType);

    return () => {
      editor.off("selectionUpdate", updateBlockType);
      editor.off("update", updateBlockType);
    };
  }, [editor]);

  const toggleAiPopover = () => setAiPopoverActive((prev) => !prev);
  const [customColor, setCustomColor] = useState({
    hue: 120,
    brightness: 1,
    saturation: 1,
  });

  const rememberSelection = () => {
    lastSelectionRef.current = editor.state.selection;
  };

  const restoreSelection = () => {
    const sel = lastSelectionRef.current;
    // console.log(sel);
    if (sel) {
      editor.chain().focus().setTextSelection({ from: sel.from, to: sel.to });
    } else {
      editor.chain().focus();
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        colorPickerRef.current &&
        !colorPickerRef.current.contains(event.target)
      ) {
        setIsColorPickerOpen(false);
      }
    };

    if (isColorPickerOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isColorPickerOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        colorPickerRef1.current &&
        !colorPickerRef1.current.contains(event.target)
      ) {
        setIsColorPickerOpen1(false);
      }
    };

    if (isColorPickerOpen1) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isColorPickerOpen1]);

  if (!editor) return null;

  const execCommand = (cb) => {
    const { state, view } = editor;
    const selection = state.selection; // store selection
    cb(); // run the formatting command
    view.dispatch(view.state.tr.setSelection(selection)); // restore selection
    view.focus(); // focus editor again
  };

  const setLink = () => {
    if (!editor || !editor.can().setLink({ href: "" })) return;
    setIsLinkModalOpen(true);
    setLinkUrl("");
  };

  const handleApplyLink = () => {
    if (linkUrl.trim() === "") {
      editor.chain().focus().unsetLink().run();
    } else {
      const validUrl =
        linkUrl.trim().startsWith("http://") ||
        linkUrl.trim().startsWith("https://")
          ? linkUrl.trim()
          : `https://${linkUrl.trim()}`;
      editor.chain().focus().setLink({ href: validUrl }).run();
    }
    setIsLinkModalOpen(false);
  };

  const handleHighlightColor = (color) => {
    if (color) {
      restoreSelection();
      editor.chain().toggleHighlight({ color }).run();
    }
    setIsColorPickerOpen(false);
  };
  const handleTextColor = (color) => {
    if (color) {
      restoreSelection();
      editor.chain().setColor(color).run();
    }
    setIsColorPickerOpen1(false);
  };

  const customStyles = `
    .dropdown-select:focus {
      border: none;
    }
    .dropdown-select:hover {
      //  background-color: lightgray;
    }
    .color-picker {
      position: absolute;
      background: white;
      border: 1px solid #ccc;
      border-radius: 8px;
      padding: 5px;
      display: flex;
      gap: 5px;
      z-index: 1000;
    }
    .color-option {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      cursor: pointer;
      border: 2px solid #fff;
    }
    .color-option:hover {
      border-color: #000;
    }
    .add-color {
      width: 20px;
      height: 20px;
      background: transparent;
      border: 1px dashed #ccc;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #666;
    }
    .image-options {
      width: 100%;
      height:120px;
      border: 1px dashed #ccc;
      padding: 10px;
      margin: 10px 0;
      background-color: #f9f9f9;
      border-radius: 4px;
      display: flex;
      gap: 10px;
      align-items: center;
    }
  `;

  function hsbToHex({ hue, saturation, brightness }) {
    const chroma = brightness * saturation;
    const x = chroma * (1 - Math.abs(((hue / 60) % 2) - 1));
    const m = brightness - chroma;
    let r = 0,
      g = 0,
      b = 0;

    if (hue < 60) [r, g, b] = [chroma, x, 0];
    else if (hue < 120) [r, g, b] = [x, chroma, 0];
    else if (hue < 180) [r, g, b] = [0, chroma, x];
    else if (hue < 240) [r, g, b] = [0, x, chroma];
    else if (hue < 300) [r, g, b] = [x, 0, chroma];
    else [r, g, b] = [chroma, 0, x];

    r = Math.round((r + m) * 120);
    g = Math.round((g + m) * 120);
    b = Math.round((b + m) * 120);

    return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
  }

  const handleAiAction = async (type) => {
    if (!editor) return;

    setIsAiLoading(true); // Start loading

    try {
      const fullHTML = editor.getHTML();
      let textToRewrite = fullHTML;
      let isImageWithTextBlock = false;

      // Parse HTML to manipulate it
      const parser = new DOMParser();
      const dom = parser.parseFromString(fullHTML, "text/html");

      // **NEW: Function to extract and preserve images**
      const extractAndPreserveImages = (doc) => {
        const images = [];
        const imgElements = doc.querySelectorAll("img");

        imgElements.forEach((img, index) => {
          // Store original image data
          images.push({
            outerHTML: img.outerHTML,
            placeholder: `__IMAGE_PLACEHOLDER_${index}__`,
          });

          // Replace image with placeholder text
          const placeholder = doc.createTextNode(
            `__IMAGE_PLACEHOLDER_${index}__`
          );
          img.parentNode.replaceChild(placeholder, img);
        });

        return images;
      };

      // **NEW: Function to restore images from placeholders**
      const restoreImages = (content, imageMap) => {
        let restoredContent = content;
        imageMap.forEach((imgData) => {
          restoredContent = restoredContent.replace(
            imgData.placeholder,
            imgData.outerHTML
          );
        });
        return restoredContent;
      };

      // Function to strip color-related attributes, <mark>, <u>, and redundant <span> tags
      const stripUnwantedStylesAndTags = (doc) => {
        // Remove <mark> tags but keep their content
        const markElements = doc.querySelectorAll("mark");
        markElements.forEach((mark) => {
          const parent = mark.parentNode;
          while (mark.firstChild) {
            parent.insertBefore(mark.firstChild, mark);
          }
          parent.removeChild(mark);
        });

        // Remove <u> tags but keep their content
        const underlineElements = doc.querySelectorAll("u");
        underlineElements.forEach((u) => {
          const parent = u.parentNode;
          while (u.firstChild) {
            parent.insertBefore(u.firstChild, u);
          }
          parent.removeChild(u);
        });

        // Remove style attributes containing color or background-color
        const elementsWithStyle = doc.querySelectorAll("[style]");
        elementsWithStyle.forEach((el) => {
          const style = el.getAttribute("style");
          if (
            style &&
            (style.includes("color") || style.includes("background-color"))
          ) {
            const newStyle = style
              .split(";")
              .filter(
                (prop) =>
                  !prop.includes("color") && !prop.includes("background-color")
              )
              .join(";");
            if (newStyle.trim()) {
              el.setAttribute("style", newStyle);
            } else {
              el.removeAttribute("style");
            }
          }
        });

        // Remove data-color attributes
        const elementsWithDataColor = doc.querySelectorAll("[data-color]");
        elementsWithDataColor.forEach((el) => {
          el.removeAttribute("data-color");
        });

        // Remove redundant <span> tags (those with no attributes or only empty style)
        const spanElements = doc.querySelectorAll("span");
        spanElements.forEach((span) => {
          if (
            !span.hasAttributes() ||
            (span.getAttribute("style") === "" &&
              Object.keys(span.attributes).length === 1)
          ) {
            const parent = span.parentNode;
            while (span.firstChild) {
              parent.insertBefore(span.firstChild, span);
            }
            parent.removeChild(span);
          }
        });
      };

      let preservedImages = [];

      // Check if top-level node is ImageWithTextBlock
      const topNode = editor.state.doc.firstChild;
      if (topNode && topNode.type.name === "imageWithTextBlock") {
        isImageWithTextBlock = true;
        const textContentDiv = dom.querySelector(".text-content");
        if (textContentDiv) {
          // **MODIFIED: Extract images before processing**
          preservedImages = extractAndPreserveImages(textContentDiv);
          stripUnwantedStylesAndTags(dom);
          textToRewrite = textContentDiv.innerHTML;
        } else {
          throw new Error("Could not extract text content for rewriting");
        }
      } else {
        // **MODIFIED: Extract images before processing for non-ImageWithTextBlock**
        preservedImages = extractAndPreserveImages(dom);
        stripUnwantedStylesAndTags(dom);
        textToRewrite = dom.body.innerHTML;
      }

      if (!textToRewrite) {
        throw new Error("No content to rewrite");
      }

      const response = await axios.post(
        `/api/rewrite-content/${shopOrigin}/`,
        {
          content: textToRewrite,
          action: type,
          language: articleLanguage,
          tone: type === "tone" ? "scientific" : undefined,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": document.querySelector("[name=csrfmiddlewaretoken]")
              ?.value,
          },
          withCredentials: true,
        }
      );

      if (response.data.status === "success" && response.data.content) {
        let newContent = DOMPurify.sanitize(response.data.content, {
          FORBID_ATTR: ["style", "data-color"], // Prevent style and data-color attributes
          FORBID_TAGS: ["mark", "u"], // Prevent <mark> and <u> tags
          ADD_TAGS: ["p", "strong", "em", "a"], // Allow desired tags
          ADD_ATTR: ["href", "target", "rel"], // Allow link attributes
        });

        // **MODIFIED: Restore images after sanitization**
        newContent = restoreImages(newContent, preservedImages);

        // Parse the sanitized content to remove redundant <span> tags
        const responseDom = parser.parseFromString(newContent, "text/html");
        const spanElements = responseDom.querySelectorAll("span");
        spanElements.forEach((span) => {
          if (
            !span.hasAttributes() ||
            (span.getAttribute("style") === "" &&
              Object.keys(span.attributes).length === 1)
          ) {
            const parent = span.parentNode;
            while (span.firstChild) {
              parent.insertBefore(span.firstChild, span);
            }
            parent.removeChild(span);
          }
        });
        newContent = responseDom.body.innerHTML;

        if (isImageWithTextBlock) {
          // Reconstruct full HTML with new inner content
          const textContentDiv = dom.querySelector(".text-content");
          if (textContentDiv) {
            textContentDiv.innerHTML = newContent;
            newContent = dom.body.innerHTML;
          } else {
            throw new Error("Could not reconstruct content");
          }
        }

        editor.commands.setContent(newContent);
      } else {
        console.error("AI Rewrite failed:", response.data.message);
      }
    } catch (error) {
      console.error("AI Rewrite error:", error);
    } finally {
      setIsAiLoading(false); // Stop loading
    }
  };

  const applyBlockTypeSafe = (type) => {
    const { state } = editor;
    const { selection } = state;
    const { $from } = selection;

    let isInImageWithTextBlock = false;
    for (let depth = $from.depth; depth >= 0; depth--) {
      const node = $from.node(depth);
      if (node.type.name === "imageWithTextBlock") {
        isInImageWithTextBlock = true;
        break;
      }
    }

    let chain = editor.chain().focus();
    chain = chain.command(({ tr }) => {
      tr.setMeta("allowImageWithTextRemoval", true);
      return true;
    });

    if (type === "paragraph") {
      chain = chain.setParagraph();
    } else if (type === "heading") {
      if (editor.isActive("heading")) {
        chain = chain.setParagraph();
      } else {
        if (editor.isActive("bulletList")) {
          chain = chain.liftListItem("listItem");
        }
        chain = chain.toggleHeading({ level: 1 });
      }
    } else if (type === "blockquote") {
      chain = chain.toggleBlockquote();
    } else if (type === "bulletList") {
      if (editor.isActive("heading")) {
        chain = chain.setParagraph();
      }
      chain = chain.toggleBulletList();
    }

    chain.run();
  };
  const isRewriteDisabled = shouldDisableRewrite();

  return (
    <>
      <style>{customStyles}</style>
      <div
        className="editor-toolbar"
        style={{
          marginBottom: "10px",
          display: "flex",
          gap: "5px",
          flexWrap: "wrap",
          borderRadius: "4px",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          border: "1px solid #d9d9d9",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
            padding: "3px",
            flexWrap: "wrap",
            justifyContent: "space-evenly",
          }}
        >
          <select
            className="dropdown-select"
            value={blockType} // Use state variable
            onChange={(e) => {
              const value = e.target.value;
              if (value === "paragraph") {
                applyBlockTypeSafe("paragraph");
              } else if (value === "1") {
                applyBlockTypeSafe("heading");
              } else if (value === "blockquote") {
                applyBlockTypeSafe("blockquote");
              } else if (value === "bulletList") {
                applyBlockTypeSafe("bulletList");
              }
            }}
          >
            <option value="paragraph">Paragraph</option>
            <option value="1">Heading</option>
            <option value="blockquote">Quote</option>
            <option value="bulletList">List</option>
          </select>

          <Button
            onClick={(e) => {
              e.preventDefault();
              // console.log("Blod clicked");
              editor.chain().focus().toggleBold().run();
            }}
            disabled={!editor.can().chain().toggleBold().run()}
            primary={editor.isActive("bold")}
            icon={<Icon source={TextBoldIcon} />}
          />
          <Button
            onClick={(e) => {
              e.preventDefault();
              editor.chain().focus().toggleItalic().run();
            }}
            disabled={!editor.can().chain().toggleItalic().run()}
            primary={editor.isActive("italic")}
            icon={<Icon source={TextItalicIcon} />}
          />
          <Button
            onClick={(e) => {
              e.preventDefault();
              editor.chain().focus().toggleUnderline().run();
            }}
            disabled={!editor.can().chain().toggleUnderline().run()}
            primary={editor.isActive("underline")}
            icon={<Icon source={TextUnderlineIcon} />}
          />
          <Button
            onClick={(e) => {
              e.preventDefault();
              editor.chain().focus().toggleStrike().run();
            }}
            disabled={!editor.can().chain().toggleStrike().run()}
            primary={editor.isActive("strike")}
          >
            Strike
          </Button>
          <Button
            onClick={() => editor.chain().setTextAlign("left").run()}
            disabled={!editor.can().chain().setTextAlign("left").run()}
            primary={editor.isActive("textAlign", { align: "left" })}
            icon={<Icon source={TextAlignLeftIcon} />}
          />
          <Button
            onClick={() => editor.chain().setTextAlign("center").run()}
            disabled={!editor.can().chain().setTextAlign("center").run()}
            primary={editor.isActive("textAlign", { align: "center" })}
            icon={<Icon source={TextAlignCenterIcon} />}
          />
          <Button
            onClick={() => editor.chain().setTextAlign("right").run()}
            disabled={!editor.can().chain().setTextAlign("right").run()}
            primary={editor.isActive("textAlign", { align: "right" })}
            icon={<Icon source={TextAlignRightIcon} />}
          />
          <Button
            onClick={(e) => {
              e.preventDefault();
              rememberSelection();
              setIsColorPickerOpen1(!isColorPickerOpen1);
            }}
            icon={
              isColorPickerOpen1 ? (
                <Icon source={ChevronUpIcon} />
              ) : (
                <Icon source={ChevronDownIcon} />
              )
            }
          >
            <Icon source={TextColorIcon} />
          </Button>
          <Button
            onClick={(e) => {
              e.preventDefault();
              rememberSelection();
              setIsColorPickerOpen(!isColorPickerOpen);
            }}
            primary={editor.isActive("highlight")}
            icon={
              isColorPickerOpen ? (
                <Icon source={ChevronUpIcon} />
              ) : (
                <Icon source={ChevronDownIcon} />
              )
            }
          >
            <span className="Polaris-Button__Icon">
              <svg
                width="15"
                height="15"
                viewBox="-2 0 20 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.56221 13.4111L4.88281 15.1997H11.4356L10.7562 13.4111H5.56221ZM6.12221 11.6629H10.196L8.15921 6.26514L6.12221 11.6629Z"
                  fill="black"
                ></path>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13.8008 0.799805H2.20078C1.43078 0.799805 0.800781 1.4298 0.800781 2.1998V13.7998C0.800781 14.5698 1.43078 15.1998 2.20078 15.1998H2.62298L6.78538 4.6466C6.81783 4.54051 6.88343 4.4476 6.97255 4.38151C7.06168 4.31543 7.16963 4.27964 7.28058 4.2794H9.04298C9.27338 4.2794 9.46658 4.43 9.53538 4.6374H9.53898L13.6964 15.1998H13.8008C14.5708 15.1998 15.2008 14.5698 15.2008 13.7998V2.1998C15.2008 1.4298 14.5708 0.799805 13.8008 0.799805Z"
                  fill="black"
                ></path>
              </svg>
            </span>
          </Button>
          {/* {subscriptionPlan === null ? null : subscriptionPlan === "free" &&
            blogsCount <= 3 ? (
            <Button
              icon={<Icon source={ImagesIcon} tone="base" />}
              disabled
              title="Insert Image"
            />
          ) : ( */}
            <Button
              icon={<Icon source={ImagesIcon} tone="base" />}
              onClick={() => onImageClick(index)}
            />
          {/* )} */}
          <Button
            onClick={setLink}
            disabled={!editor.can().chain().focus().setLink({ href: "" }).run()}
            primary={editor.isActive("link")}
            icon={<Icon source={LinkIcon} />}
          />

          <Popover
            active={aiPopoverActive && !isRewriteDisabled}
            activator={
              <Button
                icon={<Icon source={MagicIcon} />}
                onClick={toggleAiPopover}
                variant="primary"
                disclosure
                disabled={isRewriteDisabled}
                tone={isRewriteDisabled ? "subdued" : undefined}
              >
                Rewrite
              </Button>
            }
            onClose={toggleAiPopover}
            autofocusTarget="first-node"
          >
            <ActionList
              items={[
                {
                  content: "Rewrite",
                  onAction: () => {
                    if (!isRewriteDisabled) {
                      toggleAiPopover();
                      handleAiAction("rewrite");
                    }
                  },
                  disabled: isRewriteDisabled,
                },
                {
                  content: "Shorten",
                  onAction: () => {
                    if (!isRewriteDisabled) {
                      toggleAiPopover();
                      handleAiAction("shorten");
                    }
                  },
                  disabled: isRewriteDisabled,
                },
                {
                  content: "Lengthen",
                  onAction: () => {
                    if (!isRewriteDisabled) {
                      toggleAiPopover();
                      handleAiAction("lengthen");
                    }
                  },
                  disabled: isRewriteDisabled,
                },
                // {
                //   content: 'Change Tone',
                //   onAction: () => {
                //     if (!isRewriteDisabled) {
                //       toggleAiPopover();
                //       handleAiAction('tone');
                //     }
                //   },
                //   disabled: isRewriteDisabled
                // }
              ]}
            />
          </Popover>
        </div>
        {isColorPickerOpen1 && (
          <div
            ref={colorPickerRef1}
            className="color-picker"
            style={{ top: "38px", right: "195px" }}
          >
            <div
              className="color-option"
              style={{
                border: "0.4px solid black",
                backgroundColor: "#000000",
              }}
              onClick={() => handleTextColor("#000000")}
            />
            <div
              className="color-option"
              style={{
                border: "0.4px solid black",
                backgroundColor: "#FFFFFF",
              }}
              onClick={() => handleTextColor("#FFFFFF")}
            />
            <div
              className="color-option"
              style={{
                border: "0.4px solid black",
                backgroundColor: "#808080",
              }}
              onClick={() => handleTextColor("#808080")}
            />
            <div
              className="color-option"
              style={{
                border: "0.4px solid black",
                backgroundColor: "#0000FF",
              }}
              onClick={() => handleTextColor("#0000FF")}
            />
            <div
              className="color-option"
              style={{
                border: "0.4px solid black",
                backgroundColor: "#008000",
              }}
              onClick={() => handleTextColor("#008000")}
            />
            <div
              className="color-option"
              style={{
                border: "0.4px solid black",
                backgroundColor: "#FFA500",
              }}
              onClick={() => handleTextColor("#FFA500")}
            />
            <div
              className="add-color"
              onClick={() => setIsCustomColorModalOpen1(true)}
            >
              +
            </div>
          </div>
        )}
        {isColorPickerOpen && (
          <div
            ref={colorPickerRef}
            className="color-picker"
            style={{ top: "38px", right: "130px" }}
          >
            <div
              className="color-option"
              style={{
                border: "0.4px solid black",
                backgroundColor: "#000000",
              }}
              onClick={() => handleHighlightColor("#000000")}
            />
            <div
              className="color-option"
              style={{
                border: "0.4px solid black",
                backgroundColor: "#FFFFFF",
              }}
              onClick={() => handleHighlightColor("#FFFFFF")}
            />
            <div
              className="color-option"
              style={{
                border: "0.4px solid black",
                backgroundColor: "#808080",
              }}
              onClick={() => handleHighlightColor("#808080")}
            />
            <div
              className="color-option"
              style={{
                border: "0.4px solid black",
                backgroundColor: "#0000FF",
              }}
              onClick={() => handleHighlightColor("#0000FF")}
            />
            <div
              className="color-option"
              style={{
                border: "0.4px solid black",
                backgroundColor: "#008000",
              }}
              onClick={() => handleHighlightColor("#008000")}
            />
            <div
              className="color-option"
              style={{
                border: "0.4px solid black",
                backgroundColor: "#FFA500",
              }}
              onClick={() => handleHighlightColor("#FFA500")}
            />
            <div
              className="add-color"
              onClick={() => setIsCustomColorModalOpen(true)}
            >
              +
            </div>
          </div>
        )}
        <Modal
          open={isCustomColorModalOpen1}
          onClose={() => setIsCustomColorModalOpen1(false)}
          title="Pick a custom text color"
          primaryAction={{
            content: "Apply",
            onAction: () => {
              const hex = hsbToHex(customColor);
              handleTextColor(hex);
              setIsCustomColorModalOpen1(false);
            },
          }}
          secondaryActions={[
            {
              content: "Cancel",
              onAction: () => setIsCustomColorModalOpen1(false),
            },
          ]}
        >
          <Modal.Section>
            <ColorPicker
              onChange={setCustomColor}
              color={customColor}
              allowAlpha
            />
          </Modal.Section>
        </Modal>
        <Modal
          open={isCustomColorModalOpen}
          onClose={() => setIsCustomColorModalOpen(false)}
          title="Pick a custom highlight color"
          primaryAction={{
            content: "Apply",
            onAction: () => {
              const hex = hsbToHex(customColor);
              handleHighlightColor(hex);
              setIsCustomColorModalOpen(false);
            },
          }}
          secondaryActions={[
            {
              content: "Cancel",
              onAction: () => setIsCustomColorModalOpen(false),
            },
          ]}
        >
          <Modal.Section>
            <ColorPicker
              onChange={setCustomColor}
              color={customColor}
              allowAlpha
            />
          </Modal.Section>
        </Modal>
        <Modal
          open={isLinkModalOpen}
          onClose={() => setIsLinkModalOpen(false)}
          title="Add a Link"
          primaryAction={{
            content: "Apply",
            onAction: handleApplyLink,
          }}
          secondaryActions={[
            {
              content: "Cancel",
              onAction: () => setIsLinkModalOpen(false),
            },
          ]}
        >
          <Modal.Section>
            <TextField
              label="URL"
              value={linkUrl}
              onChange={setLinkUrl}
              autoComplete="off"
              placeholder="https://example.com"
            />
          </Modal.Section>
        </Modal>
      </div>
    </>
  );
};

// EditorSection Component (Unchanged)

const EditorSection = ({
  content,
  onEditorCreated,
  onFocus,
  index,
  shopOrigin,
  shopCurrency = "$",
}) => {
  const memoizedContent = useMemo(() => content, [content]);
  const shopifyAppUrl = process.env.REACT_APP_SHOPIFY_APP_URL;

  const ProductBlock = Node.create({
    name: "productBlock",
    group: "block",
    atom: true,
    draggable: true,

    addAttributes() {
      return {
        product_id: { default: null },
        product_title: { default: "Product Title" },
        product_vendor: { default: "" },
        product_description: { default: "Product description..." },
        product_image: { default: "" },
        image_alt_text: { default: "" },
        variants: { default: [] },
        selected_variant_id: { default: null },
        quantity: { default: 1 },
        currency_symbol: { default: shopCurrency },
        product_handle: { default: "" },
      };
    },

    parseHTML() {
      return [
        {
          tag: 'div[data-type="product-block"]',
          getAttrs: (dom) => ({
            product_id: dom.dataset.productId,
            product_title: dom.querySelector(
              ".custom-product-button-block-title"
            )?.textContent,
            product_vendor: dom.querySelector(".product-card-vendor")
              ?.textContent,
            product_description: dom.querySelector(".product-card-description")
              ?.innerHTML,
            product_image: dom.querySelector("img")?.src,
            image_alt_text: dom.querySelector("img")?.alt,
            variants: JSON.parse(dom.dataset.variants || "[]"),
            selected_variant_id: dom.dataset.selectedVariantId,
            quantity: parseInt(dom.dataset.quantity) || 1,
            product_handle: dom.dataset.productHandle || "",
          }),
        },
      ];
    },

    
    
    renderHTML({ HTMLAttributes }) {
      // const safeVariants = Array.isArray(variants) ? variants : [];
      // const selectedVariant =
      //   safeVariants.find(v => String(v.variant_id) === String(selected_variant_id)) ||
      //   safeVariants[0] ||
      //   null;
      const {
        variants = [],
        selected_variant_id,
        quantity = 1,
        product_handle,
        product_description = "No description",
        product_image,
        image_alt_text = "No image",
        product_vendor = "No vendor",
        product_title = "Product Title",
      } = HTMLAttributes;

      const effectiveProductImage =
        product_image || `${shopifyAppUrl}/static/ImageNotAvailable.png`;

      const selectedVariant =
        variants.find((v) => String(v.variant_id) === selected_variant_id) ||
        variants[0];

      const currencySymbol = HTMLAttributes.currency_symbol || shopCurrency;
      // console.log("RENDER HTML currencySYmbol:::: ", currencySymbol);
      const price = selectedVariant
        ? `${currencySymbol}${selectedVariant.variant_price}`
        : "Price not available";
      const maxQty =
        selectedVariant?.inventory_quantity !== undefined
          ? selectedVariant.inventory_quantity
          : 999;

      const showVariantSelection = variants.length > 2;

      const contentElements = [
        [
          "a",
          {
            href: `/products/${product_handle}`,
            class: "custom-product-button-block-title",
            target: "_blank",
            style:
              "font-size: 16px; font-weight: 600; text-decoration: none; color: black; margin: 8px 0; width:100%; line-height: 24px;",
          },
          product_title,
        ],
        [
          "p",
          {
            class: "product-card-vendor",
            style: "margin: 0 0 15px; font-size: 14px; text-align: left;",
          },
          product_vendor,
        ],
        [
          "p",
          {
            class: "product-card-description",
            style:
              "text-align: left; margin: 0 0 20px; line-height: 1.5; flex-grow: 1; overflow-y: auto; max-height: 150px; max-width: 300px; width: 100%;",
          },
          DOMPurify.sanitize(product_description),
        ],
      ];

      if (showVariantSelection) {
        contentElements.push([
          "select",
          {
            class: "product-options",
            style:
              "border: 1px dashed #ccc; padding: 10px; margin: 10px 0; background-color: #f9f9f9; border-radius: 4px; display: flex; gap: 10px; align-items: center; width: 100%;",
          },
          ...variants.map((v) => [
            "option",
            {
              value: v.variant_id,
              selected:
                String(v.variant_id) === String(selected_variant_id)
                  ? "selected"
                  : {},
            },
            v.variant_title,
          ]),
        ]);
      }

      contentElements.push([
        "p",
        { id: "price-display", style: "margin: 0 0 15px; width: 100%;" },
        ["strong", "Price:"],
        ` ${price}`,
      ]);

      if (selectedVariant && (showVariantSelection || variants.length > 1)) {
        contentElements.push([
          "p",
          { id: "variant-display", style: "margin: 4px 0; width: 100%;" },
          ["strong", "Variant:"],
          ` ${selectedVariant.variant_title}`,
        ]);
      }

      contentElements.push(
        [
          "div",
          {
            class: "quantity-selector1",
            style:
              "display: flex; align-items: center; gap: 8px; margin: 10px 0; display: flex; align-items: stretch; justify-content: space-between;",
          },
          [
            "button",
            {
              type: "button",
              style:
                "padding: border: 1px solid #ccc; cursor: pointer; border-radius: 5px;",
            },
            "-",
          ],
          [
            "input",
            {
              type: "number",
              min: 1,
              max: maxQty,
              value: quantity,
              style:
                "text-align: center; border: 0.1px solid #d1d1d1; border-radius: 5px;",
            },
          ],
          [
            "button",
            {
              type: "button",
              style:
                "padding: border: 1px solid #ccc; cursor: pointer; border-radius: 5px;",
            },
            "+",
          ],
        ],
        [
          "button",
          {
            class: "Polaris-Button",
            style:
              "background-color: #4A4AF4; color: white; border: none; padding: 10px; border-radius: 4px; cursor: pointer;",
          },
          "Add to Cart",
        ]
      );

      return [
        "div",
        {
          "data-type": "product-block",
          "data-product-id": HTMLAttributes.product_id,
          "data-variants": JSON.stringify(variants),
          "data-selected-variant-id": selectedVariant?.variant_id,
          "data-quantity": quantity,
          "data-product-handle": product_handle,
          "data-currency-symbol": currencySymbol,
          class: "custom-product-block",
          contenteditable: "false",
          style:
            "border: 1px dashed #824c4c; background-color: #fafafa; padding: 16px; margin: 12px 0; text-align: center; border-radius: 8px; display: flex; align-items: center; width: 100%;",
        },
        [
          "div",
          {
            style:
              "object-fit: cover; width: 50%; display: flex; align-items: center; justify-content: center;",
          },
          [
            "img",
            {
              src: effectiveProductImage,
              alt: image_alt_text,
              style: "width: 50%; height: auto;",
            },
          ],
        ],
        [
          "div",
          {
            class: "custom-product-button-block",
            style:
              "display: flex; flex-direction: column; flex: 1; padding: 15px; width: 100%; align-items: flex-start;text-align: left;",
          },
          ...contentElements,
        ],
      ];
    },

    addNodeView() {
      return ({ node, getPos, editor }) => {
        const dom = document.createElement("div");
        dom.setAttribute("data-type", "product-block");
        dom.className = "custom-product-block";
        dom.style.cssText =
          "border: 1px dashed #824c4c; background-color: #fafafa; padding: 16px; margin: 12px 0; text-align: center; border-radius: 8px; display: flex; align-items: center; width: 100%;";
        dom.contentEditable = "false";
        dom.dataset.productHandle = node.attrs.product_handle;
        dom.dataset.currencySymbol = node.attrs.currency_symbol || shopCurrency;
        const imageContainer = document.createElement("div");
        imageContainer.style.cssText =
          "object-fit: cover; width: 50%; display: flex; align-items: center; justify-content: center;";
        const img = document.createElement("img");
        img.src =
          node.attrs.product_image ||
          `${shopifyAppUrl}/static/ImageNotAvailable.png`; // Use static image as fallback
        img.alt = node.attrs.image_alt_text || "No image";
        img.style.cssText = "width: 50%; height: auto;";
        imageContainer.appendChild(img);

        const right = document.createElement("div");
        right.className = "custom-product-button-block";
        right.style.cssText =
          "display: flex; flex-direction: column; flex: 1; padding: 15px; width: 100%; align-items: flex-start;";

        const title = document.createElement("a");
        title.className = "custom-product-button-block-title";
        title.href = `/products/${node.attrs.product_handle}`;
        title.innerText = node.attrs.product_title || "Product Title";
        title.style.cssText =
          "font-size: 16px; font-weight: 600; text-decoration: none; color: black; margin: 8px 0; line-height: 24px;";

        const vendor = document.createElement("p");
        vendor.className = "product-card-vendor";
        vendor.innerText = node.attrs.product_vendor || "No vendor";
        vendor.style.cssText =
          "margin: 0 0 15px; font-size: 14px; text-align: left;";

        const desc = document.createElement("p");
        desc.className = "product-card-description";
        desc.innerHTML = DOMPurify.sanitize(
          node.attrs.product_description || "No description"
        );
        desc.style.cssText =
          "text-align: left; margin: 0 0 20px; line-height: 1.5; flex-grow: 1; overflow-y: auto; max-height: 150px; max-width: 300px;";

        const variants = node.attrs.variants || [];
        const showVariantSelection = variants.length > 2;
        let selectedVariant =
          variants.find(
            (v) => String(v.variant_id) === node.attrs.selected_variant_id
          ) || variants[0];

        let select = null;

        if (showVariantSelection) {
          select = document.createElement("select");
          select.className = "product-options";
          select.style.cssText =
            "border: 1px dashed #ccc; padding: 10px; margin: 10px 0; background-color: #f9f9f9; border-radius: 4px; display: flex; gap: 10px; align-items: center;";

          variants.forEach((v) => {
            const option = document.createElement("option");
            option.value = v.variant_id;
            option.innerText = v.variant_title || "No variant title";
            if (String(v.variant_id) === node.attrs.selected_variant_id) {
              option.selected = true;
            }
            select.appendChild(option);
          });
        }

        const priceEl = document.createElement("p");
        priceEl.id = "price-display";
        priceEl.style.margin = "0 0 15px;";

        const variantTitleEl = document.createElement("p");
        variantTitleEl.id = "variant-display";
        variantTitleEl.style.margin = "4px 0;";

        const qtyInput = document.createElement("input");
        qtyInput.type = "number";
        qtyInput.min = 1;
        qtyInput.max =
          selectedVariant?.inventory_quantity !== undefined
            ? selectedVariant.inventory_quantity
            : 999;
        qtyInput.value = node.attrs.quantity || 1;
        qtyInput.style.cssText = "width: 50px; text-align: center;";

        const updateDisplay = () => {
          if (showVariantSelection && select) {
            selectedVariant =
              variants.find((v) => String(v.variant_id) === select.value) ||
              variants[0];
          }

          // Use currency_symbol from node attributes instead of shopCurrency directly
          const currencySymbol = node.attrs.currency_symbol || shopCurrency;
          // console.log("ADD NODE VIEW:::: ", currencySymbol);
          priceEl.innerHTML = `<strong>Price:</strong> ${currencySymbol}${selectedVariant.variant_price}`;

          if (showVariantSelection || variants.length > 1) {
            variantTitleEl.innerHTML = `<strong>Variant:</strong> ${selectedVariant.variant_title}`;
            variantTitleEl.style.display = "block";
          } else {
            variantTitleEl.style.display = "none";
          }

          qtyInput.max =
            selectedVariant?.inventory_quantity !== undefined
              ? selectedVariant.inventory_quantity
              : 999;
        };

        if (select) {
          select.addEventListener("change", () => {
            editor.commands.command(({ tr }) => {
              tr.setNodeMarkup(getPos(), undefined, {
                ...node.attrs,
                selected_variant_id: select.value,
                currency_symbol: node.attrs.currency_symbol || shopCurrency, // Ensure currency is preserved
              });
              return true;
            });
            updateDisplay();
          });
        }

        updateDisplay();

        const qtyContainer = document.createElement("div");
        qtyContainer.style.cssText =
          "display: flex; align-items: center; gap: 8px; margin: 10px 0;";

        const decBtn = document.createElement("button");
        decBtn.innerText = "-";
        decBtn.style.cssText =
          "padding: border: 1px solid #ccc; cursor: pointer;";

        const incBtn = document.createElement("button");
        incBtn.innerText = "+";
        incBtn.style.cssText =
          "padding: border: 1px solid #ccc; cursor: pointer;";

        const updateNodeQuantity = () => {
          let val = parseInt(qtyInput.value);
          if (isNaN(val) || val < 1) val = 1;
          if (val > parseInt(qtyInput.max)) val = parseInt(qtyInput.max);
          qtyInput.value = val;
          editor.commands.command(({ tr }) => {
            tr.setNodeMarkup(getPos(), undefined, {
              ...node.attrs,
              quantity: val,
            });
            return true;
          });
          dom.dataset.quantity = val;
        };

        decBtn.addEventListener("click", () => {
          qtyInput.value = Math.max(parseInt(qtyInput.value) - 1, 1);
          updateNodeQuantity();
        });

        incBtn.addEventListener("click", () => {
          qtyInput.value = Math.min(
            parseInt(qtyInput.value) + 1,
            parseInt(qtyInput.max)
          );
          updateNodeQuantity();
        });

        qtyInput.addEventListener("change", updateNodeQuantity);

        const button = document.createElement("button");
        button.className = "Polaris-Button";
        button.innerText = "Add to Cart";
        button.style.cssText =
          "background-color: #4A4AF4; color: white; border: none; padding: 10px; border-radius: 4px; cursor: pointer;";

        right.appendChild(title);
        right.appendChild(vendor);
        right.appendChild(desc);

        if (select) {
          right.appendChild(select);
        }

        right.appendChild(priceEl);
        right.appendChild(variantTitleEl);
        right.appendChild(qtyContainer);
        right.appendChild(button);

        qtyContainer.appendChild(decBtn);
        qtyContainer.appendChild(qtyInput);
        qtyContainer.appendChild(incBtn);

        dom.appendChild(imageContainer);
        dom.appendChild(right);

        return { dom };
      };
    },
  });

  const ProductGridBlock = Node.create({
    name: "productGridBlock",
    group: "block",
    atom: true,
    draggable: true,

    addAttributes() {
      return {
        products: {
          default: [],
        }, // array of product objects
        currency_symbol: { default: shopCurrency },
      };
    },

    parseHTML() {
      return [
        {
          tag: 'div[data-type="product-grid-block"]',
          getAttrs: (dom) => {
            const items = [...dom.querySelectorAll(".product-grid-item")].map(
              (el) => ({
                product_id: el.dataset.productId,
                product_handle: el.dataset.productHandle,
                variants: JSON.parse(el.dataset.variants || "[]"),
                selected_variant_id: el.dataset.selectedVariantId,
                quantity: parseInt(el.dataset.quantity) || 1,
                product_title: el.querySelector(
                  ".custom-product-button-block-title"
                )?.textContent,
                product_vendor: el.querySelector(".product-card-vendor")
                  ?.textContent,
                product_description: el.querySelector(
                  ".product-card-description"
                )?.innerHTML,
                product_image: el.querySelector("img")?.src,
                image_alt_text: el.querySelector("img")?.alt,
              })
            );
            return { products: items };
          },
        },
      ];
    },

    renderHTML({ HTMLAttributes }) {
      const { products = [], currency_symbol = shopCurrency } = HTMLAttributes;

      return [
        "div",
        {
          "data-type": "product-grid-block",
          "data-products": JSON.stringify(products),
          class: "custom-product-grid-block custom-product-grid-block-preview",
          style:
            "display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; padding: 20px; background: #f9f9f9; border: 1px dashed #ccc; border-radius: 8px; overflow-x: auto;",
          contenteditable: "false",
        },
        ...products.map((product, prodIndex) => {
          const variants = product.variants || [];
          const selected_variant_id =
            product.selected_variant_id || variants[0]?.variant_id;
          const quantity = product.quantity || 1;
          const selectedVariant =
            variants.find(
              (v) => String(v.variant_id) === String(selected_variant_id)
            ) || variants[0];
          const price = selectedVariant
            ? `${currency_symbol}${selectedVariant.variant_price}`
            : "Price not available";
          const maxQty =
            selectedVariant?.inventory_quantity !== undefined
              ? selectedVariant.inventory_quantity
              : 999;

          // Check if we should show variant selection (more than 2 variants)
          const showVariantSelection = variants.length > 2;

          // Build content elements array
          const contentElements = [
            [
              "div",
              {
                class: "custom-product-button-block-title",
                style:
                  "font-size: 16px; font-weight: 600; text-decoration: none; color: black; margin: 8px 0; line-height: 24px; ",
              },
              product.product_title || "No Product Name",
            ],
            [
              "div",
              {
                class: "product-card-vendor",
                style:
                  "margin: 0 0 15px; font-size: 14px;width: 151px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;",
              },
              product.product_vendor || "Please Provide Vendor",
            ],
            [
              "div",
              {
                class: "product-card-description",
                title: product.product_description
                  ? product.product_description.replace(/<[^>]*>/g, "")
                  : "No description", // Strip HTML tags for tooltip
                style:
                  "text-align: left; margin: 0 0 20px; line-height: 1.5; flex-grow: 1; overflow-y: auto; max-height: 150px; max-width: 300px;width: 151px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;",
              },
              DOMPurify.sanitize(
                product.product_description || "No description"
              ),
            ],
          ];

          // Conditionally add variant selection
          if (showVariantSelection) {
            contentElements.push([
              "select",
              {
                class: "product-options",
                style:
                  "border: 1px dashed #ccc; padding: 10px; margin: 10px 0; background-color: #f9f9f9; border-radius: 4px; display: flex; gap: 10px; align-items: center; width: 100%; margin-top: 0px;",
              },
              ...variants.map((v) => [
                "option",
                {
                  value: v.variant_id,
                  selected:
                    String(v.variant_id) === String(selected_variant_id)
                      ? "selected"
                      : null,
                },
                v.variant_title,
              ]),
            ]);
          }

          // Add price display
          contentElements.push([
            "p",
            { id: "price-display", style: "margin: 0 0 15px; width: 100%;" },
            ["strong", "Price:"],
            ` ${price}`,
          ]);

          // Add variant display only if there are multiple variants
          if (
            selectedVariant &&
            (showVariantSelection || variants.length > 1)
          ) {
            contentElements.push([
              "p",
              { id: "variant-display", style: "margin: 4px 0; width: 100%;" },
              ["strong", "Variant:"],
              ` ${selectedVariant.variant_title}`,
            ]);
          }

          // Add quantity selector and add to cart button
          contentElements.push(
            [
              "div",
              {
                class: "quantity-selector1",
                style:
                  "display: flex; align-items: center; gap: 8px; margin: 10px 0;  display: flex; align-items: stretch; justify-content: space-between;",
              },
              [
                "button",
                {
                  type: "button",
                  style:
                    "padding: 5px 10px; border: 1px solid #ccc; cursor: pointer; border-radius: 5px;",
                },
                "-",
              ],
              [
                "input",
                {
                  type: "number",
                  min: 1,
                  max: maxQty,
                  value: quantity,
                  style:
                    "text-align: center; border: 0.1px solid #d1d1d1; border-radius: 5px;",
                },
              ],
              [
                "button",
                {
                  type: "button",
                  style:
                    "padding: 5px 10px; border: 1px solid #ccc; cursor: pointer; border-radius: 5px;",
                },
                "+",
              ],
            ],
            [
              "button",
              {
                class: "Polaris-Button",
                style:
                  "background-color: #4A4AF4; color: white; border: none; padding: 10px; border-radius: 4px; cursor: pointer;",
              },
              "Add to Cart",
            ]
          );

          return [
            "div",
            {
              "data-product-index": prodIndex,
              "data-product-id": product.product_id,
              "data-product-handle": product.product_handle || "",
              "data-variants": JSON.stringify(variants),
              "data-selected-variant-id": selected_variant_id,
              "data-currency-symbol": currency_symbol,
              "data-quantity": quantity,
              class: "product-grid-item product-grid-item-preview",
              style:
                "text-align: center; padding: 16px; border-radius: 6px; border: 1px solid #e0e0e0; background: #ffffff;",
            },
            [
              "div",
              {
                class: "product-image-container-preview",
                style:
                  "object-fit: cover; width: 100%; display: flex; align-items: center; justify-content: center; max-height: 100%; height: auto;",
              },
              [
                "img",
                {
                  src:
                    product.product_image ||
                    `${shopifyAppUrl}/static/ImageNotAvailable.png`,
                  alt: product.image_alt_text || "Product",
                  style: "width: 100%; height: auto;",
                },
              ],
            ],
            [
              "div",
              {
                class: "custom-product-button-block",
                style:
                  "display: flex; flex-direction: column; flex: 1; padding: 15px; width: 100%; align-items: flex-start;text-align: left;",
              },
              ...contentElements,
            ],
          ];
        }),
      ];
    },

    addNodeView() {
      return ({ node, getPos, editor }) => {
        const dom = document.createElement("div");
        dom.setAttribute("data-type", "product-grid-block");
        dom.className = "custom-product-grid-block-editor";

        // Add responsive styles for editor mode
        const style = document.createElement("style");
        style.textContent = `
          .custom-product-grid-block-editor {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 20px;
            padding: 20px;
            background: #f9f9f9;
            border: 1px dashed #ccc;
            border-radius: 8px;
          }

          @media (max-width: 1024px) {
            .custom-product-grid-block-editor {
              grid-template-columns: repeat(2, 1fr);
              gap: 15px;
              padding: 15px;
            }
          }

          @media (max-width: 768px) {
            .custom-product-grid-block-editor {
              grid-template-columns: 1fr;
              gap: 15px;
              padding: 15px;
            }
          }

          .product-grid-item-editor {
            text-align: center;
            padding: 16px;
            border-radius: 6px;
            border: 1px solid #e0e0e0;
            background: #ffffff;
          }

          .product-image-container-editor {
            object-fit: cover;
            width: 100%;
            display: flex;
            // align-items: center;
            justify-content: center;
            max-height: 100%;
            height: 268px;
          }

          @media (max-width: 768px) {
            .product-image-container-editor {
              height: auto;
            }
          }

          .product-content-editor {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            text-align: left;
          }

          .product-title-editor {
            font-size: 16px;
            font-weight: 600;
            color: black;
            margin: 8px 0;
            line-height: 24px;
          }

          .product-vendor-editor {
            margin: 0 0 15px;
            font-size: 14px;
            width: 100%;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }

          .product-description-editor {
            text-align: left;
            margin: 0 0 20px;
            line-height: 1.5;
            flex-grow: 1;
            max-height: 150px;
            width: 100%;
            text-overflow: ellipsis;
            // white-space: nowrap;
            overflow: hidden;
          }

          .product-options-editor {
            border: 1px dashed #ccc;
            padding: 10px;
            margin: 10px 0;
            background-color: #f9f9f9;
            border-radius: 4px;
            width: 100%;
            margin-top: 0px;
          }

          .quantity-selector-editor {
            display: flex;
            align-items: center;
            gap: 8px;
            margin: 10px 0;
            width: 100%;
            justify-content: flex-start;
          }

          .quantity-btn-editor {
            // padding: 5px 10px;
            border: 1px solid #ccc;
          
            cursor: pointer;
            border-radius: 5px;
          }

          .quantity-input-editor {
            // width: 100%;
            text-align: center;
            border: 0.1px solid #d1d1d1;
            border-radius: 5px;
          }

          .add-to-cart-btn-editor {
            background-color: #4A4AF4;
            color: white;
            width: 100%;
            border: none;
            padding: 10px;
            border-radius: 4px;
            cursor: pointer;
          }
        `;

        // Append style to head if not already added
        if (!document.querySelector("#product-grid-editor-styles")) {
          style.id = "product-grid-editor-styles";
          document.head.appendChild(style);
        }

        dom.contentEditable = "false";

        const products = node.attrs.products || [];

        products.forEach((product, prodIndex) => {
          const variants = product.variants || [];
          const showVariantSelection = variants.length > 2;
          let selectedVariant =
            variants.find(
              (v) => String(v.variant_id) === product.selected_variant_id
            ) || variants[0];

          const productDom = document.createElement("div");
          productDom.className = "product-grid-item-editor";
          productDom.setAttribute("data-product-index", prodIndex);
          productDom.setAttribute("data-product-id", product.product_id);
          productDom.setAttribute(
            "data-product-handle",
            product.product_handle || ""
          );
          productDom.setAttribute("data-variants", JSON.stringify(variants));
          productDom.setAttribute(
            "data-selected-variant-id",
            product.selected_variant_id || ""
          );
          productDom.setAttribute(
            "data-currency-symbol",
            node.attrs.currency_symbol || shopCurrency
          );
          productDom.setAttribute("data-quantity", product.quantity || 1);

          const imageContainer = document.createElement("div");
          imageContainer.className = "product-image-container-editor";
          const img = document.createElement("img");
          img.src =
            product.product_image ||
            `${shopifyAppUrl}/static/ImageNotAvailable.png`;
          img.alt = product.image_alt_text || "Product";
          img.style.cssText = "width: 100%; height: auto;";
          imageContainer.appendChild(img);

          const right = document.createElement("div");
          right.className = "product-content-editor";

          const title = document.createElement("div");
          title.className = "product-title-editor";
          title.innerText = product.product_title || "No Product Name";

          const vendor = document.createElement("div");
          vendor.className = "product-vendor-editor";
          vendor.innerText = product.product_vendor || "Please Provide Vendor";

          const desc = document.createElement("div");
          desc.className = "product-description-editor";
          desc.innerHTML = DOMPurify.sanitize(
            product.product_description || "No description"
          );
          desc.title = product.product_description
            ? product.product_description.replace(/<[^>]*>/g, "")
            : "No description";

          let select = null;

          // Only create select if we should show variant selection
          if (showVariantSelection) {
            select = document.createElement("select");
            select.className = "product-options-editor";

            variants.forEach((v) => {
              const option = document.createElement("option");
              option.value = v.variant_id;
              option.innerText = v.variant_title;
              if (String(v.variant_id) === product.selected_variant_id) {
                option.selected = true;
              }
              select.appendChild(option);
            });
          }

          const priceEl = document.createElement("p");
          priceEl.id = "price-display";
          priceEl.style.margin = "0 0 15px; width: 100%;";

          const variantTitleEl = document.createElement("p");
          variantTitleEl.id = "variant-display";
          variantTitleEl.style.margin = "4px 0; width: 100%;";

          const qtyInput = document.createElement("input");
          qtyInput.type = "number";
          qtyInput.min = 1;
          qtyInput.max =
            selectedVariant?.inventory_quantity !== undefined
              ? selectedVariant.inventory_quantity
              : 999;
          qtyInput.value = product.quantity || 1;
          qtyInput.className = "quantity-input-editor";

          const updateDisplay = () => {
            if (showVariantSelection && select) {
              selectedVariant =
                variants.find((v) => String(v.variant_id) === select.value) ||
                variants[0];
            }

            if (selectedVariant) {
              const currencySymbol = node.attrs.currency_symbol || shopCurrency;
              priceEl.innerHTML = `<strong>Price:</strong> ${currencySymbol}${selectedVariant.variant_price}`;

              // Show variant title only if there are multiple variants
              if (showVariantSelection || variants.length > 1) {
                variantTitleEl.innerHTML = `<strong>Variant:</strong> ${selectedVariant.variant_title}`;
                variantTitleEl.style.display = "block";
              } else {
                variantTitleEl.style.display = "none";
              }

              qtyInput.max =
                selectedVariant?.inventory_quantity !== undefined
                  ? selectedVariant.inventory_quantity
                  : 999;
            } else {
              priceEl.innerHTML = `<strong>Price:</strong> Price not available`;
              variantTitleEl.innerHTML = ``;
              qtyInput.max = 999;
            }

            if (select) {
              productDom.setAttribute("data-selected-variant-id", select.value);
            }
          };

          // Add event listener only if select exists
          if (select) {
            select.addEventListener("change", () => {
              editor.commands.command(({ tr }) => {
                const currentProducts = [...node.attrs.products];
                currentProducts[prodIndex] = {
                  ...currentProducts[prodIndex],
                  selected_variant_id: select.value,
                };
                tr.setNodeMarkup(getPos(), undefined, {
                  ...node.attrs,
                  products: currentProducts,
                });
                return true;
              });
              updateDisplay();
            });
          }

          updateDisplay(); // Call after qtyInput is defined

          const qtyContainer = document.createElement("div");
          qtyContainer.className = "quantity-selector-editor";

          const decBtn = document.createElement("button");
          decBtn.innerText = "-";
          decBtn.className = "quantity-btn-editor";

          const incBtn = document.createElement("button");
          incBtn.innerText = "+";
          incBtn.className = "quantity-btn-editor";

          const updateNodeQuantity = () => {
            let val = parseInt(qtyInput.value);
            if (isNaN(val) || val < 1) val = 1;
            if (val > parseInt(qtyInput.max)) val = parseInt(qtyInput.max);
            qtyInput.value = val;
            productDom.setAttribute("data-quantity", val);
            editor.commands.command(({ tr }) => {
              const currentProducts = [...node.attrs.products];
              currentProducts[prodIndex] = {
                ...currentProducts[prodIndex],
                quantity: val,
              };
              tr.setNodeMarkup(getPos(), undefined, {
                ...node.attrs,
                products: currentProducts,
              });
              return true;
            });
          };

          decBtn.addEventListener("click", () => {
            qtyInput.value = Math.max(parseInt(qtyInput.value) - 1, 1);
            updateNodeQuantity();
          });

          incBtn.addEventListener("click", () => {
            qtyInput.value = Math.min(
              parseInt(qtyInput.value) + 1,
              parseInt(qtyInput.max)
            );
            updateNodeQuantity();
          });

          qtyInput.addEventListener("change", updateNodeQuantity);

          qtyContainer.appendChild(decBtn);
          qtyContainer.appendChild(qtyInput);
          qtyContainer.appendChild(incBtn);

          const button = document.createElement("button");
          button.className = "add-to-cart-btn-editor";
          button.innerText = "Add to Cart";

          // Append elements to right container
          right.appendChild(title);
          right.appendChild(vendor);
          right.appendChild(desc);

          // Only append select if it should be shown
          if (select) {
            right.appendChild(select);
          }

          right.appendChild(priceEl);
          right.appendChild(variantTitleEl);
          right.appendChild(qtyContainer);
          right.appendChild(button);

          productDom.appendChild(imageContainer);
          productDom.appendChild(right);

          dom.appendChild(productDom);
        });

        return { dom };
      };
    },
  });

  const ImageWithTextBlock = Node.create({
    name: "imageWithTextBlock",
    group: "block",
    content: "block+",
    draggable: true,

    addAttributes() {
      return {
        image_url: { default: "" },
        image_alt: { default: "" },
        layout: { default: "image-left" },
        image_width: { default: "auto" },
        image_height: { default: "auto" }, // Add this
        text_width: { default: "" },
        vertical_align: { default: "center" },
        object_fit: { default: "contain" }, // Add this
        object_position: { default: "center" }, // Add this
        image_alignment: { default: "center" }, // Add this
      };
    },

    parseHTML() {
      return [
        {
          tag: 'div[data-type="image-with-text-block"]',
          getAttrs: (dom) => {
            return {
              image_url: dom.dataset.imageUrl || "",
              image_alt: dom.dataset.imageAlt || "",
              layout: dom.dataset.layout || "image-left",
              image_width: dom.dataset.imageWidth || "", // Changed default to "auto"
              text_width: dom.dataset.textWidth || "", // Changed default to "auto"
              vertical_align: dom.dataset.verticalAlign || "center",
            };
          },
          getContent: (dom, schema) => {
            const textContentDiv = dom.querySelector(".text-content");
            if (textContentDiv && textContentDiv.firstChild) {
              const clonedDiv = textContentDiv.cloneNode(true);
              const imgElements = clonedDiv.querySelectorAll("img");
              imgElements.forEach((img) => img.remove());
              if (clonedDiv.innerHTML.trim()) {
                return ProseMirrorDOMParser.fromSchema(schema).parse(clonedDiv);
              }
            }
            return schema.text("Start writing your text content here...");
          },
        },
      ];
    },

    renderHTML({ HTMLAttributes, node }) {
      const {
        image_url,
        image_alt,
        layout,
        image_width,
        text_width,
        vertical_align,
      } = HTMLAttributes;

      const verticalAlignStyle =
        vertical_align === "top"
          ? "flex-start"
          : vertical_align === "bottom"
          ? "flex-end"
          : "center";

      const imageSection = [
        "div",
        {
          class: "image-section",
          style: `width: ${image_width}; display: flex; align-items: center; justify-content: center; background-color: #fff; border-radius: 4px; min-height: 100px;`, // Added min-height for consistency
        },
        image_url
          ? [
              "img",
              {
                src: image_url,
                alt: image_alt,
                style:
                  "max-width: 100%; max-height: 100%; object-fit: contain; border-radius: 4px;",
              },
            ]
          : [
              "div",
              {
                class: "image-placeholder",
                style:
                  "text-align: center; color: #666; cursor: pointer; padding: 40px 20px;",
              },
              "Click to add image",
            ],
      ];

      const textSection = [
        "div",
        {
          class: "text-section",
          style: `flex: 1; padding: 0 10px; display: flex; align-items: ${verticalAlignStyle}; min-height: 100px;`, // Added min-height
        },
        [
          "div",
          {
            class: "text-content",
            style:
              "flex: 1; width: 100%; padding: 15px; border-radius: 4px; display: flex; flex-direction: column; justify-content: ${verticalAlignStyle};", // Ensure text-content stretches and aligns
          },
          0, // Content placeholder
        ],
      ];

      return [
        "div",
        {
          "data-type": "image-with-text-block",
          "data-image-url": image_url,
          "data-image-alt": image_alt,
          "data-layout": layout,
          "data-image-width": image_width,
          "data-text-width": text_width,
          "data-vertical-align": vertical_align,
          class: "custom-image-with-text-block",
          style:
            "display: flex; gap: 20px; align-items: stretch; padding: 20px; border-radius: 8px; margin: 12px 0;", // Changed to align-items: stretch
        },
        ...(layout === "image-left"
          ? [imageSection, textSection]
          : [textSection, imageSection]),
      ];
    },

    addNodeView() {
      return ({ node, getPos, editor }) => {
        // Outer container (non-editable, but we don't set contentEditable=false)
        const dom = document.createElement("div");
        dom.setAttribute("data-type", "image-with-text-block");
        dom.className = "custom-image-with-text-block";
        dom.style.cssText =
          "display: flex; gap: 20px; align-items: stretch; padding: 20px; border-radius: 8px; margin: 12px 0;";

        const imageSection = document.createElement("div");
        imageSection.className = "image-section";
        imageSection.style.cssText = `width: ${node.attrs.image_width}; display: flex; align-items: center; justify-content: center; background-color: #fff; border-radius: 4px; min-height: 100px;`;

        const textSection = document.createElement("div");
        textSection.className = "text-section";
        const verticalAlignStyle =
          node.attrs.vertical_align === "top"
            ? "flex-start"
            : node.attrs.vertical_align === "bottom"
            ? "flex-end"
            : "center";
        textSection.style.cssText = `flex: 1; 
          min-width: 0; 
          padding: 0 10px; 
          display: flex; 
          align-items: ${verticalAlignStyle}; 
          min-height: 100px;
        `;

        // THIS is the true ProseMirror editable content area
        const contentDOM = document.createElement("div");
        contentDOM.className = "text-content";
        contentDOM.style.cssText = `flex: 1; width: 100%; padding: 15px; border-radius: 4px; background-color: #fff; border: 1px dashed #ddd; display: flex; flex-direction: column; justify-content: ${verticalAlignStyle};`;

        // No contenteditable hacks — ProseMirror will set it automatically

        const updateImageSection = () => {
          imageSection.innerHTML = "";

          const imageWidth = node.attrs.image_width || "auto";
          const imageHeight = node.attrs.image_height || "auto";

          imageSection.style.cssText = `
            width: ${imageWidth};
            height: ${imageHeight};
            flex-shrink: 0; 
            display: flex; 
            align-items: center; 
            justify-content: center; 
            background-color: #fff; 
            border-radius: 4px; 
            min-height: 100px;
          `;

          if (node.attrs.image_url) {
            const img = document.createElement("img");
            img.src = node.attrs.image_url;
            img.alt = node.attrs.image_alt;
            img.style.cssText = `
              width: 100%;
              height: 100%;
              object-fit: ${node.attrs.object_fit || "contain"};
              object-position: ${node.attrs.object_position || "center"};
              border-radius: 4px;
            `;
            imageSection.appendChild(img);
          } else {
            const placeholder = document.createElement("div");
            placeholder.className = "image-placeholder";
            placeholder.style.cssText =
              "text-align: center; color: #666; padding: 20px;";

            const buttonContainer = document.createElement("div");
            buttonContainer.style.cssText =
              "display: flex; flex-direction: row; gap: 7px; align-items: center;";

            const uploadButton = document.createElement("button");
            uploadButton.className =
              "Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter";
            uploadButton.textContent = "Upload Image";
            uploadButton.addEventListener("click", () => {
              const input = document.createElement("input");
              input.type = "file";
              input.accept = "image/*";
              input.style.display = "none";
              input.style.width = "100%";
              input.style.height = "100%";
              input.addEventListener("change", (event) => {
                const file = event.target.files?.[0];
                if (file) {
                  const reader = new FileReader();
                  reader.onload = (e) => {
                    const imageUrl = e.target?.result;
                    if (typeof imageUrl === "string") {
                      dom.updateImage(imageUrl, file.name);
                    }
                  };
                  reader.readAsDataURL(file);
                }
              });
              input.click();
            });

            const urlButton = document.createElement("button");
            urlButton.textContent = "Insert from URL";
            urlButton.className =
              "Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter";
            urlButton.addEventListener("click", () => {
              const sectionIndex = editor.options.sectionIndex;
              window.dispatchEvent(
                new CustomEvent("setIsUrlImageTextModalOpen", {
                  detail: { sectionIndex, open: true, position: getPos() },
                })
              );
            });

            const aiButton = document.createElement("button");
            aiButton.textContent = "Generate with AI";
            aiButton.className =
              "Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter";
            aiButton.addEventListener("click", () => {
              const sectionIndex = editor.options.sectionIndex;
              window.dispatchEvent(
                new CustomEvent("setIsAiModalOpenImageText", {
                  detail: { sectionIndex, open: true },
                })
              );
            });

            buttonContainer.appendChild(uploadButton);
            buttonContainer.appendChild(urlButton);
            buttonContainer.appendChild(aiButton);
            placeholder.appendChild(buttonContainer);
            imageSection.appendChild(placeholder);
          }
        };

        updateImageSection();
        textSection.appendChild(contentDOM);

        if (node.attrs.layout === "image-left") {
          dom.appendChild(imageSection);
          dom.appendChild(textSection);
        } else {
          dom.appendChild(textSection);
          dom.appendChild(imageSection);
        }

        dom.updateImage = (imageUrl, imageAlt) => {
          editor.commands.command(({ tr }) => {
            tr.setNodeMarkup(getPos(), undefined, {
              ...node.attrs,
              image_url: imageUrl,
              image_alt: imageAlt,
              image_width: "500px",
              text_width: "500px",
            });
            return true;
          });
          updateImageSection();
        };

        // The magic: Return contentDOM here so TipTap controls it
        return {
          dom,
          contentDOM,
        };
      };
    },
  });

  const PreventNodeDeletion = Extension.create({
    name: "preventNodeDeletion",

    addKeyboardShortcuts() {
      return {
        Backspace: ({ editor }) => {
          const { state } = editor;
          const { selection } = state;

          // Only block if selection is NodeSelection or TextSelection at the start
          if (selection.empty) {
            // $from resolves the current position in the doc
            const { $from } = selection;
            // Find the parent node of type 'imageWithTextBlock'
            for (let d = $from.depth; d > 0; d--) {
              const node = $from.node(d);
              if (node.type.name === "imageWithTextBlock") {
                // Check if the text_content is empty
                const txt = node.attrs.text_content || "";
                const isEmpty = txt.replace(/<br\s*\/?>/gi, "").trim() === "";

                // Block deletion if empty and caret is at the start of text-content
                if (isEmpty && $from.parentOffset === 0) {
                  return true;
                }
                break; // Once we find this node, no need to keep going up
              }
            }
          }
          return false;
        },
      };
    },
  });

  const preventImageWithTextBlockDeletion = new Plugin({
    filterTransaction(tr, state) {
      let blockWouldBeDeleted = false;
      let blockPos = null;

      // Look for imageWithTextBlock in the original doc
      state.doc.descendants((node, pos) => {
        if (node.type.name === "imageWithTextBlock") {
          blockPos = pos;
        }
      });

      if (!blockPos) return true;

      // Simulate doc after transaction
      const newDoc = tr.doc;
      let stillHasBlock = false;
      newDoc.descendants((node) => {
        if (node.type.name === "imageWithTextBlock") stillHasBlock = true;
      });

      if (!stillHasBlock) {
        blockWouldBeDeleted = true;
      }

      // If it would delete the block but we're not backspacing, block the tx
      if (blockWouldBeDeleted && !tr.getMeta("allowImageWithTextRemoval")) {
        console.warn("Prevented removal of imageWithTextBlock");
        return false;
      }

      return true;
    },
  });

  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        codeBlock: false,
      }),
      Link.configure({
        openOnClick: true,
        HTMLAttributes: {
          href: "",
          target: "_blank",
          rel: "noopener noreferrer",
        },
      }),
      // Image.configure({
      //   inline: true,
      //   allowBase64: true,
      //   HTMLAttributes: {
      //     class: "editor-images",
      //   },
      // }),
      Underline,
      Highlight.configure({ multicolor: true }),
      Color,
      TextStyle,
      TextAlign.configure({ types: ["heading", "paragraph"] }),
      Table.configure({ resizable: true }),
      TableRow,
      TableCell,
      TableHeader,
      HardBreak.configure({
        HTMLAttributes: { class: "line-break" },
      }),
      TaskItem.configure({ nested: true }),
      CodeBlockLowlight.configure({
        lowlight: createLowlight(common),
        defaultLanguage: null,
      }),
      ResizableImage.configure({
        inline: true,
        defaultWidth: null,
        defaultHeight: null,
      }),
      ProductBlock,
      ProductGridBlock,
      ImageWithTextBlock,
      PreventNodeDeletion,
      preventImageWithTextBlockDeletion,
    ],
    content: memoizedContent,
    onFocus: () => onFocus(index),
    sectionIndex: index,
    editorProps: {
      handleKeyDown(view, event) {
        if (event.key === "Enter") {
          const { $from } = view.state.selection;

          // Check if we're inside your custom node's text section
          const inImageWithTextBlock = $from.path.some(
            (node) => node?.type?.name === "imageWithTextBlock"
          );

          if (inImageWithTextBlock) {
            event.preventDefault();
            const hardBreak = view.state.schema.nodes.hardBreak.create();
            view.dispatch(
              view.state.tr.replaceSelectionWith(hardBreak).scrollIntoView()
            );
            return true;
          }
        }
        return false;
      },
    },
  });

  useEffect(() => {
    if (editor) {
      // console.log(`Editor created at index: ${index}`);
      onEditorCreated(editor, index);
    }
    return () => {
      editor?.destroy();
    };
  }, [editor, index, onEditorCreated]);

  return (
    <div>
      <EditorContent editor={editor} />
    </div>
  );
};

// Section Component (Updated)
const Section = ({
  section,
  index,
  activeEditorIndex,
  editors,
  showToolbar,
  editorWrapperRef,
  handleEditorCreatedByIndex,
  handleEditorFocus,
  handleCopyBelow,
  handleDelete,
  setContentSectionsState,
  setEditors,
  setActiveEditorIndex,
  setShowToolbar,
  setDropTargetIndex,
  handleAiAction,
  showImageOptionsAtIndex,
  setShowImageOptionsAtIndex,
  uploadImageToShopify,
  showToast, // Added to show error messages,
  shopOrigin,
  setIsImageLoading,
  setAiModalOpen,
  setIsAiLoading,
  articleLanguage,
  openResizeModal,
  openResizeModalImageAndText,
  createImageHtmlWithNaturalWidth,
  isActive,
  setResizeDropTargetIndex,
  setTargetNodePosition,
  targetNodePosition,
  shopify,
  shopCurrency,
  subscriptionPlan,
  blogsCount,
}) => {
  const fileInputRef = useRef(null);
  const popoverRef = useRef(null);
  const [isUrlModalOpen, setIsUrlModalOpen] = useState(false);
  const [isUrlImageTextModalOpen, setIsUrlImageTextModalOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [isAiModalOpen, setIsAiModalOpen] = useState(false);
  const [isAiModalOpenImageText, setIsAiModalOpenImageText] = useState(false);

  const [aiPrompt, setAiPrompt] = useState("");
  const [showProductOptionsAtIndex, setShowProductOptionsAtIndex] =
    useState(null);
  const [showProductGridOptionsAtIndex, setShowProductGridOptionsAtIndex] =
    useState(null);
  const [isProductModalOpen, setIsProductModalOpen] = useState(false);
  const [isProductGridModalOpen, setIsProductGridModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [products, setProducts] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState([]);
  const [isLoadingProducts, setIsLoadingProducts] = useState(false);
  const [pageInfo, setPageInfo] = useState({});
  const [nextCursor, setNextCursor] = useState(null);
  const [prevCursor, setPrevCursor] = useState(null);
  const [popoverActive, setPopoverActive] = useState(false);
  const [selectedSectionIndex, setSelectedSectionIndex] = useState(null);
  // const [insertedProductAtIndex, setInsertedProductAtIndex] = useState(null);
  // const [insertedProductGridAtIndex, setInsertedProductGridAtIndex] =
  // useState(null);
  // const [selectedVariant, setSelectedVariant] = useState(null);
  // const [isClicked, setIsClicked] = useState(false);

  const [isTableModalOpen, setIsTableModalOpen] = useState(false);
  const [tableRows, setTableRows] = useState(3);
  const [tableColumns, setTableColumns] = useState(3);
  const [selectedProductsData, setSelectedProductsData] = useState([]);

  const handleCreateTable = () => {
    // Generate table HTML manually since we need it for a new section
    const generateTableHTML = (rows, cols) => {
      let tableHTML = '<table width="100%" style="width: 100%;">';

      // Create header row
      tableHTML += "<thead><tr>";
      for (let j = 0; j < cols; j++) {
        tableHTML += `<th>Header ${j + 1}</th>`;
      }
      tableHTML += "</tr></thead>";

      // Create body rows
      tableHTML += "<tbody>";
      for (let i = 1; i < rows; i++) {
        // Start from 1 since header is row 0
        tableHTML += "<tr>";
        for (let j = 0; j < cols; j++) {
          tableHTML += `<td>Cell ${i}-${j + 1}</td>`;
        }
        tableHTML += "</tr>";
      }
      tableHTML += "</tbody></table>";

      return tableHTML;
    };

    const tableHTML = generateTableHTML(tableRows, tableColumns);

    // Create a new section (same pattern as other block types)
    setContentSectionsState((prevSections) => {
      const newSections = [...prevSections];
      newSections.splice(index + 1, 0, { id: uuid(), content: tableHTML });
      return newSections;
    });

    setEditors((prevEditors) => {
      const newEditors = [...prevEditors];
      newEditors.splice(index + 1, 0, null);
      return newEditors;
    });

    setTimeout(() => {
      setActiveEditorIndex(index + 1);
      setShowToolbar(true);
      setIsTableModalOpen(false);
    }, 100);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setPopoverActive(false);
      }
    };
    if (popoverActive) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popoverActive]);

  useEffect(() => {
    const handleUrlModalOpen = (e) => {
      const { sectionIndex, open, position } = e.detail;
      if (sectionIndex === index) {
        // // console.log("handleUrlModalOpen:", { sectionIndex, open, position });

        setIsUrlImageTextModalOpen(open);
        setResizeDropTargetIndex(sectionIndex);

        // If position is provided, use it; otherwise find the node
        if (position !== null && position !== undefined) {
          setTargetNodePosition(position);
        } else {
          // Find the imageWithTextBlock in current editor
          const currentEditor = editors[sectionIndex];
          if (currentEditor) {
            let foundPos = null;
            currentEditor.state.doc.descendants((node, pos) => {
              if (
                node.type.name === "imageWithTextBlock" &&
                foundPos === null
              ) {
                foundPos = pos;
                return false;
              }
            });
            setTargetNodePosition(foundPos);
          }
        }
      }
    };

    const handleAiModalOpen = (e) => {
      const { sectionIndex, open, position } = e.detail;
      if (sectionIndex === index) {
        // // console.log("handlegenerateModalOpen:", {
        //   sectionIndex,
        //   open,
        //   position,
        // });

        setIsAiModalOpenImageText(open);
        setResizeDropTargetIndex(sectionIndex);

        // If position is provided, use it; otherwise find the node
        if (position !== null && position !== undefined) {
          setTargetNodePosition(position);
        } else {
          // Find the imageWithTextBlock in current editor
          const currentEditor = editors[sectionIndex];
          if (currentEditor) {
            let foundPos = null;
            currentEditor.state.doc.descendants((node, pos) => {
              if (
                node.type.name === "imageWithTextBlock" &&
                foundPos === null
              ) {
                foundPos = pos;
                return false;
              }
            });
            setTargetNodePosition(foundPos);
          }
        }
      }
    };

    const handleEditorFocusEvent = (e) => {
      const { sectionIndex } = e.detail;
      if (sectionIndex === index) {
        setActiveEditorIndex(index);
        setShowToolbar(true);
      }
    };

    window.addEventListener("setIsUrlImageTextModalOpen", handleUrlModalOpen);
    window.addEventListener("setIsAiModalOpenImageText", handleAiModalOpen);
    window.addEventListener("editorFocus", handleEditorFocusEvent);

    return () => {
      window.removeEventListener(
        "setIsUrlImageTextModalOpen",
        handleUrlModalOpen
      );
      window.removeEventListener(
        "setIsAiModalOpenImageText",
        handleAiModalOpen
      );
      window.removeEventListener("editorFocus", handleEditorFocusEvent);
    };
  }, [index, editors]);

  const fetchProducts = async ({
    after = null,
    before = null,
    query = "",
  } = {}) => {
    setIsLoadingProducts(true);
    try {
      let url = `/api/get-product-card/?shop=${encodeURIComponent(shopOrigin)}`;
      if (after) url += `&after=${encodeURIComponent(after)}`;
      if (before) url += `&before=${encodeURIComponent(before)}`;
      if (query) url += `&query=${encodeURIComponent(query)}`;
      const response = await axios.get(url);
      if (response.data.status === "success") {
        setProducts(response.data.products || []);
        setPageInfo(response.data.pageInfo || {});
        setNextCursor(response.data.pageInfo?.endCursor || null);
        setPrevCursor(response.data.pageInfo?.startCursor || null);
      } else {
        showToast({
          content: response.data.message || "Failed to fetch products",
          error: true,
        });
        setProducts([]);
        setPageInfo({});
      }
    } catch (error) {
      console.error("Error fetching products:", error);
      showToast({ content: "We couldn't fetch products right now.", error: true });
      setProducts([]);
      setPageInfo({});
    } finally {
      setIsLoadingProducts(false);
    }
  };

  const debouncedFetchProducts = useRef(
    debounce((query) => {
      fetchProducts({ query });
    }, 300)
  ).current;

  const handleSearchChange = (value) => {
    setSearchQuery(value);
    setNextCursor(null);
    setPrevCursor(null);
    debouncedFetchProducts(value);
  };

  useEffect(() => {
    if (isProductModalOpen || isProductGridModalOpen) {
      fetchProducts();
    }
  }, [isProductModalOpen, isProductGridModalOpen, shopOrigin]);

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file || !file.type.startsWith("image/")) return;
    try {
      setIsImageLoading(true);
      const imageUrl = await uploadImageToShopify(file);
      const img = new window.Image();
      img.src = imageUrl;
      img.onload = () => {
        openResizeModal(imageUrl, img.naturalWidth, img.naturalHeight, index);
        setShowImageOptionsAtIndex(null);
      };
    } catch (error) {
      console.error("Upload failed", error);
      showToast({ content: "Failed to upload image", error: true });
    } finally {
      setIsImageLoading(false);
    }
  };

  const togglePopover = () => setPopoverActive((prev) => !prev);

  const handleBlockType = (type) => {
    if (type === "image-with-text") {
      // // console.log("found image with text block");
      const currentEditor = editors[index];
      if (!currentEditor) {
        console.error("No editor found at index:", index);
        return;
      }

      let insertedPosition = null;

      // Hook into the transaction to capture the inserted position
      const originalDispatchTransaction = currentEditor.view.dispatch;

      // // console.log("originalDispatchTransaction:");

      currentEditor.view.dispatch = (tr) => {
        // Find the inserted node in this transaction
        if (tr.docChanged) {
          tr.steps.forEach((step) => {
            if (step.slice && step.slice.content.size > 0) {
              step.slice.content.descendants((node, pos) => {
                if (node.type.name === "imageWithTextBlock") {
                  insertedPosition = step.from + pos;
                  // // console.log("Captured insertion position:", insertedPosition);
                }
              });
            }
          });
        }

        // Call the original dispatch
        originalDispatchTransaction(tr);

        // Restore original dispatch function
        currentEditor.view.dispatch = originalDispatchTransaction;

        // Set the position if we found it
        if (insertedPosition !== null) {
          setTimeout(() => {
            setTargetNodePosition(insertedPosition);
            // // console.log("Node position captured and set:", insertedPosition);
          }, 50);
        }
      };

      // Insert the content
      currentEditor
        .chain()
        .focus()
        .insertContent({
          type: "imageWithTextBlock",
          attrs: {
            image_url: "",
            image_alt: "",
            layout: "image-left",
            image_width: "50%",
            text_width: "50%",
          },
        })
        .run();

      setActiveEditorIndex(index);
      setShowToolbar(true);
      setPopoverActive(false);
    } else {
      // Handle generic block insertion
      const template = blockTemplates[type];
      if (!template) return;

      setPopoverActive(false);

      setContentSectionsState((prevSections) => {
        const newSections = [...prevSections];
        newSections.splice(index + 1, 0, { id: uuid(), content: template });
        return newSections;
      });

      setEditors((prevEditors) => {
        const newEditors = [...prevEditors];
        newEditors.splice(index + 1, 0, null);
        return newEditors;
      });

      setTimeout(() => {
        setActiveEditorIndex(index + 1);
        setShowToolbar(true);
      }, 100);
    }
  };

  const handleInsertProductBlock = (type) => {
    if (type === "card") {
      setShowProductOptionsAtIndex(index);
    } else if (type === "grid") {
      setShowProductGridOptionsAtIndex(index);
    }
  };

  const handleSelectProduct = () => {
    setIsProductModalOpen(true);
  };

  const handleSelectProductGrid = () => {
    setIsProductGridModalOpen(true);
  };

  const handleCloseProductModal = () => {
    setIsProductModalOpen(false);
    setSearchQuery("");
    setSelectedProductId([]);
    setProducts([]);
    setPageInfo({});
    setNextCursor(null);
    setPrevCursor(null);
  };

  const handleCloseProductGridModal = () => {
    setIsProductGridModalOpen(false);
    setSearchQuery("");
    setSelectedProductId([]);
    setProducts([]);
    setPageInfo({});
    setNextCursor(null);
    setPrevCursor(null);
  };

  
  const handleSelectProductFromModal = () => {
    if (!selectedProductId.length) {
      showToast({ content: "Please select a product", error: true });
      return;
    }

    const selectedProduct = products.find(
      (product) => product.product_id === selectedProductId[0]
    );

    if (!selectedProduct) {
      showToast({ content: "Selected product not found", error: true });
      return;
    }

    // Create HTML content for the product block instead of TipTap JSON
    // This matches what the parseHTML method in ProductBlock expects
    const productBlockHTML = `
      <div data-type="product-block" 
          data-product-id="${selectedProduct.product_id}"
          data-product-handle="${selectedProduct.product_handle || ''}"
          data-variants='${JSON.stringify(selectedProduct.variants || [])}'
          data-selected-variant-id="${selectedProduct.variants?.[0]?.variant_id || ''}"
          data-quantity="1"
          data-currency-symbol="${shopCurrency}">
        <div style="object-fit: cover; width: 50%; display: flex; align-items: center; justify-content: center;">
          <img src="${selectedProduct.product_image || `${shopifyAppUrl}/static/ImageNotAvailable.png`}" 
              alt="${selectedProduct.image_alt_text || 'Product image'}" 
              style="width: 50%; height: auto;" />
        </div>
        <div class="custom-product-button-block" 
            style="display: flex; flex-direction: column; flex: 1; padding: 15px; width: 100%; align-items: flex-start;text-align: left;">
          <a href="/products/${selectedProduct.product_handle}" 
            class="custom-product-button-block-title" 
            target="_blank" 
            style="font-size: 16px; font-weight: 600; text-decoration: none; color: black; margin: 8px 0; width:100%; line-height: 24px;">
            ${selectedProduct.product_title || "Product Title"}
          </a>
          <p class="product-card-vendor" style="margin: 0 0 15px; font-size: 14px; text-align: left;">
            ${selectedProduct.product_vendor || "No vendor"}
          </p>
          <p class="product-card-description" style="text-align: left; margin: 0 0 20px; line-height: 1.5; flex-grow: 1; overflow-y: auto; max-height: 150px; max-width: 300px; width: 100%;">
            ${DOMPurify.sanitize(selectedProduct.product_description || "No description")}
          </p>
          <!-- Other product content will be generated by the renderHTML method -->
        </div>
      </div>
    `;

    // Create a new section with HTML content
    const newSection = {
      id: uuid(),
      content: productBlockHTML,
    };

    // Insert the new section after the current index
    setContentSectionsState((prevSections) => {
      const updated = [...prevSections];
      updated.splice(index + 1, 0, newSection);
      return updated;
    });

    // Update editors to include a new editor instance for the new section
    setEditors((prevEditors) => {
      const updated = [...prevEditors];
      updated.splice(index + 1, 0, null); // Placeholder for the new editor
      return updated;
    });

    // Set the active editor to the new section and show the toolbar
    setTimeout(() => {
      setActiveEditorIndex(index + 1);
      setShowToolbar(true);
    }, 100);

    // Hide the product options UI and close the modal
    setShowProductOptionsAtIndex(null);
    handleCloseProductModal();
  };

  // ✅ UPDATE THIS FUNCTION
  const handleSelectProductGridFromModal = () => {
    if (!selectedProductId.length) {
      showToast({ content: "Please select at least one product", error: true });
      return;
    }

    // const selectedProducts = products.filter((product) =>
    //   selectedProductId.includes(product.product_id)
    // );

    if (!selectedProductsData.length) {
      showToast({ content: "Selected products not found", error: true });
      return;
    }

    // Create a valid Tiptap JSON content structure for ProductGridBlock
    const productGridBlockContent = {
      type: "doc",
      content: [
        {
          type: "productGridBlock",
          attrs: {
            products: selectedProductsData.map((product) => ({
              product_id: product.product_id,
              product_title: product.product_title,
              product_vendor: product.product_vendor,
              product_description: product.product_description,
              product_handle: product.product_handle,
              product_image: product.product_image,
              image_alt_text: product.image_alt_text || "",
              variants: product.variants || [],
              selected_variant_id: product.variants?.[0]?.variant_id || null,
              quantity: 1,
            })),
          },
        },
      ],
    };

    // Create a new section
    const newSection = {
      id: uuid(),
      content: productGridBlockContent,
    };

    // Insert the new section after the current index
    setContentSectionsState((prevSections) => {
      const updated = [...prevSections];
      updated.splice(index + 1, 0, newSection);
      return updated;
    });

    // Update editors to include a new editor instance for the new section
    setEditors((prevEditors) => {
      const updated = [...prevEditors];
      updated.splice(index + 1, 0, null); // Placeholder for the new editor
      return updated;
    });

    // Set the active editor to the new section and show the toolbar
    setTimeout(() => {
      setActiveEditorIndex(index + 1);
      setShowToolbar(true);
    }, 100);

    // Hide the product grid options UI and close the modal
    setShowProductGridOptionsAtIndex(null);
    handleCloseProductGridModal();
  };

  const blockTemplates = {
    heading: "<h1>Heading Text</h1>",
    paragraph: "<p>Start writing here...</p>",
    blockquote: "<blockquote>A famous quote here</blockquote>",
    // table: `
    //   <div style="padding: 5px;">
    //     <table>
    //       <tbody>
    //         <th>Row 1 Col 1</th><th>Row 1 Col 2</th>
    //         <tr><td>Row 2 Col 1</td><td>Row 2 Col 2</td></tr>
    //       </tbody>
    //     </table>
    //   </div>
    // `,
    bulletList: "<ul><li>List item 1</li><li>List item 2</li></ul>",
  };

  useEffect(() => {
    const handleOpenImageOptions = (event) => {
      if (event.detail.sectionIndex === index) {
        setShowImageOptionsAtIndex(index);
      }
    };

    window.addEventListener("openImageOptions", handleOpenImageOptions);
    return () => {
      window.removeEventListener("openImageOptions", handleOpenImageOptions);
    };
  }, [index]);
  const handleClick = () => {
    handleEditorFocus(index);
  };

  const handleImageClick = () => {
    setShowImageOptionsAtIndex(index);
  };

  useEffect(() => {
    const handleClick = (e) => {
      if (e.target.closest(".custom-product-button")) {
        e.preventDefault();
        setIsProductModalOpen(true);
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);

  const getLowestVariantPrice = (variants = []) => {
    const numericPrices = variants
      .map((v) => parseFloat(v.variant_price))
      .filter((p) => !isNaN(p));
    return numericPrices.length ? Math.min(...numericPrices).toFixed(2) : "N/A";
  };

  const customStyles = `
  .custom-product-block {
      border: 1px dashed #824c4c;
      background-color: #fafafa;
      padding: 16px;
      margin: 12px 0;
      text-align: center;
      border-radius: 8px;
      display: flex;
      align-items: center;
      width: 100%;
    }
    .custom-product-button-block {
      display: flex;
      flex-direction: column;
      flex: 1;
      padding: 15px;
      width: 100%;
      align-items: flex-start;
    }
    .custom-product-button-block .custom-product-button-block-title {
      line-height: 24px;
    }
    .custom-product-button-block-title {
      font-size: 16px;
      font-weight: 600;
      text-decoration: none;
      color: black;
    }
    .product-card-vendor {
      margin: 0 0 15px;
      font-size: 14px;
      width:100%; 
      height: 50px;
    }
    .product-card-description {
      text-align: left;
      margin: 0 0 20px;
      line-height: 1.5;
      flex-grow: 1;
      overflow-y: auto;
      max-height: 150px;
      max-width: 300px;
    }
    .custom-product-button-block .Polaris-Button {
      background-color: #4A4AF4;
      color: white;
    }
    .custom-product-button-block .Polaris-Button--variantSecondary {
      box-shadow: 0px 0px #4A4AF4;
    }
    .product-options {
      border: 1px dashed #ccc;
      padding: 10px;
      margin: 10px 0;
      background-color: #f9f9f9;
      border-radius: 4px;
      display: flex;
      gap: 10px;
      align-items: center;
      margin-top: 0px;
    }
    .image-options {
      width: 100%;
      border: 1px dashed #ccc;
      padding: 10px;
      margin: 10px 0;
      background-color: #f9f9f9;
      border-radius: 4px;
      display: flex;
      gap: 10px;
      align-items: center;
    }
    .custom-product-grid-block {
      border: 1px dashed #0070f3;
      background-color: #f0f8ff;
      padding: 16px;
      margin: 12px 0;
      text-align: center;
      border-radius: 8px;
    }
  `;

  return (
    <div
      key={`section-${index}`}
      style={{
        position: "relative",
        display: "flex",
        minHeight: "50px",
        width: "100",
        flexDirection: "column",
      }}
      onClick={() => handleEditorFocus(index)}
    >
      <style>{customStyles}</style>
      {isActive && (
        <div
          style={{
            position: "absolute",
            left: "-17px",
            top: "13px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "4px",
            zIndex: 100,
            // paddingRight: "5px"
          }}
          className="editor-hover-extra"
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <div>
              <Icon source={DragHandleIcon} tone="base" />
            </div>
            <Popover
              active={popoverActive}
              activator={
                <Button
                  plain
                  icon={<Icon source={PlusIcon} />}
                  onClick={(e) => {
                    e.stopPropagation();
                    togglePopover();
                  }}
                />
              }
              onClose={() => setPopoverActive(false)}
            >
              <ActionList
                items={[
                  {
                    content: "Heading",
                    icon: TextTitleIcon,
                    onAction: () => handleBlockType("heading"),
                  },
                  {
                    content: "Paragraph",
                    icon: TextBlockIcon,
                    onAction: () => handleBlockType("paragraph"),
                  },
                  {
                    content: "Quote",
                    icon: TextQuoteIcon,
                    onAction: () => handleBlockType("blockquote"),
                  },
                  {
                    content: "Table",
                    icon: DataTableIcon,
                    onAction: () => {
                      setIsTableModalOpen(true);
                      setPopoverActive(false);
                    },
                  },
                  {
                    content: "List",
                    icon: ListBulletedIcon,
                    onAction: () => handleBlockType("bulletList"),
                  },
                  {
                    content: "Product Card",
                    icon:
                      // subscriptionPlan === "free" && blogsCount <= 3
                      //   ? () => (
                      //       <Icon
                      //         source={LockIcon}
                      //         color="#FFD700"
                      //         title="Upgrade to unlock this feature"
                      //       />
                      //     )
                      //   :
                         ProductIcon,
                    onAction:
                      // subscriptionPlan === "free" && blogsCount <= 3
                      //   ? 
                        () =>{
                        //     showToast({
                        //       content: "Upgrade to unlock Product Card",
                        //       error: true,
                        //     })
                        // : () => {
                            handleInsertProductBlock("card");
                            setPopoverActive(false);
                          },
                  },
                  {
                    content: "Product Grid",
                    icon:
                      // subscriptionPlan === "free"
                      //   ? () => (
                      //       <Icon
                      //         source={LockIcon}
                      //         color="#FFD700"
                      //         title="Upgrade to unlock this feature"
                      //       />
                      //     )
                      //   : 
                        LayoutColumns3Icon,
                    onAction:
                      // subscriptionPlan === "free"
                      //   ? () =>
                      //       showToast({
                      //         content: "Upgrade to unlock Product Grid",
                      //         error: true,
                      //       })
                      //   : 
                        () => {
                            handleInsertProductBlock("grid");
                            setPopoverActive(false);
                          },
                  },
                  {
                    content: "Image with Text",
                    icon:
                      // subscriptionPlan === "free"
                      //   ? () => (
                      //       <Icon
                      //         source={LockIcon}
                      //         color="#FFD700"
                      //         title="Upgrade to unlock this feature"
                      //       />
                      //     )
                      //   : 
                        ImageWithTextOverlayIcon,
                    onAction:
                      // subscriptionPlan === "free"
                      //   ? () =>
                      //       showToast({
                      //         content: "Upgrade to unlock Image with Text",
                      //         error: true,
                      //       })
                      //   : 
                        () => {
                            const newSection = {
                              id: uuid(),
                              content: `<div data-type="image-with-text-block"></div>`,
                            };
                            setContentSectionsState((prevSections) => {
                              const updated = [...prevSections];
                              updated.splice(index + 1, 0, newSection);
                              return updated;
                            });
                            setEditors((prevEditors) => {
                              const updated = [...prevEditors];
                              updated.splice(index + 1, 0, null);
                              return updated;
                            });
                            setTimeout(() => {
                              setActiveEditorIndex(index + 1);
                              setShowToolbar(true);
                            }, 100);
                            setPopoverActive(false);
                          },
                  },
                ]}
              />
            </Popover>
            <Button
              plain
              icon={<Icon source={DuplicateIcon} />}
              onClick={(e) => {
                e.stopPropagation();
                handleCopyBelow(index);
              }}
            />
            <Button
              plain
              icon={<Icon source={DeleteIcon} />}
              onClick={() => handleDelete(index)}
            />
          </div>
        </div>
      )}
      <div
        ref={index === activeEditorIndex ? editorWrapperRef : null}
        style={{ padding: "10px 0px 0px 105px", flexGrow: 1, width: "100%" }}
        className={`editor-section ${
          activeEditorIndex === index ? "active-mobile" : ""
        }`}
        onClick={() => shopify.saveBar.show("my-save-bar")}
      >
        {activeEditorIndex === index && editors[index] && showToolbar && (
          <EditorToolbar
            editor={editors[index]}
            index={index}
            onAiAction={handleAiAction}
            onImageClick={handleImageClick}
            shopOrigin={shopOrigin}
            setIsAiLoading={setIsAiLoading}
            articleLanguage={articleLanguage}
            subscriptionPlan={subscriptionPlan}
            blogsCount={blogsCount}
          />
        )}
        <div style={{ pointerEvents: "auto" }} className="sectionsDiv">
          <EditorSection
            content={section}
            index={index}
            onEditorCreated={handleEditorCreatedByIndex}
            onFocus={() => handleEditorFocus(index)}
            shopCurrency={shopCurrency}
            subscriptionPlan={subscriptionPlan}
            blogsCount={blogsCount}
          />
        </div>
      </div>
      {showImageOptionsAtIndex === index && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
          className="image-options"
          onDragOver={(e) => e.preventDefault()}
          onDrop={async (e) => {
            e.preventDefault();
            e.stopPropagation();
            setDropTargetIndex(index);
            const file = e.dataTransfer.files[0];
            if (!file || !file.type.startsWith("image/")) return;
            try {
              setIsImageLoading(true);
              const imageUrl = await uploadImageToShopify(file);
              const img = new window.Image();
              img.src = imageUrl;
              img.onload = () => {
                openResizeModal(
                  imageUrl,
                  img.naturalWidth,
                  img.naturalHeight,
                  index
                );
                setShowImageOptionsAtIndex(null);
              };
            } catch (err) {
              console.error("Drag & drop upload failed", err);
              showToast({ content: "Failed to upload image", error: true });
            } finally {
              setIsImageLoading(false);
            }
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <div
              style={{ display: "flex", justifyContent: "center", gap: "10px" }}
            >
              <Button
                variant="primary"
                onClick={() => fileInputRef.current.click()}
                icon={<Icon source={UploadIcon} tone="base" />}
              >
                Upload Image
              </Button>
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                accept="image/*"
                onChange={handleImageUpload}
              />
              <Button
                variant="primary"
                icon={<Icon source={LinkIcon} tone="base" />}
                onClick={() => setIsUrlModalOpen(true)}
              >
                Insert from URL
              </Button>
              <Button
                variant="primary"
                icon={<Icon source={ImageMagicIcon} tone="base" />}
                onClick={() => setIsAiModalOpen(true)}
              >
                Generate with AI
              </Button>
            </div>
            <div>
              <p>
                Upload or drag an image file here, or pick one from your
                library.
              </p>
            </div>
          </div>
        </div>
      )}
      {showProductOptionsAtIndex === index && (
        <div
          className="product-options"
          style={{ display: "flex", justifyContent: "center", padding: "20px" }}
        >
          <Button
            variant="primary"
            onClick={handleSelectProduct}
            icon={<Icon source={ProductIcon} tone="base" />}
          >
            Select Product
          </Button>
        </div>
      )}

      {showProductGridOptionsAtIndex === index && (
        <div
          className="product-options"
          style={{ display: "flex", justifyContent: "center", padding: "20px" }}
        >
          <Button
            variant="primary"
            onClick={handleSelectProductGrid}
            icon={<Icon source={LayoutColumns3Icon} tone="base" />}
          >
            Select Product Grid
          </Button>
        </div>
      )}
      <Modal
        open={isProductModalOpen}
        onClose={handleCloseProductModal}
        title="Select product"
      >
        {isLoadingProducts && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(255,255,255,0.7)",
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Spinner accessibilityLabel="Loading products" size="large" />
          </div>
        )}
        <Modal.Section>
          <TextField
            icon={SearchIcon}
            label="Search products"
            value={searchQuery}
            onChange={handleSearchChange}
            placeholder="Search by product title"
            autoComplete="off"
          />
        </Modal.Section>
        <Modal.Section>
          <div style={{ maxHeight: 300, overflowY: "auto" }}>
            <LegacyStack vertical>
              {products.length > 0 ? (
                products.map((product) => (
                  <LegacyStack key={product.product_id} alignment="center">
                    <Checkbox
                      label=""
                      checked={selectedProductId.includes(product.product_id)}
                      disabled={
                        !selectedProductId.includes(product.product_id) &&
                        selectedProductId.length >= 1
                      }
                      onChange={() => {
                        if (selectedProductId.includes(product.product_id)) {
                          // Remove from both arrays - PROPERLY
                          const newSelectedIds = selectedProductId.filter(
                            (id) => id !== product.product_id
                          );
                          const newSelectedData = selectedProductsData.filter(
                            (p) => p.product_id !== product.product_id
                          );
                          
                          setSelectedProductId(newSelectedIds);
                          setSelectedProductsData(newSelectedData);
                          
                          console.log('After removal:', { newSelectedIds, newSelectedData });
                        } else if (selectedProductId.length < 1) {
                          // Add to both arrays - PROPERLY
                          const newSelectedIds = [...selectedProductId, product.product_id];
                          const newSelectedData = [...selectedProductsData, product];
                          
                          setSelectedProductId(newSelectedIds);
                          setSelectedProductsData(newSelectedData);
                          
                          console.log('After addition:', { newSelectedIds, newSelectedData });
                        }
                      }}
                    />
                    <Thumbnail
                      source={product.product_image || "No Image"}
                      alt={product.image_alt_text || product.product_title}
                      size="small"
                    />
                    <span>{product.product_title}</span>
                  </LegacyStack>
                ))
              ) : (
                <p>No products found</p>
              )}
            </LegacyStack>
          </div>
        </Modal.Section>
        <Modal.Section>
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <span>{selectedProductId.length}/1 Products Selected</span>
            <div style={{ display: "flex", gap: "8px" }}>
              <Button
                variant="primary"
                disabled={!pageInfo.hasPreviousPage}
                onClick={() =>
                  fetchProducts({ before: prevCursor, query: searchQuery })
                }
                icon={PaginationStartIcon}
              />
              <Button
                variant="primary"
                disabled={!pageInfo.hasNextPage}
                onClick={() =>
                  fetchProducts({ after: nextCursor, query: searchQuery })
                }
                icon={PaginationEndIcon}
              />
            </div>
            <div style={{ display: "flex", gap: "8px" }}>
              <Button onClick={handleCloseProductModal}>Cancel</Button>
              <Button
                variant="primary"
                onClick={handleSelectProductFromModal}
                disabled={selectedProductId.length === 0}
              >
                Select
              </Button>
            </div>
          </Box>
        </Modal.Section>
      </Modal>
      <Modal
        open={isProductGridModalOpen}
        onClose={handleCloseProductGridModal}
        title="Select product grid"
      >
        {isLoadingProducts && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(255,255,255,0.7)",
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Spinner accessibilityLabel="Loading Products" size="large" />
          </div>
        )}
        <Modal.Section>
          <TextField
            icon={SearchIcon}
            label="Search products"
            value={searchQuery}
            onChange={handleSearchChange}
            placeholder="Search products"
            autoComplete="off"
          />
        </Modal.Section>
        <Modal.Section>
          <div style={{ maxHeight: 300, overflowY: "auto" }}>
            <LegacyStack vertical>
              {products.length > 0 ? (
                products.map((product) => (
                  <LegacyStack key={product.product_id} alignment="center">
                    <Checkbox
                      label=""
                      checked={selectedProductId.includes(product.product_id)}
                      disabled={
                        !selectedProductId.includes(product.product_id) &&
                        selectedProductId.length >= 3
                      }
                      onChange={() => {
                        // console.log(`Toggling product ${product.product_id}`); // Debug log

                        if (selectedProductId.includes(product.product_id)) {
                          // Remove from both arrays
                          const newSelectedIds = selectedProductId.filter(
                            (id) => id !== product.product_id
                          );
                          const newSelectedData = selectedProductsData.filter(
                            (p) => p.product_id !== product.product_id
                          );
                          
                          setSelectedProductId(newSelectedIds);
                          setSelectedProductsData(newSelectedData);
                          
                          console.log('After removal:', { newSelectedIds, newSelectedData });
                        } else if (selectedProductId.length < 3) {
                          // Add to both arrays - PROPERLY
                          const newSelectedIds = [...selectedProductId, product.product_id];
                          const newSelectedData = [...selectedProductsData, product];
                          
                          setSelectedProductId(newSelectedIds);
                          setSelectedProductsData(newSelectedData);
                          
                          console.log('After addition:', { newSelectedIds, newSelectedData });
                        }
                      }}
                    />
                    <Thumbnail
                      source={product.product_image || "No Image"}
                      alt={product.image_alt_text || product.product_title}
                      size="small"
                    />
                    <span>{product.product_title}</span>
                  </LegacyStack>
                ))
              ) : (
                <p>No products found</p>
              )}
            </LegacyStack>
          </div>
        </Modal.Section>
        <Modal.Section>
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <span>{selectedProductId.length}/3 products selected</span>
            <div style={{ display: "flex", gap: "8px" }}>
              <Button
                variant="primary"
                disabled={!pageInfo.hasPreviousPage}
                onClick={() => {
                  // console.log("Fetching previous page"); // Debug log
                  fetchProducts({ before: prevCursor, query: searchQuery });
                }}
                icon={PaginationStartIcon}
              />
              <Button
                variant="primary"
                disabled={!pageInfo.hasNextPage}
                onClick={() => {
                  // console.log("Fetching next page"); // Debug log
                  fetchProducts({ after: nextCursor, query: searchQuery });
                }}
                icon={PaginationEndIcon}
              />
            </div>
            <div style={{ display: "flex", gap: "8px" }}>
              <Button onClick={handleCloseProductGridModal}>Cancel</Button>
              <Button
                variant="primary"
                onClick={() => {
                  // console.log("Select button clicked", { selectedProductId }); // Debug log
                  handleSelectProductGridFromModal();
                }}
                disabled={selectedProductId.length === 0}
              >
                Select
              </Button>
            </div>
          </Box>
        </Modal.Section>
      </Modal>
      <Modal
        open={isUrlModalOpen}
        onClose={() => setIsUrlModalOpen(false)}
        title="Insert Image from URL"
        primaryAction={{
          content: "Upload",
          onAction: async () => {
            if (!imageUrl) return;
            try {
              setIsImageLoading(true);
              const img = new window.Image();
              img.src = imageUrl;
              img.onload = () => {
                openResizeModal(
                  imageUrl,
                  img.naturalWidth,
                  img.naturalHeight,
                  index
                );
                setIsUrlModalOpen(false);
                setImageUrl("");
              };
            } finally {
              setIsImageLoading(false);
            }
          },
        }}
        secondaryActions={[
          { content: "Cancel", onAction: () => setIsUrlModalOpen(false) },
        ]}
      >
        <Modal.Section>
          <TextField
            label="Image URL"
            value={imageUrl}
            onChange={setImageUrl}
            placeholder="https://example.com/image.jpg"
            autoComplete="off"
          />
        </Modal.Section>
      </Modal>
      <Modal
        open={isAiModalOpen}
        onClose={() => setIsAiModalOpen(false)}
        title="Generate Image with AI"
        primaryAction={{
          content: "Generate",
          onAction: async () => {
            if (!aiPrompt.trim()) return;
            try {
              setIsImageLoading(true);
              const response = await axios.post(
                `/generate-image-ai/${shopOrigin}/`,
                { prompt: aiPrompt }
              );
              if (
                response.data.status === "success" &&
                response.data.image_url
              ) {
                const imageUrl = response.data.image_url;
                const img = new window.Image();
                img.src = imageUrl;
                img.onload = () => {
                  openResizeModal(
                    imageUrl,
                    img.naturalWidth,
                    img.naturalHeight,
                    index
                  );
                  setIsAiModalOpen(false);
                  setAiPrompt("");
                  setShowImageOptionsAtIndex(null);
                };
              } else {
                showToast({ content: "Image generation failed", error: true });
              }
            } catch (err) {
              console.error("AI image error:", err);
              showToast({ content: "We couldn't generate an image right now.", error: true });
            } finally {
              setIsImageLoading(false);
            }
          },
        }}
        secondaryActions={[
          { content: "Cancel", onAction: () => setIsAiModalOpen(false) },
        ]}
      >
        <Modal.Section>
          <TextField
            label="Prompt"
            value={aiPrompt}
            onChange={setAiPrompt}
            placeholder="Describe the image you want..."
            multiline
          />
        </Modal.Section>
      </Modal>
      <Modal
        open={isUrlImageTextModalOpen}
        onClose={() => setIsUrlImageTextModalOpen(false)}
        title="Insert Image from URL for Image Text Box"
        primaryAction={{
          content: "Upload",
          onAction: async () => {
            if (!imageUrl) return;
            try {
              setIsImageLoading(true);
              const img = new window.Image();
              img.src = imageUrl;
              img.onload = () => {
                // Pass targetNodePosition as the last argument
                openResizeModalImageAndText(
                  imageUrl,
                  img.naturalWidth,
                  img.naturalHeight,
                  index,
                  `${img.naturalWidth}px`,
                  `${img.naturalHeight}px`,
                  "center",
                  "contain",
                  "center",
                  targetNodePosition // <-- Add this to pass the known position
                ); // <-- Add this closing parenthesis
                setIsUrlImageTextModalOpen(false);
                setImageUrl("");
              };
              img.onerror = () => {
                showToast({ content: "Failed to load image", error: true });
                setIsImageLoading(false);
              };
            } catch (error) {
              console.error("Error loading image:", error);
              showToast({ content: "Failed to load image", error: true });
            } finally {
              setIsImageLoading(false);
            }
          },
        }}
        secondaryActions={[
          {
            content: "Cancel",
            onAction: () => setIsUrlImageTextModalOpen(false),
          },
        ]}
      >
        <Modal.Section>
          <TextField
            label="Image URL"
            value={imageUrl}
            onChange={setImageUrl}
            placeholder="https://example.com/image.jpg"
            autoComplete="off"
          />
        </Modal.Section>
      </Modal>

      <Modal
        open={isAiModalOpenImageText}
        onClose={() => setIsAiModalOpenImageText(false)}
        title="Generate Image with AI for Image with Text"
        primaryAction={{
          content: "Generate",
          onAction: async () => {
            if (!aiPrompt.trim()) return;
            try {
              setIsImageLoading(true);
              const response = await axios.post(
                `/generate-image-ai/${shopOrigin}/`,
                { prompt: aiPrompt }
              );
              if (
                response.data.status === "success" &&
                response.data.image_url
              ) {
                const imageUrl = response.data.image_url;
                const img = new window.Image();
                img.src = imageUrl;
                img.onload = () => {
                  openResizeModalImageAndText(
                    imageUrl,
                    img.naturalWidth,
                    img.naturalHeight,
                    index,
                    `${img.naturalWidth}px`,
                    `${img.naturalHeight}px`,
                    "center",
                    "contain",
                    "center",
                    targetNodePosition // <-- Add this to pass the known position
                  );
                  setIsAiModalOpenImageText(false);
                  setAiPrompt("");
                  setShowImageOptionsAtIndex(null);
                };
              } else {
                showToast({ content: "Image generation failed", error: true });
              }
            } catch (err) {
              console.error("AI image error:", err);
              showToast({ content: "We couldn't generate an image right now.", error: true });
            } finally {
              setIsImageLoading(false);
            }
          },
        }}
        secondaryActions={[
          {
            content: "Cancel",
            onAction: () => setIsAiModalOpenImageText(false),
          },
        ]}
      >
        <Modal.Section>
          <TextField
            label="Prompt"
            value={aiPrompt}
            onChange={setAiPrompt}
            placeholder="Describe the image you want..."
            multiline
          />
        </Modal.Section>
      </Modal>

      <Modal
        open={isTableModalOpen}
        onClose={() => setIsTableModalOpen(false)}
        title="Create Table"
        primaryAction={{
          content: "Create Table",
          onAction: handleCreateTable,
        }}
        secondaryActions={[
          {
            content: "Cancel",
            onAction: () => setIsTableModalOpen(false),
          },
        ]}
      >
        <Modal.Section>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <TextField
              label="Number of Rows"
              type="number"
              value={tableRows.toString()}
              onChange={(value) => {
                const num = parseInt(value) || 1;
                setTableRows(Math.max(1, Math.min(20, num))); // Limit between 1-20
              }}
              min={1}
              max={20}
              autoComplete="off"
            />
            <TextField
              label="Number of Columns"
              type="number"
              value={tableColumns.toString()}
              onChange={(value) => {
                const num = parseInt(value) || 1;
                setTableColumns(Math.max(1, Math.min(10, num))); // Limit between 1-10
              }}
              min={1}
              max={10}
              autoComplete="off"
            />
          </div>
        </Modal.Section>
      </Modal>
    </div>
  );
};

// EditBlogs Component (Updated)

const EditBlogs = ({ shopOrigin, apiKey, handleAiAction }) => {
  const shopify = useAppBridge();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const article = location.state?.article || {};
  const [articleData, setArticleData] = useState(article || {});
  const articleLanguage = location.state?.language || "English";
  const lowlight = createLowlight(common);
  const [isImageLoading, setIsImageLoading] = useState(false);
  const [aiModalOpen, setAiModalOpen] = useState(false);
  const editorWrapperRef = useRef(null);
  const modalRef = useRef(null);
  const [showToolbar, setShowToolbar] = useState(false);
  const [articleTitle, setArticleTitle] = useState(
    article.title || article.article_title || "Untitled"
  );
  const [showImageOptionsAtIndex, setShowImageOptionsAtIndex] = useState(null);
  const [toastActive, setToastActive] = useState(false);
  const [toastContent, setToastContent] = useState("");
  const [toastError, setToastError] = useState(false);
  const [isAiLoading, setIsAiLoading] = useState(false);
  const [isDateModalOpen, setIsDateModalOpen] = useState(false);
  const [isCloseModalOpen, setIsCloseModalOpen] = useState(false);
  const [scheduledTime, setScheduledTime] = useState("12:00");
  const [{ month, year }, setDate] = useState({
    month: new Date().getMonth(),
    year: new Date().getFullYear(),
  });
  const [selectedDates, setSelectedDates] = useState({
    start: new Date(),
    end: new Date(),
  });
  const [formattedScheduledTime, setFormattedScheduledTime] = useState("");
  const [scheduledDateTime, setScheduledDateTime] = useState(null);
  const [shopTimezone, setShopTimezone] = useState("UTC");
  const [isResizeModalOpen, setIsResizeModalOpen] = useState(false);
  const [isResizeTextModalOpen, setIsResizeTextModalOpen] = useState(false); // Fixed typo
  const [resizeImageUrl, setResizeImageUrl] = useState("");
  const [imageWidth, setImageWidth] = useState("");
  const [imageHeight, setImageHeight] = useState("");
  const [imageAlignment, setImageAlignment] = useState("center");
  const [objectFit, setObjectFit] = useState("contain");
  const [objectPosition, setObjectPosition] = useState("center");
  const [resizeDropTargetIndex, setResizeDropTargetIndex] = useState(null);
  const [naturalWidth, setNaturalWidth] = useState(null);
  const [naturalHeight, setNaturalHeight] = useState(null);
  const [verticalAlign, setVerticalAlign] = useState("center");
  const [horizontalAlign, setHorizontalAlign] = useState("center");
  const [imageWithTextBlockSwap, setImageWithTextBlockSwap] = useState(false);
  const [isNewResizeModalOpen, setIsNewResizeModalOpen] = useState(false);
  const [imagePosition, setImagePosition] = useState("image-left");
  const [targetNodePosition, setTargetNodePosition] = useState(null);
  const [isPublishing, setIsPublishing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isDiscardModalOpen, setIsDiscardModalOpen] = useState(false);

  const [subscriptionPlan, setSubscriptionPlan] = useState(null);
  const [blogsCount, setBlogsCount] = useState(0);

  // initial state of the editor content statess
  const [initialArticleTitle, setInitialArticleTitle] = useState("");
  const [initialContentSections, setInitialContentSections] = useState([]);
  const [initialSelectedBlogId, setInitialSelectedBlogId] = useState("");
  const [initialTags, setInitialTags] = useState([]);
  const [initialScheduledDateTime, setInitialScheduledDateTime] =
    useState(null);
  const [initialIsPublished, setInitialIsPublished] = useState(false);
  const [initialFormattedScheduledTime, setInitialFormattedScheduledTime] =
    useState("");

  // Updated showToast function for clarity
  const showToast = ({ content, error = false }) => {
    setToastContent(content);
    setToastError(error);
    setToastActive(true);
  };

  const MAX_SHOPIFY_TAGS = 250;
  const MAX_SHOPIFY_BLOG_TITLE = 255;

  const sanitizeSingleLineText = (value = "") =>
    String(value).replace(/[\r\n]+/g, " ").trim();

  const normalizeTagsForShopify = (rawTags = []) => {
    const unique = [];
    const seen = new Set();

    for (const tag of rawTags) {
      const cleaned = DOMPurify.sanitize(String(tag || "").trim());
      if (!cleaned) continue;
      if (cleaned.length > 255) continue;
      const key = cleaned.toLowerCase();
      if (seen.has(key)) continue;
      seen.add(key);
      unique.push(cleaned);
    }

    return unique;
  };

  const getPublishApiErrorMessage = (error) => {
    const responseData = error?.response?.data || {};
    const rawMessage =
      responseData.message ||
      responseData.error ||
      error?.message ||
      "Failed to save article.";
    const message = String(rawMessage);
    const lowered = message.toLowerCase();

    if (
      lowered.includes("article tags is invalid") ||
      lowered.includes("article tags")
    ) {
      return "Some tags are invalid. Use plain text tags and keep each tag short.";
    }

    if (
      lowered.includes("input array size") &&
      lowered.includes("maximum allowed of 250")
    ) {
      return "Too many tags. Shopify allows up to 250 tags per article.";
    }

    if (
      lowered.includes("title is too long") ||
      lowered.includes("maximum is 255 characters")
    ) {
      return "Blog title is too long. Keep the new blog title under 255 characters.";
    }

    if (
      lowered.includes("single line text string") ||
      lowered.includes("metafields")
    ) {
      return "SEO title/description must be a single line. Remove line breaks and try again.";
    }

    return message;
  };

  // Fetch subscription and blog count
  useEffect(() => {
    const fetchSubscriptionAndCount = async () => {
      try {
        // Fetch subscription plan
        const subscriptionRes = await axios.get(
          `/get_subscription/?shop_name=${encodeURIComponent(shopOrigin || "")}`
        );
        setSubscriptionPlan(subscriptionRes.data.plan || null);

        // Fetch blog count
        const countRes = await axios.get(
          `/api/get-subscription-blog-count/?shop=${encodeURIComponent(
            shopOrigin || ""
          )}`
        );
        setBlogsCount(countRes.data.blogs_count || 0);
      } catch (err) {
        console.error("Error fetching subscription or blog count:", err);
        setSubscriptionPlan(null);
        setBlogsCount(0);
      }
    };

    if (shopOrigin) {
      fetchSubscriptionAndCount();
    }
  }, [shopOrigin]);

  const imageSizeOptions = [
    { label: "Original Size", value: "original" },
    { label: "Inline Size (16px)", value: "16" },
    { label: "Icon (32px)", value: "32" },
    { label: "Thumbnail (50px)", value: "50" },
    { label: "Small (100px)", value: "100" },
    { label: "Logo (150px)", value: "150" },
    { label: "Product Thumbnail (240px)", value: "240" },
    { label: "Product Image (240px)", value: "240" },
    { label: "Banner Image (600px)", value: "600" },
    { label: "Wallpaper (100%)", value: "100%" },
  ];

  // Updated openResizeModal function to handle modal type
  const openResizeModal = (
    imageUrl,
    naturalWidth,
    naturalHeight,
    targetIndex = activeEditorIndex, // Default to activeEditorIndex if targetIndex is null
    width = `${naturalWidth}px`,
    height = `${naturalHeight}px`,
    alignment = "center",
    objectFit = "contain",
    objectPosition = "center"
  ) => {
    // // // console.log("openResizeModal called with targetIndex:", targetIndex); // Debug log
    setResizeImageUrl(imageUrl);
    setImageWidth(width);
    setImageHeight(height);
    setNaturalWidth(naturalWidth);
    setNaturalHeight(naturalHeight);
    setImageAlignment(alignment);
    setObjectFit(objectFit);
    setObjectPosition(objectPosition);
    setResizeDropTargetIndex(targetIndex); // Ensure this is set
    setIsResizeModalOpen(true);
  };

  const openResizeModalImageAndText = (
    imageUrl,
    naturalWidth,
    naturalHeight,
    targetIndex = activeEditorIndex,
    width = `${naturalWidth}px`,
    height = `${naturalHeight}px`,
    alignment = "center",
    objectFit = "contain",
    objectPosition = "center",
    nodePosition = null
  ) => {
    // // console.log("openResizeModalImageAndText called with:", {
    //   targetIndex,
    //   imageUrl,
    //   nodePosition,
    // });

    // Set basic image properties
    setResizeImageUrl(imageUrl);
    setImageWidth(width);
    setImageHeight(height);
    setNaturalWidth(naturalWidth);
    setNaturalHeight(naturalHeight);
    setImageAlignment(alignment);
    setObjectFit(objectFit);
    setObjectPosition(objectPosition);
    setResizeDropTargetIndex(targetIndex);
    setVerticalAlign("center");

    const currentEditor = editors[targetIndex];
    if (!currentEditor) {
      console.error("No editor found at index:", targetIndex);
      showToast({ content: "No editor found", error: true });
      return;
    }

    // If nodePosition is provided, use it directly and open the modal
    if (nodePosition !== null && nodePosition !== undefined) {
      // // console.log("Using provided nodePosition:", nodePosition);
      setTargetNodePosition(nodePosition);
      setIsResizeTextModalOpen(true);
      return;
    }

    // Otherwise, search for the node after a short delay
    setTimeout(() => {
      const findImageWithTextBlock = (state) => {
        let foundPos = null;
        let foundNode = null;

        // Search through the document for imageWithTextBlock nodes
        state.doc.descendants((node, pos) => {
          if (node.type.name === "imageWithTextBlock" && foundPos === null) {
            foundPos = pos;
            foundNode = node;
            return false; // Stop searching
          }
        });

        return foundPos !== null ? { pos: foundPos, node: foundNode } : null;
      };

      const result = findImageWithTextBlock(currentEditor.state);

      if (result) {
        // console.log("Found imageWithTextBlock at position:", result.pos);
        setTargetNodePosition(result.pos);
        setIsResizeTextModalOpen(true);
      } else {
        console.error("No imageWithTextBlock found");
        showToast({
          content:
            "No image with text block found. Please try creating the block first.",
          error: true,
        });
      }
    }, 500); // Keep the timeout as a fallback, but it should rarely be needed now
  };

  // Update handleImageResize to include new attributes
  // In EditBlogs component, replace the existing handleImageResize function (around line 1300)

  const handleImageResize = () => {
    let widthValue = "";
    let heightValue = "";

    // Width calculation
    if (imageWidth === "100%") {
      widthValue = "100%";
    } else if (imageWidth && !isNaN(parseInt(imageWidth))) {
      widthValue = `${parseInt(imageWidth)}px`;
    } else if (imageWidth === `${naturalWidth}px`) {
      widthValue = `${naturalWidth}px`;
    }

    // Height calculation
    if (imageHeight === "auto") {
      heightValue = "auto";
    } else if (imageHeight && !isNaN(parseInt(imageHeight))) {
      heightValue = `${parseInt(imageHeight)}px`;
    }

    // Prepare attributes for the ResizableImage extension
    const imageAttributes = {
      src: resizeImageUrl,
      alt: "Resized image",
      width: widthValue,
      height: heightValue,
      align: imageAlignment,
      objectFit: objectFit,
      objectPosition: objectPosition,
    };

    // Fallback style string for non-editor insertions
    const styleAttributes = `display: block; margin: ${
      imageAlignment === "center"
        ? "0 auto"
        : imageAlignment === "left"
        ? "0 auto 0 0"
        : "0 0 0 auto"
    }; object-fit: ${objectFit}; object-position: ${objectPosition}; width: ${widthValue}; height: ${heightValue};`;

    const imgHtml = `<img src="${resizeImageUrl}" alt="Resized image" style="${styleAttributes}" data-align="${imageAlignment}" data-object-fit="${objectFit}" data-object-position="${objectPosition}" />`;
    const sanitized = DOMPurify.sanitize(imgHtml);

    const targetIndex =
      resizeDropTargetIndex !== null
        ? resizeDropTargetIndex
        : activeEditorIndex;
    const currentEditor = editors[targetIndex] ?? null;
    const isDroppedInEditor =
      currentEditor !== null && resizeDropTargetIndex === null;
    const isDroppedBetweenSections = resizeDropTargetIndex !== null;

    if (isDroppedInEditor) {
      // Insert image inline in existing editor content
      currentEditor.chain().focus().setResizableImage(imageAttributes).run();
    } else if (isDroppedBetweenSections) {
      // Insert image as a new block between content sections
      const insertIndex = resizeDropTargetIndex + 1;
      setContentSectionsState((prev) => {
        const newSections = [...prev];
        newSections.splice(insertIndex, 0, {
          id: uuid(),
          content: sanitized,
        });
        return newSections;
      });

      setEditors((prev) => {
        const newEditors = [...prev];
        newEditors.splice(insertIndex, 0, null);
        return newEditors;
      });

      setActiveEditorIndex(insertIndex);
    } else {
      // Fallback: no editor, no drop target — add at end
      const fallbackIndex = activeEditorIndex ?? contentSectionsState.length;
      setContentSectionsState((prev) => {
        const newSections = [...prev];
        newSections.splice(fallbackIndex, 0, {
          id: uuid(),
          content: sanitized,
        });
        return newSections;
      });

      setEditors((prev) => {
        const newEditors = [...prev];
        newEditors.splice(fallbackIndex, 0, null);
        return newEditors;
      });

      setActiveEditorIndex(fallbackIndex);
    }

    // Reset UI state
    setTimeout(() => {
      setShowToolbar(true);
      setIsResizeModalOpen(false);
      setShowImageOptionsAtIndex(null);
      setResizeDropTargetIndex(null);
    }, 100);
  };

  const handleImageTextResize = () => {
    // console.log("handleImageTextResize called with:", {
    //   targetNodePosition,
    //   activeEditorIndex,
    //   resizeDropTargetIndex,
    // });

    // Validate we have a target position
    if (targetNodePosition === null || targetNodePosition === undefined) {
      console.error("No target node position provided");
      showToast({
        content: "Cannot update image: Position not found. Please try again.",
        error: true,
      });
      setIsResizeTextModalOpen(false);
      return;
    }

    let widthValue = "";
    let heightValue = "";

    if (imageWidth === "100%") {
      widthValue = "100%";
    } else if (imageWidth && !isNaN(parseInt(imageWidth))) {
      widthValue = `${parseInt(imageWidth)}px`;
    } else if (imageWidth === `${naturalWidth}px`) {
      widthValue = `${naturalWidth}px`;
    }

    if (imageHeight === "auto") {
      heightValue = "auto";
    } else if (imageHeight && !isNaN(parseInt(imageHeight))) {
      heightValue = `${parseInt(imageHeight)}px`;
    }

    const imageAttributes = {
      image_url: resizeImageUrl,
      image_alt: "Resized image",
      layout: imagePosition,
      image_width: widthValue,
      text_width: `calc(100% - ${widthValue})`,
    };

    const targetIndex =
      resizeDropTargetIndex !== null
        ? resizeDropTargetIndex
        : activeEditorIndex;
    const currentEditor = editors[targetIndex];

    if (!currentEditor) {
      console.error("No editor found at index:", targetIndex);
      showToast({ content: "No editor found", error: true });
      setIsResizeTextModalOpen(false);
      return;
    }

    try {
      const { state } = currentEditor;
      const node = state.doc.nodeAt(targetNodePosition);

      // console.log(targetNodePosition);
      // console.log(node);
      // console.log(node.type);
      // console.log(node.type.name);

      if (!node || node.type.name !== "imageWithTextBlock") {
        console.error("Invalid node at position:", targetNodePosition);
        showToast({
          content: "Cannot update: Invalid image block. Please try again.",
          error: true,
        });
        setIsResizeTextModalOpen(false);
        return;
      }

      // Calculate image attributes
      let widthValue =
        imageWidth === "100%"
          ? "100%"
          : imageWidth && !isNaN(parseInt(imageWidth))
          ? `${parseInt(imageWidth)}px`
          : `${naturalWidth}px`;

      const imageAttributes = {
        image_url: resizeImageUrl,
        image_alt: "Resized image",
        layout: imagePosition,
        image_width: widthValue,
        text_width: `calc(100% - ${widthValue})`,
        vertical_align: verticalAlign,
      };

      // Update the node
      currentEditor
        .chain()
        .focus()
        .command(({ tr }) => {
          // console.log(
          //   "Updating node at position:",
          //   targetNodePosition,
          //   "with attrs:",
          //   imageAttributes
          // );
          tr.setNodeMarkup(targetNodePosition, undefined, {
            ...node.attrs,
            ...imageAttributes,
          });
          return true;
        })
        .run();

      // Success cleanup
      setTimeout(() => {
        setShowToolbar(true);
        setIsResizeTextModalOpen(false);
        setShowImageOptionsAtIndex(null);
        setResizeDropTargetIndex(null);
        setTargetNodePosition(null);
        showToast({ content: "Image updated successfully!" });
      }, 100);
    } catch (error) {
      console.error("Error updating imageWithTextBlock:", error);
      showToast({ content: "Failed to update image block", error: true });
      setIsResizeTextModalOpen(false);
    }
  };

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dropTargetIndex, setDropTargetIndex] = useState(null);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [isGenerateMode, setIsGenerateMode] = useState(false);
  const [generatePrompt, setGeneratePrompt] = useState("");
  const [isGeneratingImage, setIsGeneratingImage] = useState(false);
  const [generatedPreviewUrl, setGeneratedPreviewUrl] = useState(null);
  const [sidebarPreviewUrl, setSidebarPreviewUrl] = useState(null);
  const [sidebarAltText, setSidebarAltText] = useState("");
  const [isSidebarDragging, setIsSidebarDragging] = useState(false);
  const [showEditOptions, setShowEditOptions] = useState(false);
  const [isAltModalOpen, setIsAltModalOpen] = useState(false);
  const [imagePopoverActive, setImagePopoverActive] = useState(false);
  const toggleImagePopover = () => setImagePopoverActive((p) => !p);
  const [seoTitle, setSeoTitle] = useState("");
  const [seoDescription, setSeoDescription] = useState("");
  const [urlHandle, setUrlHandle] = useState("");
  const [blogHandle, setBlogHandle] = useState("");

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const newSections = Array.from(contentSectionsState);
    const [movedItem] = newSections.splice(result.source.index, 1);
    newSections.splice(result.destination.index, 0, movedItem);
    setContentSectionsState(newSections);

    const newEditors = Array.from(editors);
    const [movedEditor] = newEditors.splice(result.source.index, 1);
    newEditors.splice(result.destination.index, 0, movedEditor);
    setEditors(newEditors);
  };

  useEffect(() => {
    if (scheduledDateTime && shopTimezone) {
      // Convert UTC datetime to local time instead of applying shop timezone
      const localTime = moment.utc(scheduledDateTime).local();
      setFormattedScheduledTime(localTime.format("DD MMMM YYYY, HH:mm"));
    } else {
      setFormattedScheduledTime("");
    }
  }, [scheduledDateTime, shopTimezone]);

  const [shopCurrency, setShopCurrency] = useState("$");

  useEffect(() => {
    const fetchShopCurrency = async () => {
      try {
        const response = await axios.get(
          `/api/get-shop-currency/?shop=${encodeURIComponent(shopOrigin)}`
        );
        // console.log("Full currency fetch response:", response); // Debug: Log full response
        if (
          response.data.status === "success" &&
          response.data.shop_currency_symbol
        ) {
          setShopCurrency(response.data.shop_currency_symbol);
          // console.log(
          //   "Fetched Shop Currency Symbol:",
          //   response.data.shop_currency_symbol
          // ); // Debug log
        } else {
          console.warn("Currency fetch failed, using default '$'");
          setShopCurrency("$");
        }
      } catch (error) {
        console.error(
          "Error fetching shop currency:",
          error.response || error.message
        ); // Detailed error log
        setShopCurrency("$");
      }
    };

    if (shopOrigin) {
      fetchShopCurrency();
    }
  }, [shopOrigin]);

  useEffect(() => {
    const fetchShopTimezone = async () => {
      try {
        const response = await axios.get(
          `/api/get-shop-timezone/?shop=${shopOrigin}`,
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        if (response.data.status === "success" && response.data.timezone) {
          setShopTimezone(response.data.timezone);
        } else {
          console.warn("No timezone found, defaulting to UTC");
          setShopTimezone("UTC");
        }
      } catch (error) {
        console.error("Error fetching shop timezone:", error);
        setShopTimezone("UTC");
        showToast({ content: "Failed to fetch shop timezone", error: true });
      }
    };

    if (shopOrigin) {
      fetchShopTimezone();
    }
  }, [shopOrigin]);

  const createImageHtmlWithNaturalWidth = (src, alt = "", className = "") =>
    new Promise((resolve) => {
      const img = new window.Image();
      img.onload = () => {
        const width = img.naturalWidth;
        const html = `<img src="${src}" alt="${alt}" width="${width}"${
          className ? ` class="${className}"` : ""
        } />`;
        resolve(html);
      };
      img.src = src;
    });

  const uploadImageToShopify = async (file) => {
    const formData = new FormData();
    formData.append("image", file);

    try {
      const response = await axios.post(
        `/upload-image/${shopOrigin}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "X-CSRFToken": document.querySelector("[name=csrfmiddlewaretoken]")
              ?.value,
          },
          withCredentials: true,
        }
      );

      if (response.data.status === "success" && response.data.image_url) {
        return response.data.image_url;
      } else {
        throw new Error(response.data.message || "Failed to upload image.");
      }
    } catch (error) {
      console.error("Image upload error:", error);
      showToast({
        content: "Failed to upload image. Please try again.",
        error: true,
      });
      return null;
    }
  };

  // Add this helper function inside EditBlogs if it's not already there
  const getNaturalWidth = (src) =>
    new Promise((resolve, reject) => {
      const img = new window.Image();
      img.onload = () => resolve(img.naturalWidth);
      img.onerror = reject;
      img.src = src;
    });

  // Updated handleImageDrop to specify modal type
  const handleImageDrop = async (e, index) => {
    e.preventDefault();
    setIsDragging(false);

    if (subscriptionPlan === "free" && blogsCount <= 3) {
      showToast({
        content: "Upgrade plan to unlock image drag-and-drop",
        error: true,
      });
      return;
    }
    const file = e.dataTransfer?.files?.[0];
    if (!file || !file.type.startsWith("image/")) {
      showToast({ content: "Please drop a valid image file.", error: true });
      return;
    }

    try {
      setIsImageLoading(true);
      const imageUrl = await uploadImageToShopify(file);
      if (!imageUrl) {
        setIsImageLoading(false);
        return;
      }

      const img = new window.Image();
      img.src = imageUrl;
      img.onload = () => {
        if (editors[dropTargetIndex] && editors[dropTargetIndex].isFocused) {
          editors[dropTargetIndex]
            .chain()
            .focus()
            .setImage({
              src: imageUrl,
              alt: "Dropped image",
              width: `${img.naturalWidth}px`,
            })
            .run();
        } else {
          openResizeModal(
            imageUrl,
            img.naturalWidth,
            img.naturalHeight,
            dropTargetIndex,
            `${img.naturalWidth}px`,
            `${img.naturalHeight}px`,
            "center",
            "contain",
            "center",
            "center",
            "center",
            false,
            "image" // Specify 'image' modal for drag-and-drop
          );
        }
      };
    } catch (error) {
      console.error("Drag & drop upload failed", error);
      showToast({
        content: "Failed to upload image. Please try again.",
        error: true,
      });
    } finally {
      setIsImageLoading(false);
    }
  };

  // Function to handle image options selection (e.g., from image-options panel)

  const [articleId, setArticleId] = useState(article?.article_id || "");
  const [autoPublishToggle, setAutoPublishToggle] = useState(false);

  const parseArticleBodyToSections = (rawHtml) => {
    if (!rawHtml || typeof rawHtml !== "string" || rawHtml.trim() === "") {
      return ["<p>Start writing here...</p>"];
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(rawHtml, "text/html");
    const sections = Array.from(doc.body.children).map(
      (child) => child.outerHTML
    );

    if (sections.length === 0 && doc.body.textContent.trim()) {
      return [`<p>${doc.body.textContent.trim()}</p>`];
    }

    if (sections.length === 0) {
      return ["<p>Start writing here...</p>"];
    }

    return sections;
  };

  const isDateInFuture = (date, timezone) => {
    if (!date) return false;

    if (timezone === "local") {
      // Use local time comparison
      const now = new Date();
      const targetDate = new Date(date);
      return targetDate > now;
    }

    // Keep existing logic for shop timezone
    const isOffsetString = /^[+-]\d{4}$/.test(timezone);
    let now, targetDate;

    if (isOffsetString) {
      now = moment().utcOffset(timezone);
      targetDate = moment(date).utcOffset(timezone);
    } else {
      now = moment().tz(timezone);
      targetDate = moment.tz(date, timezone);
    }

    return targetDate.isAfter(now);
  };

  useEffect(() => {
    const articleIdFromParams = searchParams.get("article_id");
    if (!location.state?.article && articleIdFromParams && shopOrigin) {
      const fetchArticle = async () => {
        setIsLoading(true);
        try {
          const response = await axios.get(
            `/api/get-article-id?shop=${shopOrigin}&article_id=${articleIdFromParams}`,
            {
              headers: { "Content-Type": "application/json" },
            }
          );
          const fetchedArticle = response.data.article;
          if (fetchedArticle) {
            setArticleData(fetchedArticle);
            setArticleId(fetchedArticle.article_id);
            setArticleTitle(fetchedArticle.article_title || "Untitled");
            setSelectedBlogId(fetchedArticle.blog_id || "");
            setTags(fetchedArticle.keywords || []);
            // If article has an image from Shopify, show it in the sidebar
            if (fetchedArticle.image_url) {
              setSidebarPreviewUrl(fetchedArticle.image_url);
              setSidebarAltText(fetchedArticle.image_alt || "");
            }
            setSeoTitle(fetchedArticle.seo_title || fetchedArticle.article_title || "");
            setSeoDescription(fetchedArticle.seo_description || "");
            setUrlHandle(fetchedArticle.article_handle || "");
            setBlogHandle(fetchedArticle.blog_handle || "");

            setInitialArticleTitle(fetchedArticle.article_title || "Untitled");
            setInitialSelectedBlogId(fetchedArticle.blog_id || "");
            setInitialTags(fetchedArticle.keywords || []); // Create a copy
            setInitialIsPublished(!!fetchedArticle.published);

            if (fetchedArticle.updated_at) {
              updateLastSavedTime(fetchedArticle.updated_at);
            } else {
              // For new articles without updated_at, use current time
              updateLastSavedTime(new Date().toISOString());
            }

            if (fetchedArticle.published_at) {
              const utcDateTime = moment.utc(fetchedArticle.published_at);
              const localDateTime = new Date(fetchedArticle.published_at); // Convert to user's local time

              setScheduledDateTime(utcDateTime.format("YYYY-MM-DDTHH:mm:ss"));
              setSelectedDates({
                start: localDateTime,
                end: localDateTime,
              });
              setScheduledTime(moment(localDateTime).format("HH:mm"));
              setDate({
                month: localDateTime.getMonth(),
                year: localDateTime.getFullYear(),
              });
              setFormattedScheduledTime(
                moment(localDateTime).format("DD MMMM YYYY, HH:mm")
              );

              // Store initial scheduling values
              setInitialScheduledDateTime(
                utcDateTime.format("YYYY-MM-DDTHH:mm:ss")
              );
              setInitialFormattedScheduledTime(
                moment(localDateTime).format("DD MMMM YYYY, HH:mm")
              );

              setIsPublished(
                !isDateInFuture(fetchedArticle.published_at, "local")
              );
            } else {
              setInitialScheduledDateTime(null);
              setInitialFormattedScheduledTime("");
              setIsPublished(!!fetchedArticle.published);
            }

            const raw = fetchedArticle.article_body || "";
            const newContentSections = parseArticleBodyToSections(raw);
            setContentSectionsState(
              newContentSections.map((content) => ({ id: uuid(), content }))
            );

            // Store initial content sections
            setInitialContentSections(
              newContentSections.map((content) => ({ id: uuid(), content }))
            );
          } else {
            console.error("No article found in response");
            setError("Article not found");
            showToast({ content: "Article not found", error: true });
          }
        } catch (err) {
          console.error(
            "Error fetching article:",
            err.response?.data || err.message
          );
          setError("Failed to load article");
          showToast({ content: "Failed to load article", error: true });
        } finally {
          setIsLoading(false);
        }
      };
      fetchArticle();
    } else if (location.state?.article) {
      setArticleData(location.state.article);
      setArticleId(location.state.article.article_id);
      setArticleTitle(
        location.state.article.article_title ||
          location.state.article.title ||
          "Untitled"
      );
      setSelectedBlogId(location.state.article.blog_id || "");
      setTags(
        location.state.article.keywords || location.state.article.tags || []
      );
      // If article passed via route state contains image info, populate sidebar
      if (location.state.article.image_url) {
        setSidebarPreviewUrl(location.state.article.image_url);
        setSidebarAltText(location.state.article.image_alt || "");
      }
      setSeoTitle(location.state.article.seo_title || location.state.article.article_title || "");
      setSeoDescription(location.state.article.seo_description || "");
      setUrlHandle(location.state.article.article_handle || "");
      setBlogHandle(location.state.article.blog_handle || "");

      // Store initial values
      setInitialArticleTitle(
        article.article_title || article.title || "Untitled"
      );
      setInitialSelectedBlogId(location.state.article.blog_id || "");
      setInitialTags(
        location.state.article.keywords || location.state.article.tags || []
      );
      setInitialIsPublished(!!location.state.article.published);

      // Set last saved time - either from article or current time for new articles
      if (location.state.article.updated_at) {
        updateLastSavedTime(location.state.article.updated_at);
      } else {
        // For new generated articles without updated_at, use current time
        updateLastSavedTime(new Date().toISOString());
      }

      if (location.state.article.published_at) {
        const utcDateTime = moment.utc(location.state.article.published_at);
        const localDateTime = new Date(location.state.article.published_at); // Convert to user's local time

        setScheduledDateTime(utcDateTime.format("YYYY-MM-DDTHH:mm:ss"));
        setSelectedDates({
          start: localDateTime,
          end: localDateTime,
        });
        setScheduledTime(moment(localDateTime).format("HH:mm"));
        setDate({
          month: localDateTime.getMonth(),
          year: localDateTime.getFullYear(),
        });
        setFormattedScheduledTime(
          moment(localDateTime).format("DD MMMM YYYY, HH:mm")
        );
        setIsPublished(
          !isDateInFuture(location.state.article.published_at, "local")
        );
      } else {
        setIsPublished(!!location.state.article.published);
      }

      const raw =
        location.state.article.article_body ||
        location.state.article.content ||
        "";
      const newContentSections = parseArticleBodyToSections(raw);
      setContentSectionsState(
        newContentSections.map((content) => ({ id: uuid(), content }))
      );
      setInitialContentSections(
        newContentSections.map((content) => ({ id: uuid(), content }))
      );
    }
  }, [location.state, searchParams, shopOrigin, shopTimezone]);

  // Separate useEffect for updating last saved time
  useEffect(() => {
    if (articleData?.updated_at && shopTimezone) {
      updateLastSavedTime(articleData.updated_at);
    }
  }, [articleData, shopTimezone]);

  const contentSections = useMemo(() => {
    const raw = articleData.content || articleData.article_body || "";
    return parseArticleBodyToSections(raw);
  }, [articleData.content, articleData.article_body]);

  const [editors, setEditors] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [tagInput, setTagInput] = useState("");
  const [showTagInput, setShowTagInput] = useState(false);
  const [showNewBlogInput, setShowNewBlogInput] = useState(false);
  const [activeEditorIndex, setActiveEditorIndex] = useState(null);
  const [modalActive, setModalActive] = useState(false);
  const [lastSavedTime, setLastSavedTime] = useState("");
  const [isDragging, setIsDragging] = useState(false);
  const [tags, setTags] = useState([]);
  const [selectedBlogId, setSelectedBlogId] = useState(article.blog_id || "");
  const [newBlogTitle, setNewBlogTitle] = useState("");
  const [isPublished, setIsPublished] = useState(!!article.published);

  const [contentSectionsState, setContentSectionsState] = useState(
    contentSections.map((html) => ({ id: uuid(), content: html }))
  );

  const handleEditorCreatedByIndex = useCallback((editor, idx) => {
    setEditors((prev) => {
      if (prev[idx] === editor) return prev;
      const updated = [...prev];
      updated[idx] = editor;
      return updated;
    });
  }, []);

  const handleCopyBelow = (index) => {
    const currentEditor = editors[index];
    const currentContent = currentEditor
      ? currentEditor.getHTML()
      : contentSectionsState[index].content;

    setContentSectionsState((prev) => {
      const newSections = [...prev];
      const duplicated = { id: uuid(), content: currentContent };
      newSections.splice(index + 1, 0, duplicated);
      return newSections;
    });

    setEditors((prev) => {
      const newEditors = [...prev];
      newEditors.splice(index + 1, 0, null);
      return newEditors;
    });

    setTimeout(() => {
      setActiveEditorIndex(index + 1);
      setShowToolbar(true);
    }, 100);
  };

  const handleDelete = (index) => {
    if (contentSectionsState.length === 1) return;

    const newSections = contentSectionsState.filter((_, i) => i !== index);
    setContentSectionsState(newSections);

    setEditors((prevEditors) => {
      const newEditors = prevEditors.filter((_, i) => i !== index);
      return newEditors;
    });

    setActiveEditorIndex((prevIndex) => {
      if (prevIndex === index) {
        return index > 0 ? index - 1 : 0;
      } else if (prevIndex > index) {
        return prevIndex - 1;
      }
      return prevIndex;
    });
  };

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get(`/api/get-blogs/?shop=${shopOrigin}`);
        const { status, blogs } = response.data;
        if (status === "success") {
          setBlogs(blogs);
        } else {
          console.error("Error fetching blogs:", response.data.message);
          setBlogs([]);
          showToast({ content: "Failed to fetch blogs", error: true });
        }
      } catch (error) {
        console.error("Error fetching blogs:", error);
        setBlogs([]);
        showToast({ content: "Failed to fetch blogs", error: true });
      }
    };

    if (shopOrigin) {
      fetchBlogs();
    }
  }, [shopOrigin]);

  useEffect(() => {
    if (article.updated_at) {
      updateLastSavedTime(article.updated_at);
    }
  }, [article.updated_at]);

  const updateLastSavedTime = (updatedAt) => {
    if (!updatedAt) {
      setLastSavedTime("Unknown");
      return;
    }

    // Parse the UTC time from updatedAt
    const utcTime = moment.utc(updatedAt);

    // Convert UTC time to user's local time zone by removing fixed utcOffset usage
    const localTime = utcTime.local();

    // Format with seconds included
    const formattedTime = localTime.format("DD MMMM YYYY, HH:mm:ss");

    setLastSavedTime(formattedTime);
  };

  const handleEditorFocus = useCallback((index) => {
    setActiveEditorIndex(index);
    setShowToolbar(true);
  }, []);

  const extractTitle = () => {
    return articleTitle || "Untitled";
  };

  const extractBody = () => {
    const content = editors
      .map((editor, index) => {
        if (!editor) return "";
        let html = editor.getHTML();

        // Clean up any duplicate images in ImageWithTextBlock content
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        // For ImageWithTextBlock nodes, ensure images only appear in image sections
        const imageTextBlocks = doc.querySelectorAll(
          '[data-type="image-with-text-block"]'
        );
        imageTextBlocks.forEach((block) => {
          const textContent = block.querySelector(".text-content");
          if (textContent) {
            // Remove any img elements from text content to prevent duplication
            const imgElements = textContent.querySelectorAll("img");
            imgElements.forEach((img) => img.remove());
          }
        });

        // NEW: Clean up paragraph tags within list items
        const listItems = doc.querySelectorAll("li");
        listItems.forEach((li) => {
          // Check if the li contains only one paragraph as its direct child
          const paragraphs = li.querySelectorAll(":scope > p");
          if (paragraphs.length === 1) {
            const p = paragraphs[0];
            // Move all paragraph content directly to the li
            while (p.firstChild) {
              li.insertBefore(p.firstChild, p);
            }
            // Remove the empty paragraph tag
            p.remove();
          }
        });

        const anchorTags = doc.querySelectorAll("a");
        anchorTags.forEach((anchor) => {
          anchor.setAttribute("target", "_blank");
        });

        return DOMPurify.sanitize(doc.body.innerHTML);
      })
      .filter((section) => section.trim())
      .join("\n\n");

    return (
      content ||
      article.content ||
      article.article_body ||
      "<p>No content available.</p>"
    );
  };

  const handlePreview = () => {
    setModalActive(true);
  };

  const handleNewPreview = async () => {
    const domain = shopOrigin;
    const blogHandle = articleData?.blog_handle;
    const articleHandle = articleData?.article_handle;
    shopify.saveBar.show("my-save-bar");

    if (!domain || !blogHandle) {
      console.error("Missing required parameters for preview");
      showToast({
        content: "Cannot preview: Save the article first.",
        error: true,
      });
      return;
    }

    if (isPublished === true) {
      // this is for the article which are published or true
      const previewUrl = `https://${domain}/blogs/${blogHandle}/${articleHandle}`;
      window.open(previewUrl, "_blank");
    } else {
      if (!articleId || !shopOrigin) {
        showToast({
          content: "Cannot preview: Save the article first.",
          error: true,
        });
        return;
      }

      const previewUrl = `/app/blog-preview/${shopOrigin}/${articleId}/`;
      window.open(previewUrl, "_blank");
    }
  };

  const handlePublish = async () => {
    const title = extractTitle();
    const body = extractBody();
    let status = isPublished ? "publish" : "draft";
    let scheduled_datetime = null;
    // console.log("scheduledDateTime for blogs: ", scheduledDateTime)
    // console.log("isPublished for blogs: ", isPublished)
    // console.log("scheduled_datetime: ", scheduled_datetime)

    if (isPublished && !scheduledDateTime) {
      // console.log("inside if")
      // console.log("scheduled_datetime: ", scheduled_datetime)
      // console.log("scheduledDateTime for blogs: ", scheduledDateTime)
      status = "publish";
      scheduled_datetime = null;
      // console.log("scheduled_datetime: ", scheduled_datetime)
    } else if (isPublished && scheduledDateTime) {
      // console.log("inside first else if 1st")
      // console.log("scheduled_datetime: ", scheduled_datetime)
      // console.log("scheduledDateTime for blogs: ", scheduledDateTime)
      status = "publish";
      scheduled_datetime = null;
      // console.log("scheduled_datetime: ", scheduled_datetime)
    } else if (!isPublished && scheduledDateTime) {
      // console.log("inside first else if 2nd")
      // console.log("scheduled_datetime: ", scheduled_datetime)
      // console.log("scheduledDateTime for blogs: ", scheduledDateTime)
      status = "draft";
      scheduled_datetime = scheduledDateTime;
      // console.log("scheduled_datetime: ", scheduled_datetime)
    } else {
      // console.log("inside else")
      status = "draft";
    }

    const normalizedTags = normalizeTagsForShopify(tags);
    if (normalizedTags.length > MAX_SHOPIFY_TAGS) {
      showToast({
        content: "Too many tags. Shopify allows up to 250 tags per article.",
        error: true,
      });
      return;
    }

    if (
      selectedBlogId === "new" &&
      newBlogTitle &&
      newBlogTitle.trim().length > MAX_SHOPIFY_BLOG_TITLE
    ) {
      showToast({
        content: "Blog title is too long. Keep it under 255 characters.",
        error: true,
      });
      return;
    }

    const data = {
      article_id: articleId,
      article_title: title,
      article_content: body,
      status,
      blog_id: selectedBlogId,
      new_blog_title:
        showNewBlogInput && newBlogTitle ? newBlogTitle : undefined,
      tags: normalizedTags,
      scheduled_datetime: scheduled_datetime,
      auto_publish_toggle: isPublished,
    };

    // Always include image fields so backend knows about removals.
    // sidebarPreviewUrl === null means the user explicitly removed the image.
    data.image_url = sidebarPreviewUrl || null;
    data.image_alt = sidebarAltText || "";

    // SEO fields
    data.seo_title = sanitizeSingleLineText(seoTitle || "");
    data.seo_description = sanitizeSingleLineText(seoDescription || "");
    data.summary = seoDescription || "";  // map meta description → Shopify summary
    data.url_handle = urlHandle || "";

    if (selectedBlogId === "new" && newBlogTitle) {
      data.new_blog_title = newBlogTitle;
    }

    try {
      setIsPublishing(true);

      const response = await axios.post(
        `/publish-article/${shopOrigin}/`,
        data,
        {
          headers: {
            "X-CSRFToken": document.querySelector("[name=csrfmiddlewaretoken]")
              ?.value,
          },
          withCredentials: true,
        }
      );

      if (response.data.status === "success") {
        const newArticleId = response.data.article_id?.replace(
          "gid://shopify/Article/",
          ""
        );

        // const formattedTime = moment.utc(updatedAt).local().format('DD MMMM YYYY, HH:mm:ss');
        // setLastSavedTime(formattedTime);

        const updatedAt = response.data.updated_at; // e.g., '2025-08-26T06:21:42Z'
        if (updatedAt) {
          const formattedDate = moment
            .utc(updatedAt)
            .local()
            .format("DD MMMM YYYY, HH:mm:ss");
          setLastSavedTime(formattedDate); // Store formatted string, e.g., '26 August 2025, 02:25:42'
        }

        showToast({
          content: `Article ${
            status === "publish" ? "published" : "saved as draft"
          } successfully!`,
        });

        setTimeout(() => {
          shopify.saveBar.hide("my-save-bar");
          setIsPublishing(false);
          window.location.href = `/edit-blogs?shop=${encodeURIComponent(
            shopOrigin
          )}&article_id=${newArticleId}`;
        }, 1500);
      }
    } catch (error) {
      console.error("Publish error:", error);
      showToast({
        content: getPublishApiErrorMessage(error),
        error: true,
      });
      setIsPublishing(false);
    }
  };

  const addTag = (e) => {
    if (e.key === "Enter" && tagInput.trim()) {
      e.preventDefault();
      const sanitizedTag = DOMPurify.sanitize(tagInput.trim());
      setTags([...tags, sanitizedTag]);
      setTagInput("");
      setShowTagInput(false);
    }
  };

  const removeTag = (tagToRemove) => {
    setTags(tags.filter((tag) => tag !== tagToRemove));
  };

  const handleBlogChange = (value) => {
    setSelectedBlogId(value);
    setShowNewBlogInput(value === "new");
    if (value !== "new") {
      setNewBlogTitle("");
    }
  };

  // 👈 Handle date and time selection
  const handleSetVisibilityDate = () => {
    const [hours, minutes] = scheduledTime.split(":");
    const updatedDate = new Date(selectedDates.start);

    if (isNaN(updatedDate.getTime())) {
      console.error("Invalid date selected");
      showToast({ content: "Invalid date selected", error: true });
      return;
    }

    // Set local hours and minutes from user input
    updatedDate.setHours(parseInt(hours, 10), parseInt(minutes, 10));

    // Convert the local Date object to a moment instance
    const momentDate = moment(updatedDate);

    // Convert to UTC string for storage
    const utcDateTime = momentDate.utc().format("YYYY-MM-DDTHH:mm:ss");

    // Format for display in local time
    const localFormatted = momentDate.format("DD MMMM YYYY, HH:mm");

    setScheduledDateTime(utcDateTime);
    setIsPublished(!isDateInFuture(updatedDate, "local"));
    setFormattedScheduledTime(localFormatted);
    setIsDateModalOpen(false);
    shopify.saveBar.show("my-save-bar");
  };

  const customStyles = `
    .custom-select1 {
      width: 100%;
      padding: 8px;
      border: 1px solid #dfe3e8;
      border-radius: 4px;
      font-size: 14px;
      margin-bottom: 16px;
    }
    .custom-select1:focus {
      outline: none;
      border-color: #008060;
      box-shadow: 0 0 0 2px rgba(0, 128, 96, 0.2);
    }
    .tag-input {
      width: 100%;
      padding: 8px;
      border: 1px solid #dfe3e8;
      border-radius: 4px;
      font-size: 14px;
    }
    .tag-input:focus {
      outline: none;
      border-color: #008060;
      box-shadow: 0 0 0 2px rgba(0, 128, 96, 0.2);
    }
    .edit-blogs-title-div .Polaris-TextField__Input {
      font-size: 20px !important;
      font-weight: bold;
    }
    .Polaris-Card, .edit-blogs-card {
      overflow: visible !important;
    }
    
    
    .editor-section {
      word-wrap: break-word;
      overflow-wrap: break-word;
      padding: 10px 0px 0px 105px;
    }
    .image-options {
      width: 100%;
      border: 1px dashed #ccc;
      padding: 10px;
      margin: 10px 0;
      background-color: #f9f9f9;
      border-radius: 4px;
      display: flex;
      gap: 10px;
      align-items: center;
    }
    img[data-align="center"] {
      display: block !important;
      margin: 0 auto !important;
    }
    img[data-align="left"] {
      display: block !important;
      margin: 0 auto 0 0 !important;
    }
    img[data-align="right"] {
      display: block !important;
      margin: 0 0 0 auto !important;
    }
    .threefourth {
      max-width: 75% !important;
    }
    .oneFourth {
      max-width: 25% !important;
    }
    .PreviewMainModa{
      max-width: 80%;
    }
    .previewModal p{
      padding-bottom: 10px;
    }
    @media only screen and (max-width: 75em){
      .threefourth{
        max-width: 100% !important;
    }
    .oneFourth{
        max-width: 100% !important;
      }
    }
    @media (max-width: 712px) {
      .Polaris-Frame__Content {
        transform: translate(0px, 0px) !important;
        margin: 0 15px;
      }
      
      /* Make the header stack on mobile */
      .edit-blogs-MainDiv {
        flex-direction: column !important;
        align-items: flex-start !important;
        gap: 15px;
      }
      
      // .edit-blogs-MainDiv .Polaris-ButtonGroup {
      //   width: 100%;
      //   flex-direction: column;
      // }
      
      .edit-blogs-MainDiv .Polaris-ButtonGroup .Polaris-ButtonGroup__Item {
        // width: 100%;
      }
      
      .edit-blogs-MainDiv .Polaris-ButtonGroup .Polaris-Button {
        width: 100%;
        justify-content: center;
      }
    }
    @media (max-width:30.6225em){
       .Polaris-ButtonGroup{
        flex-direction: row;
      }
      // .Polaris-ButtonGroup__Item{
      //   width:100%;
      // }
      // .Polaris-Button--textAlignCenter{
      //   width:100%;
      // }
      
      /* Additional spacing for very small screens */
      .edit-blogs-MainDiv {
        gap: 12px;
      }
    }

    // product grid block
    .custom-product-grid-block-preview {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 20px;
      padding: 20px;
      background: #f9f9f9;
      border: 1px dashed #ccc;
      border-radius: 8px;
      overflow-x: auto;
    }

    @media (max-width: 1024px) {
      .custom-product-grid-block-preview {
        grid-template-columns: repeat(2, 1fr);
        gap: 15px;
        padding: 15px;
      }
    }
    @media screen and (max-width: 768px) {
      .ProseMirror, 
      .editor-section, 
      input, 
      textarea, 
      select {
        font-size: 16px !important; /* Crucial: 16px prevents iOS/Android zoom */
      }
      
      /* 2. Handle your Padding Logic */
      .editor-section {
        padding: 10px 0px 0px 0px !important;
        transition: padding 0.2s ease;
      }
      
      .editor-section.active-mobile {
        padding: 10px 0px 0px 105px !important;
      }
    }

    @media (max-width: 768px) {
      .custom-product-grid-block-preview {
        grid-template-columns: 1fr;
        gap: 15px;
        padding: 15px;
      }
    }

    .product-grid-item-preview {
      text-align: center;
      padding: 16px;
      border-radius: 6px;
      border: 1px solid #e0e0e0;
      background: #ffffff;
    }

    .product-image-container-preview {
      object-fit: cover;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      max-height: 100%;
      height: 268px;
    }

    @media (max-width: 768px) {
      .editor-section {
        padding: 10px 0px 0px 0px !important; /* Remove left padding on mobile by default */
        transition: padding 0.2s ease; /* Optional: Smooth transition */
      }

      .editor-section.active-mobile {
        padding: 10px 0px 0px 105px !important; /* Add padding back when active */
      }
      .product-image-container-preview {
        height: 200px;
      }
    }

    .product-content-preview {
      display: flex;
        flex-direction: column;
      flex: 1;
      padding: 15px;
      width: 100%;
      align-items: flex-start;
      text-align: left;
    }

    .product-title-preview {
      font-size: 16px;
      font-weight: 600;
      text-decoration: none;
      color: black;
      margin: 8px 0;
      line-height: 24px;
    }

    .product-vendor-preview {
      margin: 0 0 15px;
      font-size: 14px;
      width: 100%;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    .product-description-preview {
      text-align: left;
      margin: 0 0 20px;
      line-height: 1.5;
      flex-grow: 1;
      overflow-y: auto;
      max-height: 150px;
      width: 100%;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    .product-options-preview {
      border: 1px dashed #ccc;
      padding: 10px;
      margin: 10px 0;
      background-color: #f9f9f9;
      border-radius: 4px;
      width: 100%;
      margin-top: 0px;
    }

    .quantity-selector-preview {
      display: flex;
      align-items: center;
      gap: 8px;
      margin: 10px 0;
      width: 100%;
      justify-content: space-between;
    }

    .quantity-btn-preview {
      padding: 5px 10px;
      border: 1px solid #ccc;
    
      cursor: pointer;
      border-radius: 5px;
    }

    .quantity-input-preview {
      width: 100%;
      text-align: center;
      border: 0.1px solid #d1d1d1;
      border-radius: 5px;
    }

    .add-to-cart-btn-preview {
      background-color: #4A4AF4;
      color: white;
      width: 100%;
      border: none;
      padding: 10px;
      border-radius: 4px;
      cursor: pointer;
    }
  `;

  const handleSave = async () => {
    const title = extractTitle();
    const body = extractBody();
    let status = "draft";
    let scheduled_datetime = scheduledDateTime ? scheduledDateTime : null;

    const normalizedTags = normalizeTagsForShopify(tags);
    if (normalizedTags.length > MAX_SHOPIFY_TAGS) {
      showToast({
        content: "Too many tags. Shopify allows up to 250 tags per article.",
        error: true,
      });
      return;
    }

    if (
      selectedBlogId === "new" &&
      newBlogTitle &&
      newBlogTitle.trim().length > MAX_SHOPIFY_BLOG_TITLE
    ) {
      showToast({
        content: "Blog title is too long. Keep it under 255 characters.",
        error: true,
      });
      return;
    }

    const data = {
      article_id: articleId,
      article_title: title,
      article_content: body,
      status,
      blog_id: selectedBlogId,
      new_blog_title:
        showNewBlogInput && newBlogTitle ? newBlogTitle : undefined,
      tags: normalizedTags,
      scheduled_datetime,
      auto_publish_toggle: false,
      // Always send image fields so backend handles removal correctly
      image_url: sidebarPreviewUrl || null,
      image_alt: sidebarAltText || "",
      // SEO fields
      seo_title: sanitizeSingleLineText(seoTitle || ""),
      seo_description: sanitizeSingleLineText(seoDescription || ""),
      summary: seoDescription || "",
      url_handle: urlHandle || "",
    };

    if (selectedBlogId === "new" && newBlogTitle) {
      data.new_blog_title = newBlogTitle;
    }

    try {
      setIsSaving(true);

      const response = await axios.post(
        `/publish-article/${shopOrigin}/`,
        data,
        {
          headers: {
            "X-CSRFToken": document.querySelector("[name=csrfmiddlewaretoken]")
              ?.value,
          },
          withCredentials: true,
        }
      );

      if (response.data.status === "success") {
        const newArticleId = response.data.article_id?.replace(
          "gid://shopify/Article/",
          ""
        );

        const updatedAt = response.data.updated_at;
        if (updatedAt) {
          const formattedDate = moment
            .utc(updatedAt)
            .local()
            .format("DD MMMM YYYY, HH:mm:ss");
          setLastSavedTime(formattedDate);
        }

        showToast({
          content: "Article saved as draft successfully!",
        });

        setTimeout(() => {
          shopify.saveBar.hide("my-save-bar");
          setIsSaving(false);
          window.location.href = `/edit-blogs?shop=${encodeURIComponent(
            shopOrigin
          )}&article_id=${newArticleId}`;
        }, 1500);
      }
    } catch (error) {
      console.error("Save error:", error);
      showToast({
        content: getPublishApiErrorMessage(error),
        error: true,
      });
      setIsSaving(false);
    }
  };

  const handleSaveDashboard = async () => {
    const title = extractTitle();
    const body = extractBody();
    let status = "draft";
    let scheduled_datetime = scheduledDateTime ? scheduledDateTime : null;

    const normalizedTags = normalizeTagsForShopify(tags);
    if (normalizedTags.length > MAX_SHOPIFY_TAGS) {
      showToast({
        content: "Too many tags. Shopify allows up to 250 tags per article.",
        error: true,
      });
      return;
    }

    if (
      selectedBlogId === "new" &&
      newBlogTitle &&
      newBlogTitle.trim().length > MAX_SHOPIFY_BLOG_TITLE
    ) {
      showToast({
        content: "Blog title is too long. Keep it under 255 characters.",
        error: true,
      });
      return;
    }

    const data = {
      article_id: articleId,
      article_title: title,
      article_content: body,
      status,
      blog_id: selectedBlogId,
      new_blog_title:
        showNewBlogInput && newBlogTitle ? newBlogTitle : undefined,
      tags: normalizedTags,
      scheduled_datetime,
      auto_publish_toggle: false,
      // Always send image fields so backend handles removal correctly
      image_url: sidebarPreviewUrl || null,
      image_alt: sidebarAltText || "",
      // SEO fields
      seo_title: sanitizeSingleLineText(seoTitle || ""),
      seo_description: sanitizeSingleLineText(seoDescription || ""),
      summary: seoDescription || "",
      url_handle: urlHandle || "",
    };

    if (selectedBlogId === "new" && newBlogTitle) {
      data.new_blog_title = newBlogTitle;
    }

    try {
      setIsSaving(true);

      const response = await axios.post(
        `/publish-article/${shopOrigin}/`,
        data,
        {
          headers: {
            "X-CSRFToken": document.querySelector("[name=csrfmiddlewaretoken]")
              ?.value,
          },
          withCredentials: true,
        }
      );

      if (response.data.status === "success") {
        const newArticleId = response.data.article_id?.replace(
          "gid://shopify/Article/",
          ""
        );

        const updatedAt = response.data.updated_at;
        if (updatedAt) {
          const formattedDate = moment
            .utc(updatedAt)
            .local()
            .format("DD MMMM YYYY, HH:mm:ss");
          setLastSavedTime(formattedDate);
        }

        showToast({
          content: "Article saved as draft successfully!",
        });

        // Hide save bar and close modal before navigation
        shopify.saveBar.hide("my-save-bar");
        setIsDiscardModalOpen(false);
        setIsSaving(false);

        // Navigate after a short delay
        setTimeout(() => {
          navigate(`/dashboard?shop=${encodeURIComponent(shopOrigin || "")}`);
        }, 500);
      }
    } catch (error) {
      console.error("Save error:", error);
      showToast({
        content: getPublishApiErrorMessage(error),
        error: true,
      });
      setIsSaving(false);
    }
  };

  const handleDiscard = () => {
    // console.log("Discarding changes, reverting to initial state");
    // handleNavigateDashboard(true);
    // Reset all states to initial values
    setArticleTitle(initialArticleTitle);
    setSelectedBlogId(initialSelectedBlogId);
    setTags([...initialTags]); // Create a copy
    setIsPublished(initialIsPublished);
    setScheduledDateTime(initialScheduledDateTime);
    setFormattedScheduledTime(initialFormattedScheduledTime);

    // Reset content sections
    setContentSectionsState(
      initialContentSections.map((section) => ({
        id: uuid(), // Generate new IDs to force re-render
        content: section.content,
      }))
    );

    // Reset editors array
    setEditors([]);
    setActiveEditorIndex(null);

    // Reset any other form states
    setTagInput("");
    setShowTagInput(false);
    setShowNewBlogInput(false);
    setNewBlogTitle("");

    // Reset scheduling UI states
    setSelectedDates({
      start: new Date(),
      end: new Date(),
    });
    setScheduledTime("12:00");
    setDate({
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
    });
    shopify.saveBar.hide("my-save-bar");
    showToast({ content: "Changes discarded successfully!" });
    // Don't navigate here - let the modal handler do it
  };

  const handleNavigateDashboard = () => {
    // event.preventDefault?.();
    setIsDiscardModalOpen(true);
  };

  useEffect(() => {
    const handlePopState = (e) => {
      // Prevent back navigation and show SaveBar instead of modal
      e.preventDefault();

      // Show the SaveBar to let user save or discard
      shopify.saveBar.show("my-save-bar");

      // Push state back to prevent navigation
      window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", handlePopState);

    // Push current state to prevent immediate back navigation
    window.history.pushState(null, "", window.location.href);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [shopify]);

  return (
    <>
      <SaveModal
        open={isDiscardModalOpen}
        onClose={() => setIsDiscardModalOpen(false)}
        onSave={() => {
          handleSaveDashboard();
          // Don't close modal or navigate here - let handleSaveDashboard handle it
        }}
        onDiscard={() => {
          handleDiscard();
          setIsDiscardModalOpen(false);
          // Navigate immediately for discard
          navigate(`/dashboard?shop=${encodeURIComponent(shopOrigin || "")}`);
        }}
        articleTitle={articleTitle}
      />
      {isPublishing && (
        <div
          style={{
            position: "fixed", // Fixed positioning to stay in place
            top: 0, // Top edge of the viewport
            left: 0, // Left edge of the viewport
            width: "100vw", // Full viewport width
            height: "100vh", // Full viewport height
            background: "rgba(255,255,255,0.7)", // Semi-transparent background
            zIndex: 9999, // Make sure the spinner is on top
            display: "flex", // Use flexbox to center the spinner
            justifyContent: "center", // Center horizontally
            alignItems: "center", // Center vertically
          }}
        >
          <div style={{ textAlign: "center" }}>
            <Spinner accessibilityLabel={isPublished ? "Publishing article" : "Saving as draft"} size="large" />
            <p style={{ marginTop: 10 }}>{isPublished ? "Publishing article..." : "Saving as draft..."}</p>
          </div>
        </div>
      )}
      {isSaving && (
        <div
          style={{
            position: "fixed", // Fixed positioning to stay in place
            top: 0, // Top edge of the viewport
            left: 0, // Left edge of the viewport
            width: "100vw", // Full viewport width
            height: "100vh", // Full viewport height
            background: "rgba(255,255,255,0.7)", // Semi-transparent background
            zIndex: 9999, // Make sure the spinner is on top
            display: "flex", // Use flexbox to center the spinner
            justifyContent: "center", // Center horizontally
            alignItems: "center", // Center vertically
          }}
        >
          <div style={{ textAlign: "center" }}>
            <Spinner accessibilityLabel="Saving article" size="large" />
            <p style={{ marginTop: 10 }}>Saving article...</p>
          </div>
        </div>
      )}
      {isLoading ? (
        <div
          style={{
            position: "fixed", // Fixed positioning to stay in place
            top: 0, // Top edge of the viewport
            left: 0, // Left edge of the viewport
            width: "100vw", // Full viewport width
            height: "100vh", // Full viewport height
            background: "rgba(255,255,255,0.7)", // Semi-transparent background
            zIndex: 9999, // Make sure the spinner is on top
            display: "flex", // Use flexbox to center the spinner
            justifyContent: "center", // Center horizontally
            alignItems: "center", // Center vertically
          }}
        >
          <div style={{ textAlign: "center" }}>
            <Spinner accessibilityLabel="Loading article" size="large" />
            <PolarisText variant="bodyMd" as="p" style={{ marginTop: "10px" }}>
              Loading article...
            </PolarisText>
          </div>
        </div>
      ) : (
        <>
          {isAiLoading && (
            <div
              style={{
                position: "fixed", // Fixed positioning to stay in place
                top: 0, // Top edge of the viewport
                left: 0, // Left edge of the viewport
                width: "100vw", // Full viewport width
                height: "100vh", // Full viewport height
                background: "rgba(255,255,255,0.7)", // Semi-transparent background
                zIndex: 9999, // Make sure the spinner is on top
                display: "flex", // Use flexbox to center the spinner
                justifyContent: "center", // Center horizontally
                alignItems: "center", // Center vertically
              }}
            >
              <div style={{ textAlign: "center" }}>
                <Spinner
                  accessibilityLabel="AI is rewriting content"
                  size="large"
                />
                <p style={{ marginTop: 10 }}>AI is rewriting content...</p>
              </div>
            </div>
          )}
          {isImageLoading && (
            <div
              style={{
                position: "fixed", // Fixed positioning to stay in place
                top: 0, // Top edge of the viewport
                left: 0, // Left edge of the viewport
                width: "100vw", // Full viewport width
                height: "100vh", // Full viewport height
                background: "rgba(255,255,255,0.7)", // Semi-transparent background
                zIndex: 9999, // Make sure the spinner is on top
                display: "flex", // Use flexbox to center the spinner
                justifyContent: "center", // Center horizontally
                alignItems: "center", // Center vertically
              }}
            >
              <div style={{ textAlign: "center" }}>
                <Spinner accessibilityLabel="Uploading image" size="large" />
                <p style={{ marginTop: 10 }}>Uploading image...</p>
              </div>
            </div>
          )}
          <Page fullWidth>
            {toastActive && (
              <Toast
                content={toastContent}
                error={toastError}
                onDismiss={() => setToastActive(false)}
              />
            )}
            <SaveBar id="my-save-bar">
              <button variant="primary" onClick={handleSave}></button>
              <button onClick={handleDiscard}></button>
            </SaveBar>
            <style>{customStyles}</style>
            <div
              className="Polaris-Page-Header edit-blogs-MainDiv"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <LegacyStack distribution="equalSpacing">
                <div>
                  <PolarisText variant="headingXl" as="p">
                    Edit Blog
                    <span
                      style={{
                        fontSize: "12px",
                        color: "#637381",
                        paddingLeft: "5px",
                      }}
                    >
                      Last Saved:{" "}
                      <span id="last-saved-time">{lastSavedTime}</span>
                    </span>
                  </PolarisText>
                </div>
              </LegacyStack>
              <ButtonGroup>
                {/* <Button
                  onClick={() =>
                    navigate(
                      `/dashboard?shop=${encodeURIComponent(shopOrigin || "")}`
                    )
                  }
                >
                  Dashboard
                </Button> */}
                <Button
                  onClick={(event) => {
                    event.preventDefault();
                    handleNavigateDashboard();
                  }}
                >
                  Dashboard
                </Button>
                <Button onClick={handleNewPreview} variant="secondary">
                  Preview
                </Button>
                <Button onClick={handlePublish} variant="primary">
                  {isPublished ? "Publish" : "Draft"}
                </Button>
                <Button
                  onClick={() => setIsDateModalOpen(true)}
                  variant="secondary"
                >
                  Schedule
                </Button>
                <Button
                  variant="secondary"
                  onClick={() => setIsCloseModalOpen(true)}
                >
                  X
                </Button>
              </ButtonGroup>
            </div>
            <div className="Polaris-Page__Content">
              <div className="Polaris-Layout">
                <div className="Polaris-Layout__Section Polaris-Layout__Section--twoThirds threefourth">
                  <Card sectioned className="edit-blogs-card">
                    <div
                      className="edit-blogs-title-div"
                      onFocus={() => shopify.saveBar.show("my-save-bar")}
                    >
                      <TextField
                        style={{ fontSize: "28px" }}
                        className="title-input"
                        value={articleTitle}
                        as="h1"
                        onChange={setArticleTitle}
                        autoComplete="off"
                        placeholder="Enter article title"
                      />
                    </div>
                    <div
                      onDragOver={(e) => {
                        e.preventDefault();
                        setIsDragging(true);
                      }}
                      onDragLeave={() => setIsDragging(false)}
                      onDrop={(e) => {
                        setIsDragging(false);
                        handleImageDrop(e);
                        setShowImageOptionsAtIndex(null);
                      }}
                      style={{
                        padding: "0px",
                      }}
                    >
                      {contentSectionsState.length === 0 ? (
                        <PolarisText variant="bodyMd" as="p">
                          No content available.
                        </PolarisText>
                      ) : (
                        <DragDropContext onDragEnd={handleDragEnd}>
                          <Droppable droppableId="sections">
                            {(provided) => (
                              <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                              >
                                {contentSectionsState.map((section, index) => (
                                  <Draggable
                                    key={section.id}
                                    draggableId={section.id}
                                    index={index}
                                  >
                                    {(provided) => (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                      >
                                        <Section
                                          section={section.content}
                                          shopify={shopify}
                                          index={index}
                                          activeEditorIndex={activeEditorIndex}
                                          editors={editors}
                                          showToolbar={showToolbar}
                                          editorWrapperRef={editorWrapperRef}
                                          handleEditorCreatedByIndex={
                                            handleEditorCreatedByIndex
                                          }
                                          handleEditorFocus={handleEditorFocus}
                                          handleCopyBelow={handleCopyBelow}
                                          handleDelete={handleDelete}
                                          setContentSectionsState={
                                            setContentSectionsState
                                          }
                                          setEditors={setEditors}
                                          setActiveEditorIndex={
                                            setActiveEditorIndex
                                          }
                                          setShowToolbar={setShowToolbar}
                                          setDropTargetIndex={
                                            setDropTargetIndex
                                          }
                                          handleAiAction={handleAiAction}
                                          showImageOptionsAtIndex={
                                            showImageOptionsAtIndex
                                          }
                                          setShowImageOptionsAtIndex={
                                            setShowImageOptionsAtIndex
                                          }
                                          uploadImageToShopify={
                                            uploadImageToShopify
                                          }
                                          showToast={showToast}
                                          shopOrigin={shopOrigin}
                                          setIsImageLoading={setIsImageLoading}
                                          setAiModalOpen={setAiModalOpen}
                                          setIsAiLoading={setIsAiLoading}
                                          articleLanguage={articleLanguage}
                                          createImageHtmlWithNaturalWidth={
                                            createImageHtmlWithNaturalWidth
                                          }
                                          openResizeModal={openResizeModal}
                                          setResizeDropTargetIndex={
                                            setResizeDropTargetIndex
                                          }
                                          setTargetNodePosition={
                                            setTargetNodePosition
                                          }
                                          openResizeModalImageAndText={
                                            openResizeModalImageAndText
                                          }
                                          isActive={index === activeEditorIndex}
                                          targetNodePosition={
                                            targetNodePosition
                                          }
                                          shopCurrency={shopCurrency}
                                          subscriptionPlan={subscriptionPlan}
                                          blogsCount={blogsCount}
                                        />
                                      </div>
                                    )}
                                  </Draggable>
                                ))}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                        </DragDropContext>
                        // contentSectionsState.map(({ id, content }, index) => (
                        //   <React.Fragment key={id}>
                        //     <Section
                        //       section={content}
                        //       index={index}
                        //       activeEditorIndex={activeEditorIndex}
                        //       editors={editors}
                        //       showToolbar={showToolbar}
                        //       editorWrapperRef={editorWrapperRef}
                        //       handleEditorCreatedByIndex={
                        //         handleEditorCreatedByIndex
                        //       }
                        //       handleEditorFocus={handleEditorFocus}
                        //       handleCopyBelow={handleCopyBelow}
                        //       handleDelete={handleDelete}
                        //       setContentSectionsState={setContentSectionsState}
                        //       setEditors={setEditors}
                        //       setActiveEditorIndex={setActiveEditorIndex}
                        //       setShowToolbar={setShowToolbar}
                        //       setDropTargetIndex={setDropTargetIndex}
                        //       handleAiAction={handleAiAction}
                        //       showImageOptionsAtIndex={showImageOptionsAtIndex}
                        //       setShowImageOptionsAtIndex={
                        //         setShowImageOptionsAtIndex
                        //       }
                        //       uploadImageToShopify={uploadImageToShopify}
                        //       showToast={showToast}
                        //       shopOrigin={shopOrigin}
                        //       setIsImageLoading={setIsImageLoading}
                        //       setAiModalOpen={setAiModalOpen}
                        //       setIsAiLoading={setIsAiLoading}
                        //       articleLanguage={articleLanguage}
                        //       createImageHtmlWithNaturalWidth={
                        //         createImageHtmlWithNaturalWidth
                        //       }
                        //     />
                        //   </React.Fragment>
                        // ))
                      )}
                    </div>
                  </Card>
                  <Modal
                    open={isImageModalOpen}
                    onClose={() => {
                      setIsImageModalOpen(false);
                      setIsGenerateMode(false);
                      setGeneratePrompt("");
                      setGeneratedPreviewUrl(null);
                      setIsGeneratingImage(false);
                    }}
                    title="Add or generate image"
                  >
                    {/* Blur backdrop when generate mode is active */}
                    <style>{isGenerateMode ? '.Polaris-Modal-Section { filter: blur(0); } .Polaris-Modal__Body { backdrop-filter: blur(4px); }' : ''}</style>
                    <Modal.Section>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "12px",
                        }}
                      >
                        <div
                          style={{
                            border: "1px dashed #dfe3e8",
                            borderRadius: "8px",
                            padding: "18px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            minHeight: "160px",
                            position: "relative",
                            background: "#fff",
                          }}
                          onDragOver={(e) => e.preventDefault()}
                          onDrop={async (e) => {
                            e.preventDefault();
                            const file = e.dataTransfer?.files?.[0];
                            if (file) {
                              try {
                                setIsImageLoading(true);
                                const imageUrl = await uploadImageToShopify(file);
                                if (imageUrl) {
                                  try {
                                    if (sidebarPreviewUrl) URL.revokeObjectURL(sidebarPreviewUrl);
                                  } catch (err) {}
                                  setSidebarPreviewUrl(imageUrl);
                                }
                                setIsImageModalOpen(false);
                              } catch (err) {
                                console.error(err);
                              } finally {
                                setIsImageLoading(false);
                              }
                            }
                          }}
                        >
                          {!isGenerateMode && (
                            <>
                              <input
                                id="modal-image-input"
                                type="file"
                                accept="image/*"
                                style={{ display: "none" }}
                                onChange={async (e) => {
                                  const file = e.target.files && e.target.files[0];
                                  if (!file) return;
                                  try {
                                    setIsImageLoading(true);
                                    const imageUrl = await uploadImageToShopify(file);
                                    if (imageUrl) {
                                      try {
                                        if (sidebarPreviewUrl) URL.revokeObjectURL(sidebarPreviewUrl);
                                      } catch (err) {}
                                      setSidebarPreviewUrl(imageUrl);
                                    }
                                    setIsImageModalOpen(false);
                                  } catch (err) {
                                    console.error(err);
                                  } finally {
                                    setIsImageLoading(false);
                                    e.target.value = null;
                                  }
                                }}
                              />
                              <div style={{ display: "flex", gap: "12px" }}>
                                <Button
                                  onClick={() =>
                                    document.getElementById("modal-image-input").click()
                                  }
                                  primary
                                >
                                  Add Files
                                </Button>
                                <Button
                                  onClick={() => {
                                    setIsGenerateMode(true);
                                  }}
                                >
                                  Generate Image
                                </Button>
                              </div>
                              <PolarisText
                                variant="bodyMd"
                                as="p"
                                style={{ marginTop: "8px", color: "#637381" }}
                              >
                                or drop an image to upload
                              </PolarisText>
                            </>
                          )}

                          {isGenerateMode && (
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "column",
                                gap: "8px",
                                alignItems: "stretch",
                              }}
                            >
                              <div style={{ display: "flex", gap: "8px" }}>
                                <input
                                  value={generatePrompt}
                                  onChange={(e) => setGeneratePrompt(e.target.value)}
                                  placeholder="Enter prompt to generate image"
                                  style={{
                                    flex: 1,
                                    padding: "8px",
                                    border: "1px solid #dfe3e8",
                                    borderRadius: "4px",
                                  }}
                                />
                                <Button
                                  primary
                                  onClick={async () => {
                                    if (!generatePrompt.trim()) return;
                                    setIsGeneratingImage(true);
                                    try {
                                      const token = document.querySelector("[name=csrfmiddlewaretoken]")?.value;
                                      const res = await axios.post(
                                        `/generate-image-ai/${shopOrigin}/`,
                                        { prompt: generatePrompt },
                                        {
                                          headers: {
                                            "Content-Type": "application/json",
                                            ...(token ? { "X-CSRFToken": token } : {}),
                                          },
                                          withCredentials: true,
                                        }
                                      );

                                      if (res.data && res.data.status === "success" && res.data.image_url) {
                                        // show preview from returned Shopify URL
                                        setGeneratedPreviewUrl(res.data.image_url);
                                      } else {
                                        showToast({ content: res.data?.message || "Failed to generate image", error: true });
                                      }
                                    } catch (err) {
                                      console.error("Generate image error:", err);
                                      showToast({ content: "Failed to generate image. Please try again.", error: true });
                                    } finally {
                                      setIsGeneratingImage(false);
                                    }
                                  }}
                                >
                                  Go
                                </Button>
                              </div>

                              <div style={{ minHeight: "160px" }}>
                                {isGeneratingImage && (
                                  <div style={{ textAlign: "center", paddingTop: 24 }}>
                                    <Spinner size="large" accessibilityLabel="Generating image" />
                                    <PolarisText as="p" style={{ marginTop: 8 }}>Generating preview…</PolarisText>
                                  </div>
                                )}

                                {generatedPreviewUrl && (
                                  <div style={{ textAlign: "center" }}>
                                    <img
                                      src={generatedPreviewUrl}
                                      alt="Generated preview"
                                      style={{ maxWidth: "100%", borderRadius: 6 }}
                                    />
                                    <div style={{ marginTop: 10, display: "flex", gap: 8, justifyContent: "center" }}>
                                      <Button
                                        primary
                                        onClick={async () => {
                                          try {
                                            setIsImageLoading(true);
                                            // If backend returned a remote Shopify URL, use it directly
                                            if (generatedPreviewUrl && !generatedPreviewUrl.startsWith("data:")) {
                                              try {
                                                if (sidebarPreviewUrl) URL.revokeObjectURL(sidebarPreviewUrl);
                                              } catch (e) {}
                                              setSidebarPreviewUrl(generatedPreviewUrl);
                                              // Optionally set alt text to prompt
                                              setSidebarAltText(generatePrompt || "");
                                              setIsImageModalOpen(false);
                                              setGeneratedPreviewUrl(null);
                                              setIsGenerateMode(false);
                                            } else if (generatedPreviewUrl) {
                                              // handle data: URLs (fallback)
                                              const res = await fetch(generatedPreviewUrl);
                                              const blob = await res.blob();
                                              try {
                                                if (sidebarPreviewUrl) URL.revokeObjectURL(sidebarPreviewUrl);
                                              } catch (e) {}
                                              const blobUrl = URL.createObjectURL(blob);
                                              setSidebarPreviewUrl(blobUrl);
                                              const file = new File([blob], "generated.png", { type: blob.type });
                                              await uploadImageToShopify(file);
                                              setIsImageModalOpen(false);
                                              setGeneratedPreviewUrl(null);
                                              setIsGenerateMode(false);
                                            }
                                          } catch (err) {
                                            console.error(err);
                                            showToast({ content: "Failed to use generated image", error: true });
                                          } finally {
                                            setIsImageLoading(false);
                                          }
                                        }}
                                      >
                                        Use Image
                                      </Button>
                                      <Button onClick={() => setGeneratedPreviewUrl(null)}>
                                        Cancel
                                      </Button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </Modal.Section>
                  </Modal>
                  <Modal
                    open={isAltModalOpen}
                    onClose={() => setIsAltModalOpen(false)}
                    title="Edit image alt text"
                    primaryAction={{
                      content: "Save",
                      onAction: () => {
                        setIsAltModalOpen(false);
                      },
                    }}
                    secondaryActions={[
                      {
                        content: "Cancel",
                        onAction: () => setIsAltModalOpen(false),
                      },
                    ]}
                  >
                    <Modal.Section>
                      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                        {sidebarPreviewUrl && (
                          <div style={{ textAlign: "center" }}>
                            <img src={sidebarPreviewUrl} alt={sidebarAltText || "Preview"} style={{ maxWidth: "100%", borderRadius: 6 }} />
                          </div>
                        )}
                        <div>
                          <PolarisText variant="bodyMd" as="p" style={{ marginBottom: 6 }}>
                            Alt Text
                          </PolarisText>
                          <input
                            value={sidebarAltText}
                            onChange={(e) => setSidebarAltText(e.target.value)}
                            placeholder="Describe this image"
                            style={{ width: "100%", padding: 8, border: "1px solid #dfe3e8", borderRadius: 4 }}
                          />
                          <PolarisText variant="caption" as="p" style={{ marginTop: 6, color: "#637381" }}>
                            Write a brief description of the file for people with visual impairment or low-bandwidth connections.
                          </PolarisText>
                        </div>
                      </div>
                    </Modal.Section>
                  </Modal>
                </div>
                <div className="Polaris-Layout__Section Polaris-Layout__Section--oneThird oneFourth">
                  <Card padding="400">
                    <PolarisText variant="headingSm" as="h2">
                      Categories
                    </PolarisText>
                    <select
                      className="custom-select1"
                      value={selectedBlogId}
                      style={{ backgroundColor: "transparent" }}
                      onChange={(e) => handleBlogChange(e.target.value)}
                      onClick={() => shopify.saveBar.show("my-save-bar")}
                    >
                      <optgroup label="Blogs">
                        {blogs.length > 0 ? (
                          blogs.map((blog) => (
                            <option
                              key={blog.node?.id || blog.id}
                              value={blog.node?.id || blog.id}
                              data-handle={blog.node?.handle || blog.handle}
                            >
                              {blog.node?.title || blog.title}
                            </option>
                          ))
                        ) : (
                          <option value="">No blogs available</option>
                        )}
                      </optgroup>
                      <optgroup label="Actions">
                        <option value="new">Create a new Blog</option>
                      </optgroup>
                    </select>
                    {showNewBlogInput && (
                      <div style={{ marginTop: "10px" }}>
                        <TextField
                          id="new-blog-title"
                          label=""
                          placeholder="Enter new blog title"
                          value={newBlogTitle}
                          onChange={setNewBlogTitle}
                        />
                      </div>
                    )}
                    <PolarisText
                      variant="headingSm"
                      as="h2"
                      style={{ marginTop: "20px" }}
                    >
                      Tags
                    </PolarisText>
                    <LegacyStack spacing="tight">
                      {tags.length === 0 ? (
                        <Tag>No tags</Tag>
                      ) : (
                        tags.map((tag) => (
                          <div
                            onClick={() => shopify.saveBar.show("my-save-bar")}
                          >
                            <Tag key={tag} onRemove={() => removeTag(tag)}>
                              {tag}
                            </Tag>
                          </div>
                        ))
                      )}
                    </LegacyStack>
                    <div style={{ marginTop: "10px", marginBottom: "10px" }}>
                      <Button
                        plain
                        onClick={() => setShowTagInput(true)}
                        className="custom-add-tag-button"
                      >
                        + Add tag
                      </Button>
                    </div>
                    {showTagInput && (
                      <div style={{ marginTop: "10px", marginBottom: "16px" }}>
                        <input
                          className="tag-input"
                          value={tagInput}
                          onChange={(e) => setTagInput(e.target.value)}
                          onFocus={() => shopify.saveBar.show("my-save-bar")}
                          onKeyDown={addTag}
                          placeholder="Enter tag"
                          autoFocus
                        />
                      </div>
                    )}
                    <PolarisText
                      variant="headingSm"
                      as="h2"
                      style={{ marginTop: "20px" }}
                    >
                      Schedule
                    </PolarisText>
                    <LegacyStack distribution="equalSpacing" alignment="center">
                      <PolarisText variant="bodyMd">Publish Now</PolarisText>
                      <LegacyStack
                        distribution="equalSpacing"
                        alignment="center"
                      >
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            cursor: "pointer",
                            gap: "5px",
                          }}
                          onClick={() => shopify.saveBar.show("my-save-bar")}
                        >
                          <div
                            style={{
                              position: "relative",
                              width: "40px",
                              height: "20px",
                              backgroundColor: isPublished
                                ? "#008060"
                                : "#dfe3e8",
                              borderRadius: "10px",
                              transition: "background-color 0.3s",
                            }}
                            onClick={() => setIsPublished(!isPublished)}
                          >
                            <div
                              style={{
                                position: "absolute",
                                width: "16px",
                                height: "16px",
                                backgroundColor: "#ffffff",
                                borderRadius: "50%",
                                top: "2px",
                                left: isPublished ? "22px" : "2px",
                                transition: "left 0.3s",
                                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
                              }}
                            />
                          </div>
                          {/* <div
                            style={{ cursor: "pointer" }}
                            onClick={() => setIsDateModalOpen(true)}
                          >
                            <Icon source={EditIcon} tone="base" />
                          </div> */}
                        </div>
                      </LegacyStack>
                    </LegacyStack>
                    {formattedScheduledTime && !isPublished && (
                      <PolarisText
                        variant="bodyMd"
                        as="p"
                        style={{ marginTop: "10px" }}
                      >
                        Scheduled for: {formattedScheduledTime}
                      </PolarisText>
                    )}
                  </Card>
                  <div  style={{marginTop: "15px"}}>
                    <Card padding="400">
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <PolarisText variant="headingSm" as="h2">
                          Image
                        </PolarisText>
                        {sidebarPreviewUrl ? (
                          <Popover
                            active={imagePopoverActive}
                            activator={
                              <Button variant="plain" onClick={toggleImagePopover} ariaExpanded={imagePopoverActive} ariaHaspopup>
                                Edit
                              </Button>
                            }
                            onClose={() => setImagePopoverActive(false)}
                          >
                            <ActionList
                              items={[
                                {
                                  content: "Change image",
                                  onAction: () => {
                                    setIsImageModalOpen(true);
                                    setImagePopoverActive(false);
                                  },
                                },
                                {
                                  content: "Edit Alt Text",
                                  onAction: () => {
                                    setIsAltModalOpen(true);
                                    setImagePopoverActive(false);
                                  },
                                },
                                {
                                  content: "Remove Image",
                                  onAction: () => {
                                    try {
                                      if (sidebarPreviewUrl) URL.revokeObjectURL(sidebarPreviewUrl);
                                    } catch (err) {}
                                    setSidebarPreviewUrl(null);
                                    setSidebarAltText("");
                                    setImagePopoverActive(false);
                                  },
                                  destructive: true,
                                },
                              ]}
                            />
                          </Popover>
                        ) : null}
                      </div>
                      <div
                        style={{
                          border: "1px dashed #dfe3e8",
                          borderRadius: "8px",
                          padding: "18px",
                          marginTop: "12px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          minHeight: "120px",
                          background: "#fff",
                          position: "relative",
                        }}
                        onDragOver={(e) => {
                          e.preventDefault();
                          setIsSidebarDragging(true);
                        }}
                        onDragLeave={() => setIsSidebarDragging(false)}
                        onDrop={async (e) => {
                          e.preventDefault();
                          setIsSidebarDragging(false);
                          const file = e.dataTransfer?.files?.[0];
                          if (file) {
                            try {
                              setIsImageLoading(true);
                              const imageUrl = await uploadImageToShopify(file);
                              if (imageUrl) {
                                try {
                                  if (sidebarPreviewUrl) URL.revokeObjectURL(sidebarPreviewUrl);
                                } catch (err) {}
                                setSidebarPreviewUrl(imageUrl);
                              }
                            } catch (err) {
                              console.error(err);
                            } finally {
                              setIsImageLoading(false);
                            }
                          }
                        }}
                      >
                        <input
                          id="sidebar-image-input"
                          type="file"
                          accept="image/*"
                          style={{ display: "none" }}
                          onChange={async (e) => {
                            const file = e.target.files && e.target.files[0];
                            if (!file) return;
                            try {
                              setIsImageLoading(true);
                              const imageUrl = await uploadImageToShopify(file);
                              if (imageUrl) {
                                try {
                                  if (sidebarPreviewUrl) URL.revokeObjectURL(sidebarPreviewUrl);
                                } catch (err) {}
                                setSidebarPreviewUrl(imageUrl);
                              }
                            } catch (err) {
                              console.error(err);
                            } finally {
                              setIsImageLoading(false);
                              e.target.value = null;
                            }
                          }}
                        />
                        <div style={{ textAlign: "center", width: "100%" }}>
                          {/* Show drag hint when dragging over */}
                          {isSidebarDragging && !sidebarPreviewUrl ? (
                            <PolarisText variant="bodyMd" as="p" style={{ color: "#637381", fontWeight: 600 }}>
                              Drop Image to Upload
                            </PolarisText>
                          ) : (
                            !sidebarPreviewUrl && (
                              <>
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                  <Button onClick={() => setIsImageModalOpen(true)} primary>
                                    Add image
                                  </Button>
                                </div>
                                <PolarisText
                                  variant="bodyMd"
                                  as="p"
                                  style={{ marginTop: "8px", color: "#637381" }}
                                >
                                  or drop an image to upload
                                </PolarisText>
                              </>
                            )
                          )}

                          {/* When preview exists show image and edit link */}
                          {sidebarPreviewUrl && (
                            <div style={{ marginTop: 12, position: "relative" }}>
                              <div style={{ position: "absolute", left: 8, top: 8, zIndex: 5 }}>
                                <div style={{ position: "relative" }}>
                                  
                                  {showEditOptions && false && (
                                    <div style={{ position: "absolute", left: 0, top: 18, background: "#fff", border: "1px solid #e1e5e9", borderRadius: 4, boxShadow: "0 4px 8px rgba(0,0,0,0.08)", padding: 6 }}>
                                      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                                        <button
                                          className="Polaris-Button Polaris-Button--plain"
                                          style={{ background: "none", border: "none", padding: "6px 10px", textAlign: "left", cursor: "pointer" }}
                                          onClick={() => {
                                            setIsImageModalOpen(true);
                                            setShowEditOptions(false);
                                          }}
                                        >
                                          Change image
                                        </button>
                                        <button
                                          className="Polaris-Button Polaris-Button--plain"
                                          style={{ background: "none", border: "none", padding: "6px 10px", textAlign: "left", cursor: "pointer" }}
                                          onClick={() => {
                                            setIsAltModalOpen(true);
                                            setShowEditOptions(false);
                                          }}
                                        >
                                          Edit Alt Text
                                        </button>
                                        <button
                                          className="Polaris-Button Polaris-Button--plain"
                                          style={{ background: "none", border: "none", padding: "6px 10px", textAlign: "left", cursor: "pointer", color: "#bf0711" }}
                                          onClick={() => {
                                            try {
                                              if (sidebarPreviewUrl) URL.revokeObjectURL(sidebarPreviewUrl);
                                            } catch (err) {}
                                            setSidebarPreviewUrl(null);
                                            setSidebarAltText("");
                                            setShowEditOptions(false);
                                          }}
                                        >
                                          Remove Image
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>

                              <img
                                src={sidebarPreviewUrl}
                                alt={sidebarAltText || "Preview"}
                                style={{ maxWidth: "100%", maxHeight: 180, borderRadius: 6 }}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </Card>
                  </div>
                  <div style={{ marginTop: "15px" }}>
                    <Card padding="400">
                      <PolarisText variant="headingSm" as="h2">
                        Search engine listing
                      </PolarisText>
                      {/* Google-style preview */}
                      <div
                        style={{
                          marginTop: "12px",
                          marginBottom: "16px",
                          padding: "12px",
                          border: "1px solid #e1e5e9",
                          borderRadius: "6px",
                          background: "#fafafa",
                        }}
                      >
                        {/* Breadcrumb-style URL */}
                        <div style={{ fontSize: "12px", color: "#202124", marginBottom: "3px", display: "flex", alignItems: "center", flexWrap: "wrap", gap: "2px" }}>
                          <span>{shopOrigin ? shopOrigin.replace(/^https?:\/\//, "") : "your-store.myshopify.com"}</span>
                          <span style={{ color: "#5f6368", margin: "0 2px" }}>›</span>
                          <span style={{ color: "#5f6368" }}>blogs</span>
                          <span style={{ color: "#5f6368", margin: "0 2px" }}>›</span>
                          <span style={{ color: "#5f6368" }}>{blogHandle || "your-blog"}</span>
                          <span style={{ color: "#5f6368", margin: "0 2px" }}>›</span>
                          <span style={{ color: "#5f6368" }}>{urlHandle || "article-handle"}</span>
                        </div>
                        <div style={{ fontSize: "16px", color: "#1a0dab", fontWeight: 500, marginBottom: "2px", lineHeight: "1.3" }}>
                          {seoTitle || "Add a page title"}
                        </div>
                        <div style={{ fontSize: "13px", color: "#4d5156", lineHeight: "1.4" }}>
                          {seoDescription || ""}
                        </div>
                      </div>
                      {/* Page title */}
                      <div style={{ marginBottom: "12px" }}>
                        <PolarisText variant="bodyMd" as="p" fontWeight="medium">
                          Page title
                        </PolarisText>
                        <div style={{ marginTop: "6px" }}>
                          <input
                            value={seoTitle}
                            maxLength={70}
                            onChange={(e) => {
                              setSeoTitle(e.target.value);
                              shopify.saveBar.show("my-save-bar");
                            }}
                            placeholder="Add a page title"
                            style={{
                              width: "100%",
                              padding: "8px 10px",
                              border: "1px solid #dfe3e8",
                              borderRadius: "4px",
                              fontSize: "14px",
                              boxSizing: "border-box",
                            }}
                          />
                        </div>
                        <PolarisText variant="caption" as="p" tone="subdued" style={{ marginTop: "4px" }}>
                          {seoTitle.length} of 70 characters used
                        </PolarisText>
                      </div>
                      {/* Meta description */}
                      <div style={{ marginBottom: "12px" }}>
                        <PolarisText variant="bodyMd" as="p" fontWeight="medium">
                          Meta description
                        </PolarisText>
                        <div style={{ marginTop: "6px" }}>
                          <textarea
                            value={seoDescription}
                            maxLength={160}
                            rows={3}
                            onChange={(e) => {
                              setSeoDescription(e.target.value);
                              shopify.saveBar.show("my-save-bar");
                            }}
                            placeholder="Add a meta description"
                            style={{
                              width: "100%",
                              padding: "8px 10px",
                              border: "1px solid #dfe3e8",
                              borderRadius: "4px",
                              fontSize: "14px",
                              resize: "vertical",
                              boxSizing: "border-box",
                            }}
                          />
                        </div>
                        <PolarisText variant="caption" as="p" tone="subdued" style={{ marginTop: "4px" }}>
                          {seoDescription.length} of 160 characters used
                        </PolarisText>
                      </div>
                      {/* URL handle */}
                      <div>
                        <PolarisText variant="bodyMd" as="p" fontWeight="medium">
                          URL handle
                        </PolarisText>
                        <div
                          style={{
                            marginTop: "6px",
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #dfe3e8",
                            borderRadius: "4px",
                            overflow: "hidden",
                          }}
                        >
                          <span
                            style={{
                              padding: "8px 10px",
                              background: "#f6f6f7",
                              color: "#637381",
                              fontSize: "14px",
                              whiteSpace: "nowrap",
                              borderRight: "1px solid #dfe3e8",
                            }}
                          >
                            {`blogs/${blogHandle || "your-blog"}/`}
                          </span>
                          <input
                            value={urlHandle}
                            onChange={(e) => {
                              setUrlHandle(e.target.value);
                              shopify.saveBar.show("my-save-bar");
                            }}
                            placeholder="article-handle"
                            style={{
                              flex: 1,
                              padding: "8px 10px",
                              border: "none",
                              outline: "none",
                              fontSize: "14px",
                            }}
                          />
                        </div>
                        <PolarisText variant="caption" as="p" tone="subdued" style={{ marginTop: "4px" }}>
                          {shopOrigin
                            ? `https://${shopOrigin}/blogs/${blogHandle || "your-blog"}/${urlHandle || "article-handle"}`
                            : `https://your-store.myshopify.com/blogs/${blogHandle || "your-blog"}/${urlHandle || "article-handle"}`}
                        </PolarisText>
                      </div>
                    </Card>
                  </div>
                </div>
              </div>
            </div>
            {/* <Modal
              open={modalActive}
              onClose={() => setModalActive(false)}
              title={extractTitle()}
            >
              <div ref={modalRef}>
                <Modal.Section>
                  <div dangerouslySetInnerHTML={{ __html: extractBody() }} />
                </Modal.Section>
              </div>
            </Modal> */}
            <ArticleModal
              open={modalActive}
              onClose={() => setModalActive(false)}
              article={{
                article_title: extractTitle(),
                article_body: extractBody(),
              }}
            />
            <CloseModal
              open={isCloseModalOpen}
              onClose={() => setIsCloseModalOpen(false)}
              shopOrigin={shopOrigin}
            />
            <Modal
              open={isDateModalOpen}
              onClose={() => setIsDateModalOpen(false)}
              title="Set visibility date"
            >
              <Modal.Section>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                  }}
                >
                  {/* <PolarisText as="p" variant="bodyMd">
                    Schedule blog post to be published on this date and time (in{" "}
                    {shopTimezone}):
                  </PolarisText> */}
                  <div
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "16px",
                    }}
                  >
                    {new Date(year, month).toLocaleString("en-US", {
                      month: "long",
                    })}
                  </div>
                  <DatePicker
                    month={month}
                    year={year}
                    onChange={setSelectedDates}
                    onMonthChange={(m, y) => setDate({ month: m, year: y })}
                    selected={selectedDates}
                  />
                  <div
                    style={{
                      display: "flex",
                      gap: "12px",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <div style={{ width: "100%" }}>
                      <TextField
                        label="Time"
                        type="time"
                        value={scheduledTime}
                        onChange={setScheduledTime}
                      />
                    </div>
                  </div>
                </div>
              </Modal.Section>

              {/* Adjusting action buttons to be in a row */}
              <Modal.Section>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Button onClick={() => setIsDateModalOpen(false)}>
                    {"Cancel"}
                  </Button>
                  <Button variant="primary" onClick={handleSetVisibilityDate}>
                    {"Set visibility date"}
                  </Button>
                </div>
              </Modal.Section>
            </Modal>

            <Modal
              open={isResizeModalOpen}
              onClose={() => setIsResizeModalOpen(false)}
              title="Resize and Style Image"
              primaryAction={{
                content: "Apply",
                onAction: handleImageResize,
              }}
              secondaryActions={[
                {
                  content: "Cancel",
                  onAction: () => setIsResizeModalOpen(false),
                },
              ]}
            >
              <Modal.Section>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <img
                      src={resizeImageUrl}
                      alt="Preview"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "200px",
                        objectFit: objectFit,
                        objectPosition: objectPosition,
                        margin:
                          imageAlignment === "center"
                            ? "0 auto"
                            : imageAlignment === "left"
                            ? "0 auto 0 0"
                            : "0 0 0 auto",
                      }}
                    />
                  </div>

                  <select
                    value={
                      imageWidth === `${naturalWidth}px` &&
                      imageHeight === `${naturalHeight}px`
                        ? "original"
                        : imageWidth === "100%"
                        ? "100%"
                        : imageWidth.replace("px", "")
                    }
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "original") {
                        setImageWidth(`${naturalWidth}px`);
                        setImageHeight(`${naturalHeight}px`);
                      } else if (value === "100%") {
                        setImageWidth("100%");
                        setImageHeight("auto");
                      } else {
                        const numericValue = parseInt(value);
                        setImageWidth(`${numericValue}px`);
                        if (naturalWidth && naturalHeight) {
                          setImageHeight(
                            `${Math.round(
                              (numericValue / naturalWidth) * naturalHeight
                            )}px`
                          );
                        } else {
                          setImageHeight("auto");
                        }
                      }
                    }}
                    style={{
                      padding: "8px",
                      border: "1px solid #dfe3e8",
                      borderRadius: "4px",
                      fontSize: "14px",
                      width: "100%",
                    }}
                  >
                    {imageSizeOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>

                  <TextField
                    label="Width"
                    type="text"
                    value={
                      imageWidth && imageWidth !== "auto"
                        ? imageWidth.replace(/px|%$/, "")
                        : ""
                    }
                    onChange={(value) => {
                      if (value === "") {
                        setImageWidth("");
                      } else if (
                        value.endsWith("%") &&
                        !isNaN(parseInt(value))
                      ) {
                        setImageWidth(value);
                      } else if (!isNaN(parseInt(value))) {
                        setImageWidth(`${parseInt(value)}px`);
                      }
                    }}
                    placeholder="Enter width in pixels or %"
                    autoComplete="off"
                    suffix={imageWidth.endsWith("%") ? "%" : "px"}
                  />

                  <TextField
                    label="Height"
                    type="text"
                    value={
                      imageHeight === "auto"
                        ? ""
                        : imageHeight.replace("px", "")
                    }
                    onChange={(value) => {
                      if (value === "" || value === "auto") {
                        setImageHeight("auto");
                      } else if (!isNaN(parseInt(value))) {
                        setImageHeight(`${parseInt(value)}px`);
                      }
                    }}
                    placeholder="Enter height in pixels or 'auto'"
                    autoComplete="off"
                    suffix={imageHeight === "auto" ? "" : "px"}
                  />
                  <div>
                    <PolarisText variant="headingSm" as="h3">
                      Alignment
                    </PolarisText>
                    <ButtonGroup>
                      <Button
                        pressed={imageAlignment === "left"}
                        onClick={() => setImageAlignment("left")}
                        icon={<Icon source={TextAlignLeftIcon} />}
                      >
                        Left
                      </Button>
                      <Button
                        pressed={imageAlignment === "center"}
                        onClick={() => setImageAlignment("center")}
                        icon={<Icon source={TextAlignCenterIcon} />}
                      >
                        Center
                      </Button>
                      <Button
                        pressed={imageAlignment === "right"}
                        onClick={() => setImageAlignment("right")}
                        icon={<Icon source={TextAlignRightIcon} />}
                      >
                        Right
                      </Button>
                    </ButtonGroup>
                  </div>
                  <div>
                    <PolarisText variant="headingSm" as="h3">
                      Object Fit
                    </PolarisText>
                    <select
                      value={objectFit}
                      onChange={(e) => setObjectFit(e.target.value)}
                      style={{
                        padding: "8px",
                        border: "1px solid #dfe3e8",
                        borderRadius: "4px",
                        fontSize: "14px",
                        width: "100%",
                      }}
                    >
                      <option value="contain">Contain</option>
                      <option value="cover">Cover</option>
                      <option value="fill">Fill</option>
                      <option value="none">None</option>
                      <option value="scale-down">Scale-down</option>
                    </select>
                  </div>
                  <div>
                    <PolarisText variant="headingSm" as="h3">
                      Object Position
                    </PolarisText>
                    <select
                      value={objectPosition}
                      onChange={(e) => setObjectPosition(e.target.value)}
                      style={{
                        padding: "8px",
                        border: "1px solid #dfe3e8",
                        borderRadius: "4px",
                        fontSize: "14px",
                        width: "100%",
                      }}
                    >
                      <option value="top">Top</option>
                      <option value="bottom">Bottom</option>
                      <option value="left">Left</option>
                      <option value="right">Right</option>
                      <option value="center">Center</option>
                    </select>
                  </div>
                </div>
              </Modal.Section>
            </Modal>
            <Modal
              open={isResizeTextModalOpen}
              onClose={() => setIsResizeTextModalOpen(false)}
              title="Resize and Style Image and Text"
              primaryAction={{
                content: "Apply",
                onAction: handleImageTextResize,
              }}
              secondaryActions={[
                {
                  content: "Cancel",
                  onAction: () => setIsResizeTextModalOpen(false),
                },
              ]}
            >
              <Modal.Section>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <img
                      src={resizeImageUrl}
                      alt="Preview"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "200px",
                        objectFit: objectFit,
                        objectPosition: objectPosition,
                        margin:
                          imageAlignment === "center"
                            ? "0 auto"
                            : imageAlignment === "left"
                            ? "0 auto 0 0"
                            : "0 0 0 auto",
                      }}
                    />
                  </div>
                  <select
                    value={
                      imageWidth === `${naturalWidth}px` &&
                      imageHeight === `${naturalHeight}px`
                        ? "original"
                        : imageWidth === "100%"
                        ? "100%"
                        : imageWidth.replace("px", "")
                    }
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "original") {
                        setImageWidth(`${naturalWidth}px`);
                        setImageHeight(`${naturalHeight}px`);
                      } else if (value === "100%") {
                        setImageWidth("100%");
                        setImageHeight("auto");
                      } else {
                        const numericValue = parseInt(value);
                        setImageWidth(`${numericValue}px`);
                        if (naturalWidth && naturalHeight) {
                          setImageHeight(
                            `${Math.round(
                              (numericValue / naturalWidth) * naturalHeight
                            )}px`
                          );
                        } else {
                          setImageHeight("auto");
                        }
                      }
                    }}
                    style={{
                      padding: "8px",
                      border: "1px solid #dfe3e8",
                      borderRadius: "4px",
                      fontSize: "14px",
                      width: "100%",
                    }}
                  >
                    {imageSizeOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <TextField
                    label="Width"
                    type="text"
                    value={
                      imageWidth && imageWidth !== "auto"
                        ? imageWidth.replace(/px|%$/, "")
                        : ""
                    }
                    onChange={(value) => {
                      if (value === "") {
                        setImageWidth("");
                      } else if (
                        value.endsWith("%") &&
                        !isNaN(parseInt(value))
                      ) {
                        setImageWidth(value);
                      } else if (!isNaN(parseInt(value))) {
                        setImageWidth(`${parseInt(value)}px`);
                      }
                    }}
                    placeholder="Enter width in pixels or %"
                    autoComplete="off"
                    suffix={imageWidth.endsWith("%") ? "%" : "px"}
                  />
                  <TextField
                    label="Height"
                    type="text"
                    value={
                      imageHeight === "auto"
                        ? ""
                        : imageHeight.replace("px", "")
                    }
                    onChange={(value) => {
                      if (value === "" || value === "auto") {
                        setImageHeight("auto");
                      } else if (!isNaN(parseInt(value))) {
                        setImageHeight(`${parseInt(value)}px`);
                      }
                    }}
                    placeholder="Enter height in pixels or 'auto'"
                    autoComplete="off"
                    suffix={imageHeight === "auto" ? "" : "px"}
                  />
                  <div>
                    <PolarisText variant="headingSm" as="h3">
                      Alignment
                    </PolarisText>
                    <ButtonGroup>
                      <Button
                        pressed={imageAlignment === "left"}
                        onClick={() => setImageAlignment("left")}
                        icon={<Icon source={TextAlignLeftIcon} />}
                      >
                        Left
                      </Button>
                      <Button
                        pressed={imageAlignment === "center"}
                        onClick={() => setImageAlignment("center")}
                        icon={<Icon source={TextAlignCenterIcon} />}
                      >
                        Center
                      </Button>
                      <Button
                        pressed={imageAlignment === "right"}
                        onClick={() => setImageAlignment("right")}
                        icon={<Icon source={TextAlignRightIcon} />}
                      >
                        Right
                      </Button>
                    </ButtonGroup>
                  </div>

                  <div>
                    <PolarisText variant="headingSm" as="h3">
                      Vertical Alignment
                    </PolarisText>
                    <ButtonGroup>
                      <Button
                        pressed={verticalAlign === "top"}
                        onClick={() => setVerticalAlign("top")}
                        icon={<Icon source={ChevronUpIcon} />}
                      >
                        Top
                      </Button>
                      <Button
                        pressed={verticalAlign === "center"}
                        onClick={() => setVerticalAlign("center")}
                        icon={<Icon source={TextAlignCenterIcon} />}
                      >
                        Middle
                      </Button>
                      <Button
                        pressed={verticalAlign === "bottom"}
                        onClick={() => setVerticalAlign("bottom")}
                        icon={<Icon source={ChevronDownIcon} />}
                      >
                        Bottom
                      </Button>
                    </ButtonGroup>
                  </div>
                  <div>
                    <PolarisText variant="headingSm" as="h3">
                      Object Fit
                    </PolarisText>
                    <select
                      value={objectFit}
                      onChange={(e) => setObjectFit(e.target.value)}
                      style={{
                        padding: "8px",
                        border: "1px solid #dfe3e8",
                        borderRadius: "4px",
                        fontSize: "14px",
                        width: "100%",
                      }}
                    >
                      <option value="contain">Contain</option>
                      <option value="cover">Cover</option>
                      <option value="fill">Fill</option>
                      <option value="none">None</option>
                      <option value="scale-down">Scale-down</option>
                    </select>
                  </div>
                  <div>
                    <PolarisText variant="headingSm" as="h3">
                      Object Position
                    </PolarisText>
                    <select
                      value={objectPosition}
                      onChange={(e) => setObjectPosition(e.target.value)}
                      style={{
                        padding: "8px",
                        border: "1px solid #dfe3e8",
                        borderRadius: "4px",
                        fontSize: "14px",
                        width: "100%",
                      }}
                    >
                      <option value="top">Top</option>
                      <option value="bottom">Bottom</option>
                      <option value="left">Left</option>
                      <option value="right">Right</option>
                      <option value="center">Center</option>
                    </select>
                  </div>
                </div>
              </Modal.Section>
            </Modal>
          </Page>
        </>
      )}
    </>
  );
};

export default EditBlogs;
